{
  "1_HOUR_AGO": "1 hour ago",
  "1_MINUTE_AGO": "1 minute ago",
  "A": "A",
  "AA": "AA",
  "ABOUT": "About",
  "ABOUT_AGENCY": "About the agency",
  "ABOUT_COMPANY": "About the company",
  "ABOUT_COMPANY_LABEL_2": "What do you do differently as a company, compared with competitors?",
  "ABOUT_RECRUITER": "About the agency user",
  "ABOUT_YOURSELF": "Profile description (about yourself)",
  "ABOUT_YOUR_COMPANY": "About your company",
  "ACCEPT": "Accept",
  "ACCEPTED_ON": "Accepted on",
  "ACCEPT_AND_CONTINUE": "Accept and Continue",
  "ACCEPT_INVITE": "Accept Invite",
  "ACCEPT_OFFER": "Accept offer",
  "ACCORDING_TO_CONTRACT": "According to contract",
  "ACTIONS": "Actions",
  "ACTION_REQUIRED": "⚠️ Action Required",
  "ACTIVE": "Active",
  "ACTIVE_INTERVIEW": "Active interview processes",
  "ACTIVITY": "Activity",
  "ADD": "Add",
  "ADDED_TO_LIST": "✓ Added to list:",
  "ADDED_TO_LIST_BULK": "{{count}} agency(s) added to list",
  "ADDED_TO_NEW_LIST": "Added {{count}} agencies to the new list",
  "ADDITIONAL_INFO": "Additional info",
  "ADD_AGENCY": "Add Agency",
  "ADD_AGENCY_FAILED": "Failed to add agency",
  "ADD_AGENCY_START_FAILED": "Failed to start add agency process",
  "ADD_AGENCY_SUCCESS": "Agency added",
  "ADD_ANOTHER": "Add another",
  "ADD_ANOTHER_PERSON": "Add another person",
  "ADD_BRACKET": "Add bracket",
  "ADD_CLIENT": "Add Company",
  "ADD_COMPANY_DEFAULTS_HINT": "Add company default questions in the Company Settings to make them available on all jobs.",
  "ADD_FROM_COMPANY_DEFAULTS_DESC": "You can add questions that are predefined for your company.",
  "ADD_FROM_COMPANY_DEFAULTS_TITLE": "Add from Company Questions",
  "ADD_JOB": "Add job",
  "ADD_LOCATION_TITLE": "Add Location",
  "ADD_NEW_CUSTOM_FIELD": "Add new custom field",
  "ADD_NEW_DEFAULT_FIELD": "Add new",
  "ADD_POSITION": "Add position",
  "ADD_QUOTE": "Add quote",
  "ADD_RECRUITER": "Add agency user",
  "ADD_ROLE": "Add role",
  "ADD_SCREENING_QUESTION": "Add Screening Question",
  "ADD_TAG": "Add tag",
  "ADD_TO_LIST": "Add to List",
  "ADD_TO_LIST_FAILED": "Failed to add agencies to list",
  "ADD_TO_LIST_SELECTED_HINT": "Selected agencies (<b>{{count}}</b>) will be added to the selected list.",
  "ADD_USER_TITLE": "Add User",
  "ADMIN": "Admin",
  "ADMIN_BULK_UPLOAD_NOT_AVAILABLE": "Bulk upload is not available in admin view. Add candidates using the form below and select a recruiter company first.",
  "AGENCY_ADMIN_ROLE_DESC": "Can decide on permissions and visibility, including inviting others",
  "AGENCY_MEMBER_ROLE_DESC": "Can view and submit candidates, and work on roles when the entire agency is assigned by the customer",
  "ADOPTION_METRICS_COLUMN_AGENCIES_ACCEPTED": "Active Agencies (accepted agreement)",
  "ADOPTION_METRICS_COLUMN_AGENCIES_NOT_ACCEPTED": "Active Agencies (no accepted agreement)",
  "ADOPTION_METRICS_COLUMN_ATS": "ATS",
  "ADOPTION_METRICS_COLUMN_CLIENT_COMPANY": "Client Company",
  "ADOPTION_METRICS_COLUMN_PUBLISHED_JOBS_WITH_SUPPLIERS": "Published Jobs with Agencies",
  "ADOPTION_METRICS_ONLY_WITH_ATS": "Only companies with an ATS",
  "ADOPTION_METRICS_SEARCH_PLACEHOLDER": "Search by company name",
  "ADOPTION_METRICS_TABLE_TITLE": "Adoption metrics per client company",
  "AFFECTED_COMPANIES_MESSAGE": "This candidate has been introduced to the following companies",
  "AFTER_CANDIDATE_START_DATE": "After candidate start date",
  "AFTER_SIGNING_CONTRACT": "After signing contract",
  "AGENCIES": "Agencies",
  "AGENCIES_ASSIGNMENT_UPDATED": "Agency assignment updated successfully",
  "AGENCIES_CAN_MANAGE_PROJECTS": "Allow agencies to manage project members",
  "AGENCIES_CAN_MANAGE_PROJECTS_DESC": "Let agency admins invite colleagues and manage membership of their own agency company (project). When disabled, only your team can manage agency company membership.",
  "AGENCIES_REMOVED": "{{count}} agency agreement(s) removed",
  "AGENCY": "Agency",
  "AGENCY_ANALYTICS": "Agency Analytics",
  "AGENCY_ASSIGNMENTS": "Agency assignments",
  "AGENCY_ASSIGNMENT_WARNING_DESCRIPTION": "The selected agencies will be notified by email and will need to accept the new contract. Until they accept, they won't be able to see jobs or introduce new candidates under this contract.",
  "AGENCY_ASSIGNMENT_WARNING_TITLE": "New agencies will need to accept this contract",
  "AGENCY_CANDIDATES": "Agency Candidates",
  "AGENCY_CHAT": "Agency chat",
  "AGENCY_CHAT_CONTEXT": "About <candidateLink>{{candidate}}</candidateLink> · <jobLink>{{job}}</jobLink>",
  "AGENCY_CONTRACTS": "Agency Contracts",
  "AGENCY_CONTRACT_TAB_LISTS": "Agency lists",
  "AGENCY_EMAIL_PLACEHOLDER": "email@agency.com",
  "AGENCY_FINANCIALS": "Agency Financials",
  "AGENCY_HIRING_OVERVIEW": "Agency Hiring Overview",
  "AGENCY_INBOX": "Agency inbox",
  "AGENCY_JOBS": "Agency Jobs",
  "AGENCY_LISTING_CLEAR_SEARCH_FILTERS": "Clear search and filters",
  "AGENCY_LISTING_EMPTY_NO_AGENCIES": "No agencies yet. Invite your first agency or upload a list to get started.",
  "AGENCY_LISTING_EMPTY_NO_MATCH": "No matching agencies. Try adjusting your search or filters to see more results.",
  "AGENCY_LISTS": "Agency Lists",
  "AGENCY_LISTS_TOOLTIP": "Filter agencies by list membership.",
  "AGENCY_MANAGEMENT": "Agency Management",
  "AGENCY_NAME_PLACEHOLDER": "Filter by agency name",
  "AGENCY_OWNED": "Agency-owned",
  "AGENCY_PORTAL": "Agency Portal",
  "AGENCY_PORTAL_SETTINGS": "Agency Portal Settings",
  "AGENCY_RATING_NONE_SHORT": "No rating",
  "AGENCY_RATING_NONE_TOOLTIP": "No rating yet",
  "AGENCY_RATING_TOOLTIP": "overall rating",
  "AGENCY_USER": "Agency User",
  "AGGREGATE_BY_COMPANY": "Group by agency",
  "AGREE": "I confirm the above",
  "AGREEMENT_FEE_DETAILS": "Agreement Fee Details",
  "AGREEMENT_FEE_DETAILS_PLACEHOLDER": "Fee bracket details from the agreement",
  "AGREEMENT_STATUS_ACCEPTED": "Accepted",
  "AGREEMENT_STATUS_DECLINED": "Declined",
  "AGREEMENT_STATUS_NONE": "None",
  "AGREEMENT_STATUS_PENDING": "Pending",
  "AI": "AI",
  "ALL": "All",
  "ALL_CANDIDATES": "All candidates",
  "ALL_CURRENCIES": "All currencies",
  "ALL_JOBS_FILTER_TITLE": "All jobs",
  "ALL_TAGS": "All Tags (Include Fee)",
  "ALL_WORKSPACES": "All workspaces",
  "ALREADY_APPLIED": "Candidate was already applied to this job previously.",
  "ALT_IN_PROGRESS": "In progress",
  "ALWAYS_PRIVATE": "Always Private",
  "ALWAYS_PUBLIC": "Always Public",
  "ALWAYS_UNMAP_ACTION": "Hide for Agencies",
  "AMOUNT": "Amount",
  "ANALYTICS_ACCESS": "Analytics Access",
  "ANALYTICS_ACCESS_DESC": "Control access to view analytics.",
  "ANALYTICS_ACTIVE_LEADS": "Active Leads",
  "ANALYTICS_APPROVED_LEADS": "Approved Leads",
  "ANALYTICS_AVG_PLACEMENT_FEE": "Average Agency Placement Fee per month",
  "ANALYTICS_AVG_TIME_IN_FUNNEL": "Average time in funnel (days)",
  "ANALYTICS_AVG_TIME_TO_HIRE": "Avg time to hire (days)",
  "ANALYTICS_CANDIDATES_IN_PIPELINE": "Agency Candidates in pipeline today",
  "ANALYTICS_CLOSED_LEADS": "Closed Leads",
  "ANALYTICS_COLUMN_TOTAL": "Total",
  "ANALYTICS_CONTRACT_TIME_TO_HIRE": "Contract Hiring - Time to Hire",
  "ANALYTICS_CONVERSION_RATE": "Conversion Rate (%)",
  "ANALYTICS_CREATED_LEADS_OVER_TIME": "Created Leads over time",
  "ANALYTICS_CSV_CANDIDATE_ID": "Candidate Id",
  "ANALYTICS_CSV_DS_CODE": "Ds Code",
  "ANALYTICS_DAYS_TO_FILL": "Days to fill",
  "ANALYTICS_DAYS_TO_FIRST_INTRO": "Days to first Introduction",
  "ANALYTICS_DEMO_AGENCY_LIST_OTHER": "Other agencies (demo)",
  "ANALYTICS_DEMO_AGENCY_LIST_PREFERRED": "Preferred agencies (demo)",
  "ANALYTICS_DESC_AGENCY_RATINGS": "How agencies rate your company across different categories",
  "ANALYTICS_DESC_AVG_PLACEMENT_FEE": "Average recruitment fee paid per hire each period",
  "ANALYTICS_DESC_CONTRACT_TIME": "Average days to hire for contract/freelance positions over time",
  "ANALYTICS_DESC_DAYS_TO_FILL": "Average time to successfully hire a candidate, for completed hires only",
  "ANALYTICS_DESC_DAYS_TO_INTRO": "Average time from job publication until first candidate introduction, by job",
  "ANALYTICS_DESC_HIRES": "Candidates successfully hired through agencies",
  "ANALYTICS_DESC_HIRES_SUCCESS": "Candidates who were successfully hired through agencies",
  "ANALYTICS_DESC_HIRES_TOTAL": "Total successful hires completed",
  "ANALYTICS_DESC_HIRE_SUCCESS_RATE": "Percentage of all interviews that result in a successful hire (higher is better)",
  "ANALYTICS_DESC_INTERVIEWS": "Candidates currently in the interview process",
  "ANALYTICS_DESC_INTERVIEWS_TOTAL": "Total candidates in interview process",
  "ANALYTICS_DESC_INTRODUCED_TOTAL": "Total candidates introduced in selected period",
  "ANALYTICS_DESC_INTRODUCTIONS": "Candidates initially introduced by agencies (not yet interviewed)",
  "ANALYTICS_DESC_INTRO_TO_INTERVIEW": "Percentage of introduced candidates that progressed to interviews, by agency",
  "ANALYTICS_DESC_LIVE_JOBS": "New published jobs created in each period",
  "ANALYTICS_DESC_NEW_CANDIDATES": "All candidates introduced by agencies during this period",
  "ANALYTICS_DESC_NEW_INTERVIEWS": "Total interviews scheduled with candidates from all agencies",
  "ANALYTICS_DESC_OFFERS_TOTAL": "Total job offers made to candidates",
  "ANALYTICS_DESC_PERM_TIME": "Average days to hire for permanent positions over time",
  "ANALYTICS_DESC_PIPELINE": "Breakdown of all candidates by their current stage in the hiring process",
  "ANALYTICS_DESC_REJECTION_RANKED": "Detailed breakdown of rejection reasons ranked by frequency",
  "ANALYTICS_DESC_REJECTION_WHY": "Why candidates were rejected - helps identify common patterns",
  "ANALYTICS_DESC_TIME_VS_FEE": "Compare agencies: X-axis = days to hire, Y-axis = avg fee per hire, bubble size = total hires",
  "ANALYTICS_DESC_TOTAL_HIRES_PERIOD": "Total number of successful hires in the selected period",
  "ANALYTICS_DESC_TOTAL_RATINGS": "Total number of ratings received from all agencies",
  "ANALYTICS_DESC_TOTAL_SPEND": "Total recruitment fees paid to all agencies combined each period",
  "ANALYTICS_DESC_YOUR_RATINGS": "Your ratings of each recruiting agency you work with",
  "ANALYTICS_DESC_YOUR_RATINGS_BREAKDOWN": "How you rate agencies across performance, communication, quality and partnership",
  "ANALYTICS_EXPIRED_LEADS": "Expired Leads",
  "ANALYTICS_FILTER_AGENCY_COMPANY": "Filter on agency company",
  "ANALYTICS_FILTER_AGENCY_LIST": "Filter on agency list",
  "ANALYTICS_FILTER_AGENCY_USER": "Filter on agency user",
  "ANALYTICS_FILTER_ALL_DSPS": "All DSPs",
  "ANALYTICS_FILTER_DELIVERY_STATION": "Select Delivery Station",
  "ANALYTICS_FILTER_DRIVER_EXPRESS": "DriverExpress",
  "ANALYTICS_FILTER_EMPLOYMENT_TYPE": "Filter on employment type",
  "ANALYTICS_FILTER_JOB": "Filter on job",
  "ANALYTICS_HIRED_CANDIDATES": "Hired candidates",
  "ANALYTICS_HIRE_SUCCESS_RATE": "Agency Hire Success Rate (%)",
  "ANALYTICS_INTERVIEWS": "Interviews",
  "ANALYTICS_INTRO_TO_INTERVIEW_RATIO": "Agency introduction to interview ratio",
  "ANALYTICS_JOBS_OPEN_TO_AGENCIES": "Jobs open to agencies",
  "ANALYTICS_JOB_DATA_OVERVIEW": "Job Data Overview",
  "ANALYTICS_LEADS_REVIEWED": "Leads Reviewed",
  "ANALYTICS_LEAD_TARGET": "Lead Target",
  "ANALYTICS_LIVE_JOBS": "New Live jobs",
  "ANALYTICS_NEW_CANDIDATES": "New Candidates",
  "ANALYTICS_NEW_INTERVIEWS": "New Interviews",
  "ANALYTICS_OFFERS": "Offers",
  "ANALYTICS_PERM_TIME_TO_HIRE": "Permanent Hiring - Time to Hire",
  "ANALYTICS_PIPELINE_FUNNEL_CONVERSIONS": "Pipeline funnel conversions",
  "ANALYTICS_REJECTED_LEADS": "Rejected Leads",
  "ANALYTICS_REJECTION_REASONS": "Rejection Reasons",
  "ANALYTICS_SPEND_PER_SUPPLIER": "Spend per Agency",
  "ANALYTICS_TAB_FINANCIALS": "Financials",
  "ANALYTICS_TAB_OVERVIEW": "Overview",
  "ANALYTICS_TAB_PERFORMANCE": "Performance",
  "ANALYTICS_TAB_RATINGS": "Ratings",
  "ANALYTICS_TIME_TO_ACTION": "Time to Action (days)",
  "ANALYTICS_TIME_TO_HIRE_VS_FEE": "Time to Hire vs Avg Placement Fee",
  "ANALYTICS_TIME_TO_OFFER": "Time to Offer (days)",
  "ANALYTICS_TITLE": "Analytics",
  "ANALYTICS_TOTAL_HIRES": "Total Hires",
  "ANALYTICS_TOTAL_SPEND": "Total Agency Spend per month",
  "AND": "AND",
  "ANNUAL_SALARY": "Annual Salary",
  "ANSWERED": "Answered",
  "ANSWERS_SAVED": "Your answers have been saved",
  "ANSWERS_SUBMITTED": "Answers submitted successfully",
  "ANSWER_OPTIONS": "Answer Options",
  "ANSWER_QUESTIONS": "Answer Questions",
  "APPLICATION_PROCESS": "Application process",
  "APPLY_CHANGES": "Apply",
  "APPLY_REQUIRES_CHANGES": "Change the selection to add or remove assignments",
  "APPLY_TITLE": "Applied",
  "APPLY_TO_SELECTED": "Apply to selected",
  "APPOINT": "Propose to Job",
  "APPOINT_CANDIDATE": "Appoint candidate",
  "APPOINT_CANDIDATE_COMPANIES": "The candidate can not work for the following companies",
  "APPOINT_CANDIDATE_CONFIRM_TITLE": "Please make sure your candidate meets the below requirements",
  "APPOINT_JOB": "Propose candidate",
  "APPOINT_TITLE_2": "Appoint a candidate",
  "APPROVALS_AND_INVOICES_DESC": "Control who on your team can manage fee approvals and who gets notified about them",
  "APPROVED": "Approved",
  "APPROVE_INVOICE": "Approve Fee Approval",
  "ARCHIVED": "Archived",
  "ASK_QUESTION": "I have a question",
  "ASSIGN": "Assign",
  "ASSIGNED": "Assignment date",
  "ASSIGNMENT_DATE": "Assigned",
  "ASSIGNMENT_REMOVED": "Assignment removed successfully",
  "ASSIGNMENT_STATUS": "Assignment status",
  "ASSIGN_AGENCIES": "Assign agencies",
  "ASSIGN_AND_OR_MANAGE_AGENCY_RELATIONSHIPS": "Assign and/or manage agency relationships and permissions.",
  "ASSISTANT_ACTION_AGENCY_COMPANY_MEMBERS": "Agency company members",
  "ASSISTANT_ACTION_AGENCY_PROFILE": "Agency profile",
  "ASSISTANT_ACTION_AGREEMENT_HISTORY": "Agreement history",
  "ASSISTANT_ACTION_ASSIGNED_JOBS": "Assigned jobs",
  "ASSISTANT_ACTION_FEE_APPROVALS": "Fee approvals",
  "ASSISTANT_ACTION_FEE_TERMS": "Fee terms",
  "ASSISTANT_ACTION_FULL_DETAILS": "Full details",
  "ASSISTANT_ACTION_JOB_DETAILS": "Job details",
  "ASSISTANT_ACTION_JOB_QUESTIONS": "Job questions",
  "ASSISTANT_ACTION_PROJECT_MEMBERS": "Project members",
  "ASSISTANT_ACTION_SCREENING_QUESTIONS": "Screening questions",
  "ASSISTANT_ANALYTICS_APPROVED_LEADS": "Approved leads",
  "ASSISTANT_ANALYTICS_AVG_FEE": "Average placement fee",
  "ASSISTANT_ANALYTICS_CLOSED_LEADS": "Closed leads",
  "ASSISTANT_ANALYTICS_CONVERSION": "Conversion to hire",
  "ASSISTANT_ANALYTICS_DAYS_TO_HIRE": "Days to hire",
  "ASSISTANT_ANALYTICS_METRIC": "Other figure",
  "ASSISTANT_ANALYTICS_REFRESHED": "Figures refreshed {{when}}",
  "ASSISTANT_ANALYTICS_WINDOW": "Window {{from}} to {{to}}",
  "ASSISTANT_CATEGORY_INACTIVE": "Inactive logins",
  "ASSISTANT_CATEGORY_SUPPORT": "Support",
  "ASSISTANT_DRAFT_AGENCY_CUSTOMERS": "Which hiring companies does the agency named ",
  "ASSISTANT_DRAFT_ATS": "Which ATS is the company named ",
  "ASSISTANT_DRAFT_CANDIDATE_TRACE": "Trace the introduction with id ",
  "ASSISTANT_DRAFT_INVITATIONS": "Show invitations for the email ",
  "ASSISTANT_DRAFT_LOOKUP_USER": "Look up the user with email ",
  "ASSISTANT_DRAFT_OVERVIEW": "Show the setup for the account named ",
  "ASSISTANT_DRAFT_SEARCH_ACCOUNTS": "Find the hiring company or agency named ",
  "ASSISTANT_DRAFT_VISIBILITY": "Why can't this agency user see this job: ",
  "ASSISTANT_EMPTY": "No results",
  "ASSISTANT_ERROR_INVALID_ARGUMENT": "That request used a value this assistant cannot filter on",
  "ASSISTANT_ERROR_PERMISSION_DENIED": "You do not have permission to see this",
  "ASSISTANT_GENERIC_RESULT": "Assistant context",
  "ASSISTANT_OPEN": "Open assistant",
  "ASSISTANT_PLACEHOLDER": "Ask about jobs, agencies, contracts, or fee approvals",
  "ASSISTANT_PROVENANCE_AI_DRAFT": "AI draft",
  "ASSISTANT_PROVENANCE_CLIENT_SUBMITTED": "Entered by approver",
  "ASSISTANT_PROVENANCE_DERIVED_BRACKETS": "Calculated from fee brackets",
  "ASSISTANT_PROVENANCE_DERIVED_PERCENTAGE": "Calculated from fee percentage",
  "ASSISTANT_QUESTION_AGENCY_COMPANY_MEMBERS": "Who belongs to this agency company?",
  "ASSISTANT_QUESTION_AGENCY_FEE_APPROVALS": "Show the fee approvals with this agency",
  "ASSISTANT_QUESTION_AGENCY_JOBS": "Which jobs is this agency assigned to?",
  "ASSISTANT_QUESTION_AGENCY_LISTS": "Show our agency lists",
  "ASSISTANT_QUESTION_AGENCY_PROFILE": "Tell me about this agency",
  "ASSISTANT_QUESTION_ANALYTICS_AGENCY_PERFORMANCE": "How do agencies compare on hire success?",
  "ASSISTANT_QUESTION_ANALYTICS_FUNNEL": "Where do leads drop off in the pipeline?",
  "ASSISTANT_QUESTION_ANALYTICS_JOBS_OVERVIEW": "How are our jobs performing on introductions and hires?",
  "ASSISTANT_QUESTION_ANALYTICS_KPIS": "Summarize hires and pipeline KPIs for this period",
  "ASSISTANT_QUESTION_ANALYTICS_MY_KPIS": "What are my conversion and time-to-offer KPIs?",
  "ASSISTANT_QUESTION_ANALYTICS_PIPELINE": "How many candidates are in each pipeline stage?",
  "ASSISTANT_QUESTION_ANALYTICS_REJECTIONS": "What are the top rejection reasons?",
  "ASSISTANT_QUESTION_ANALYTICS_SPEND": "How much did we spend with each agency?",
  "ASSISTANT_QUESTION_ANALYTICS_TREND": "Show hires over time for this period",
  "ASSISTANT_QUESTION_CLIENT_AGREEMENT": "How has my agreement with this client changed?",
  "ASSISTANT_QUESTION_CONTRACT_AGENCIES": "Which agencies are on this master contract?",
  "ASSISTANT_QUESTION_CONTRACT_LISTS": "Which agency lists does this master contract cover?",
  "ASSISTANT_QUESTION_CONTRACT_TERMS": "What are the fee terms on this master contract?",
  "ASSISTANT_QUESTION_FEE_APPROVALS_DISPUTED": "Show the disputed fee approvals",
  "ASSISTANT_QUESTION_FEE_APPROVAL_CHANGES": "What changed on this fee approval?",
  "ASSISTANT_QUESTION_INVOICE_DETAILS": "Show the details of this fee approval",
  "ASSISTANT_QUESTION_JOB_AGENCIES": "Which agencies work on this job?",
  "ASSISTANT_QUESTION_JOB_DETAILS": "Tell me about this job",
  "ASSISTANT_QUESTION_JOB_FEE_APPROVALS": "Show the fee approvals for this job",
  "ASSISTANT_QUESTION_PROJECT_MEMBERS": "Who is on this project with me?",
  "ASSISTANT_REQUEST_FAILED": "The assistant could not complete that request",
  "ASSISTANT_SUGGESTION_ADMIN_AGENCY_CUSTOMERS": "Which hiring companies does an agency work with?",
  "ASSISTANT_SUGGESTION_ADMIN_ATS": "Which ATS is a company connected to?",
  "ASSISTANT_SUGGESTION_ADMIN_CANDIDATE_TRACE": "Was a candidate pushed to the ATS?",
  "ASSISTANT_SUGGESTION_ADMIN_INACTIVE_AGENCIES": "Which agency users have not logged in for 30 days?",
  "ASSISTANT_SUGGESTION_ADMIN_INACTIVE_CLIENTS": "Which hiring-company users have not logged in for 30 days?",
  "ASSISTANT_SUGGESTION_ADMIN_INVITATIONS": "Show invitations for an email",
  "ASSISTANT_SUGGESTION_ADMIN_JOB_CHANGE_LOG": "Show the change log for this job",
  "ASSISTANT_SUGGESTION_ADMIN_LOOKUP_USER": "Look up a user by email",
  "ASSISTANT_SUGGESTION_ADMIN_OVERVIEW": "Show the setup for an account",
  "ASSISTANT_SUGGESTION_ADMIN_SEARCH_ACCOUNTS": "Find a hiring company or agency by name",
  "ASSISTANT_SUGGESTION_ADMIN_VISIBILITY": "Why can't an agency user see a job? (assignment, live status, agreement)",
  "ASSISTANT_SUGGESTION_AGENCY_COMPANIES": "Which agency companies do we work with?",
  "ASSISTANT_SUGGESTION_AGENCY_COMPANIES_NEW": "Which agency companies have new members to review?",
  "ASSISTANT_SUGGESTION_ANALYTICS_KPIS": "How many hires and introductions are in this period?",
  "ASSISTANT_SUGGESTION_ANALYTICS_MY_KPIS": "What are my pipeline KPIs for this period?",
  "ASSISTANT_SUGGESTION_FEE_APPROVALS_DISPUTED": "How many fee approvals are disputed?",
  "ASSISTANT_SUGGESTION_FEE_APPROVALS_PENDING": "Which fee approvals are waiting for review?",
  "ASSISTANT_SUGGESTION_FEE_TERMS": "Which agencies are on each master contract?",
  "ASSISTANT_SUGGESTION_JOBS_NEED_ME": "Which jobs have questions waiting for my answer?",
  "ASSISTANT_SUGGESTION_JOB_QUESTIONS": "Which job questions still need an answer?",
  "ASSISTANT_SUGGESTION_JOB_SCREENING": "Show the candidate screening questions",
  "ASSISTANT_SUGGESTION_LIVE_JOBS": "Which jobs are published?",
  "ASSISTANT_SUGGESTION_MY_FEE_APPROVALS": "What is the status of my fee approvals?",
  "ASSISTANT_SUGGESTION_MY_TARGETS": "What are my targets on each job?",
  "ASSISTANT_SUGGESTION_NO_AGENCIES": "Which jobs have no agencies assigned?",
  "ASSISTANT_SUGGESTION_PROJECTS": "Which client projects is my agency on?",
  "ASSISTANT_TAG_ASSIGNED_TO_CONTRACT": "Assigned to contract",
  "ASSISTANT_TAG_NOT_ASSIGNED_TO_CONTRACT": "Not assigned to contract",
  "ASSISTANT_TITLE": "HirePort assistant",
  "ASSISTANT_WELCOME": "Hi {{name}}. What do you need a hand with?",
  "ASSISTANT_WELCOME_ANON": "Hi. What do you need a hand with?",
  "ASSISTANT_WITHHELD_FIELDS": "Some fields are hidden by your permissions",
  "ASSOCIATED_JOBS": "Associated jobs",
  "AT": "at",
  "ATS_DUPLICATE_CHECK": "Check ATS for existing candidates",
  "ATS_DUPLICATE_CHECK_DESC": "When enabled, we also search your ATS for an existing candidate or application with the same email during introduction.",
  "ATS_INTEGRATION_ADVANCED": "ATS Integration (Advanced)",
  "ATS_INTEGRATION_ADVANCED_DESC": "Advanced settings for how HirePort works with your recruiting system. These affect what your team sees and receives.",
  "ATS_INTERVIEWS_EARLIER": "Past and cancelled ({{count}})",
  "ATS_INTERVIEWS_NONE_UPCOMING": "No upcoming interviews",
  "ATS_INTERVIEW_CANCELLED": "Cancelled",
  "ATS_INTERVIEW_NEXT": "Next interview",
  "ATS_QUESTIONS": "ATS Questions",
  "ATS_QUESTIONS_DESCRIPTION": "Questions from your Applicant Tracking System. Required questions cannot be removed.",
  "ATS_QUESTION_MANAGED_IN_ATS": "Managed from screening question setup in ATS",
  "ATS_REAUTH_REQUIRED_MESSAGE": "Your ATS integration requires re-authentication. Please reconnect by following the instructions in the Kombo platform to continue syncing data.",
  "ATS_SCHEDULED_INTERVIEWS": "Scheduled interviews",
  "ATS_SCREENING_QUESTIONS_ENABLED": "Enable ATS Screening Questions",
  "ATS_SCREENING_QUESTIONS_ENABLED_DESC": "Show screening questions from your ATS to agencies when they introduce candidates. The questions come directly from your ATS.",
  "ATS_SCREENING_QUESTIONS_SR_LIMITATIONS_ATTACHMENTS": "Additional attachments can be retrieved through the agency chat.",
  "ATS_SCREENING_QUESTIONS_SR_LIMITATIONS_EXCLUDED": "Diversity questions and questions containing additional attachments are excluded and thus not visible for agencies.",
  "ATS_SCREENING_QUESTIONS_SR_LIMITATIONS_INCLUDED": "Public and internal screening questions (default sets + job specific questions) are pulled from the job in SmartRecruiters.",
  "ATS_SCREENING_QUESTIONS_SR_LIMITATIONS_INTRO": "Enabling ATS Screening Questions let's agencies fill in the screening questions that normally are filled in by the candidate if they apply directly.",
  "ATS_SCREENING_QUESTIONS_SR_LIMITATIONS_PLACEMENT": "These screening questions are presented the moment an agency recruiter proposes a candidate to your job and at the bottom of the Job page.",
  "ATS_SCREENING_QUESTIONS_SR_LIMITATIONS_TITLE": "SmartRecruiters limitations",
  "ATTACHED_FILE": "Attached file",
  "ATTACHMENTS": "Attachments",
  "ATTACH_FILE": "Attach file",
  "AUTO": "AUTO",
  "AVAILABLE": "Available",
  "AVERAGE_AGE_LABEL": "Average age",
  "AVERAGE_RATINGS_FROM_AGENCIES": "Average ratings from agencies you work with",
  "AWAITING_RECRUITER_ANSWERS": "Awaiting answers from the agency",
  "AZ-900": "AZ-900",
  "BACK": "Back",
  "BACKGROUND_IMAGE": "Background image",
  "BACK_TO_ADMIN_ROLE": "Back to admin role",
  "BACK_TO_CURRENT": "Back to Current Version",
  "BACK_TO_DASHBOARD": "Back to dashboard",
  "BADGE_UPDATED": "Updated",
  "BADGE_URGENT": "Urgent",
  "BASIC_PORTAL_SETTINGS": "Basic Portal Settings",
  "BB-1870": "Candidate invited, please select dates for the interview",
  "BEAR_WITH_US": "Bear with us...",
  "BENEFIT_TITLE": "Benefits",
  "BOLD": "Bold",
  "BRANCH": "Branch",
  "BROADCAST_MESSAGE": "Broadcast Message",
  "BROADCAST_MESSAGE_PLACEHOLDER": "Type your message",
  "BUILT_IN_STAGES": "Built-in Stages (question shown in chat)",
  "BULLET_LIST": "Bullets",
  "BY": "by",
  "C": "C",
  "CALENDAR_COLLEAGUE_INTERVIEW": "Colleague's interview",
  "CALENDAR_MORE_EVENTS": "Show more events",
  "CALENDAR_RECRUITER_LABEL": "Recruiter: {{name}}",
  "CANCEL": "Cancel",
  "CANCEL_EXPORT": "Cancel export",
  "CANDIDATE": "Candidate",
  "CANDIDATES": "Candidates",
  "CANDIDATES_IN_PROCESS_REJECTION_REASON": "Each candidate is rejected with the reason \"Agency removed from company\". This cannot be undone.",
  "CANDIDATES_IN_PROCESS_WARNING": "Candidates In Process",
  "CANDIDATES_IN_PROCESS_WARNING_DESCRIPTION": "This agency has active candidates. To remove the agency, all candidates below will be rejected.",
  "CANDIDATES_ON": "Candidates in {{stage}} stage",
  "CANDIDATE_ADD": "Add new candidate",
  "CANDIDATE_CHANGE_NOTIFICATION_MESSAGE": "You are about to update <1>{{candidateName}}</1>'s information.",
  "CANDIDATE_CHANGE_NOTIFICATION_TITLE": "Notify Companies About Changes?",
  "CANDIDATE_COMPENSATION_PRESET_TEXT": "Create preset values that you can change later when introducing the candidate to specific roles.",
  "CANDIDATE_CONSENT_ENABLED_DESC": "When enabled, HirePort sends candidate consent to your ATS at introduction time.",
  "CANDIDATE_CONSENT_ENABLED_TITLE": "Candidate Consent",
  "CANDIDATE_CREATE_MESSAGE": "Candidate was successfully created",
  "CANDIDATE_DELETE_CONFIRM": "Are you sure you want to delete this candidate?",
  "CANDIDATE_DELETE_IN_PROCESS_WARNING": "This candidate is in process at {{companies}}. Are you sure you want to delete it?",
  "CANDIDATE_DETAILS": "Candidate Details",
  "CANDIDATE_DRAWER_SELECT_JOB": "Select job",
  "CANDIDATE_FORM_COMMENT_1": "Please fill in the contact details of the candidate. Companies are expected to contact candidates only through the agency, unless otherwise agreed.",
  "CANDIDATE_FORM_COMMENT_3": "Not visible for companies, only for yourself as notes. You can use this for other information that you might need later when introducing the candidate.",
  "CANDIDATE_INFO": "Candidate info",
  "CANDIDATE_INFORMATION": "Candidate Information",
  "CANDIDATE_INTRODUCE_MESSAGE": "Candidate was successfully introduced",
  "CANDIDATE_INVITE": "Introduced candidate is accepted",
  "CANDIDATE_IS_REJECTED": "Candidate is rejected",
  "CANDIDATE_JOB_RECRUITER_FEES": "Agency fees",
  "CANDIDATE_MOVEMENT_CONTROL": "Candidate Movement Control",
  "CANDIDATE_MOVEMENT_CONTROL_DESC": "Let recruiters move candidates through stages, or view only.",
  "CANDIDATE_NAME": "Candidate name",
  "CANDIDATE_NAME_SUFFIX": "Candidate Name Suffix",
  "CANDIDATE_NAME_SUFFIX_DESC": "Add text after candidate names in your ATS to identify them (e.g., 'John Doe via HirePort'). Leave empty if not needed.",
  "CANDIDATE_NAME_SUFFIX_PLACEHOLDER": "e.g., ' via HirePort'",
  "CANDIDATE_PREPARATION_LABEL": "How can the candidate prepare",
  "CANDIDATE_PRIVACY_NOTICE": "By introducing this candidate, you confirm they have reviewed <a>{{companyName}}'s privacy notice</a>.",
  "CANDIDATE_PROFILE_TITLE": "Candidate profile",
  "CANDIDATE_REJECT": "Introduced candidate is rejected",
  "CANDIDATE_REJECT_MESSAGE": "Candidate was rejected",
  "CANDIDATE_SOLVES_PROBLEM": "What problem the candidate will solve",
  "CANDIDATE_SOURCE_LABEL": "Candidate Source Label",
  "CANDIDATE_SOURCE_LABEL_DESC": "Change how agencies appear in your ATS. For example, use 'External Agency' instead of showing each agency's actual name. Leave empty to show real agency names.",
  "CANDIDATE_SOURCE_LABEL_PLACEHOLDER": "e.g., Agency",
  "CANDIDATE_STATUS_CHANGED": "The candidate status has been changed",
  "CANDIDATE_TAGS_IN_ATS": "Candidate Tags in ATS",
  "CANDIDATE_TAGS_IN_ATS_DESC": "Choose which tags are added to candidates in your ATS: a general \"Agency\" tag, the agency's company name, and the recruitment fee (if a fee is set in the contract). Choose \"No Fee Tag\" to hide fee information.",
  "CANDIDATE_TITLE": "Candidates specification",
  "CANDIDATE_TRANSFER_TRACKING": "Candidate Transfer Tracking",
  "CANDIDATE_TRANSFER_TRACKING_DESC": "When a candidate is moved to a different job in your ATS, automatically notify the agency and let them continue tracking that candidate. Only works with SmartRecruiters.",
  "CANDIDATE_UPDATED_AND_NOTIFIED_MESSAGE": "Candidate updated and companies notified successfully!",
  "CANDIDATE_UPDATED_MESSAGE": "Candidate was successfully updated",
  "CANDIDATE_WITHDRAWN": "Candidate has been withdrawn",
  "CANNOT_ENRICH": "Cannot enrich",
  "CANNOT_REMOVE_ASSIGNMENT_CANDIDATES_IN_PROCESS": "Unable to remove assignment. Candidates are in process.",
  "CAN_ENRICH": "Can enrich",
  "CAREER-OPPORTUNITIES": "Career opportunities",
  "CAREER_PATH": "Career path",
  "CAREER_PATH_HINT": "Specify which positions the candidate can obtain as a result of career growth",
  "CERTIFICATION_MINIMUM": "Certification minimum",
  "CERTIFICATION_NICE_TO_HAVE": "Certification nice to have",
  "CHANGE_PASSWORD": "Change password",
  "CHART_ZOOM": "Zoom",
  "CHAT": "Chat",
  "CHAT_AND_COMMUNICATION": "Chat & Communication",
  "CHAT_COMMUNICATION_EMAIL_WARNING": "Email notifications are controlled in two places. Users will only receive emails if notifications are also enabled for their role in the Permissions tab.",
  "CHAT_DRAFT": "Draft",
  "CHAT_EMPTY_MESSAGE": "Select a chat to start messaging",
  "CHAT_HIRING_TEAM_ROLES": "Chat access for hiring team roles",
  "CHAT_HIRING_TEAM_ROLES_DESC": "Limit chat access to hiring team members with specific roles. Leave empty to give access to all roles",
  "CHAT_MESSAGE_DELAY_NOTICE": "Messages can take up to 15 minutes to appear.",
  "CHAT_MESSAGE_NOTES": "Notes on new messages",
  "CHAT_MESSAGE_NOTES_DESC": "Choose whether to create notes for new messages received",
  "CHAT_ONLY": "Chat Only",
  "CHAT_WIDTH": "Chat with agency",
  "CHECK_COMPENSATION_BEFORE_PROCEEDING": "Please check that candidate compensation information below is given in {{currency}} before proceeding.",
  "CHOOSE_A_JOB": "Choose a job...",
  "CHOOSE_CANDIDATE": "Choose candidate",
  "CHOOSE_DATES": "Choose dates",
  "CHOOSE_FILE": "Choose File",
  "CHOOSE_IMAGE": "Choose image",
  "CHOOSE_JOB": "Choose job",
  "CLEAR": "Clear",
  "CLEAR_FILTERS": "Clear filters",
  "CLEAR_SELECTION": "Clear selection",
  "CLICK_TO_EDIT_SCHEDULE": "Click to edit schedule",
  "CLICK_TO_SEE_PROFILE": "Click to view profile",
  "CLICK_TO_UPLOAD": "Click to Upload",
  "CLICK_TO_UPLOAD_DOCUMENT": "Click to upload a document",
  "CLICK_TO_VIEW_JOB_DETAILS": "Click to view job details",
  "CLICK_TO_VIEW_RECRUITER_PROFILE": "Click to view agency recruiter profile",
  "CLIENT": "Company",
  "CLIENTS": "Companies",
  "CLIENTS_LISTING_TITLE": "All companies",
  "CLIENTS_SELECT_LABEL": "Select company name",
  "CLIENT_AGENCY_SHARED_LOGIN_DEADLINE": "⚠️ Complete this by {{date}}. After this date, the old shared agency logins will stop working.",
  "CLIENT_AGENCY_SHARED_LOGIN_INTRO": "We turned on <bold>two-factor authentication (2FA)</bold> to keep every account more secure. Because 2FA is tied to one person, agencies can no longer share a single login (a \"SPOC\" account) across their whole team: <bold>each agency user now needs their own individual HirePort login.</bold>",
  "CLIENT_AGENCY_SHARED_LOGIN_STEP_1": "Ask each of your agencies to send you the full name and email address of everyone at their company who needs access: they'll message you this list <bold>directly through the Agency Chat</bold>.",
  "CLIENT_AGENCY_SHARED_LOGIN_STEP_2": "No action from you until you hear from them.",
  "CLIENT_AGENCY_SHARED_LOGIN_STEP_3": "Invite each person individually from your <bold>Agency Management</bold> screen.",
  "CLIENT_AGENCY_SHARED_LOGIN_STEP_4": "Each invite goes to its own email address: no more shared logins.",
  "CLIENT_AGENCY_SHARED_LOGIN_STEP_5": "Group everyone from the same company into one <bold>Agency List</bold> named after that agency.",
  "CLIENT_AGENCY_SHARED_LOGIN_STEP_6": "Anyone on the list automatically gets access to the jobs you assign to the list.",
  "CLIENT_AGENCY_SHARED_LOGIN_TITLE": "Shared agency logins are going away",
  "CLIENT_COMPANY": "Subcompany",
  "CLIENT_FEEDBACK": "Waiting for company feedback",
  "CLIENT_LOGIN_NOT_ALLOWED": "To access HirePort as a Company user, please use the integration in your ATS.",
  "CLIENT_OFFER_STAGE_TITLE_1": "You have to send the offer within {{numberOfHours}} hours",
  "CLIENT_OFFER_STAGE_TITLE_1_OUTDATED": "You have to send offer",
  "CLIENT_OFFER_STAGE_TITLE_2": "The agency must accept the offer for the candidate",
  "CLIENT_OWNED_PROJECT_NAME_READONLY": "This project name is managed by the company that owns the project and cannot be edited.",
  "CLIENT_SELECTED_CURRENCY_NOTE": "the client has selected {{currency}} as the default currency for this job.",
  "CLIENT_STAGE_TASK_TITLE-3": "The candidate will have their {{currentStageName}} on {{dateTime}}",
  "CLIENT_STAGE_TASK_TITLE-3_ATS": "The candidate will have “{{interviewTitle}}” on {{dateTime}}",
  "CLIENT_STAGE_TASK_TITLE-3_DISABLED": "The candidate will have their interview",
  "CLIENT_STAGE_TASK_TITLE-4-SIMPLE": "The agency will provide you with feedback",
  "CLIENT_STAGE_TASK_TITLE-4_AFTER": "The agency will provide you with feedback within {{numberOfHours}} hours after the interview",
  "CLIENT_STAGE_TASK_TITLE-4_OUTDATED": "The agency should have provided feedback",
  "CLOSE": "Close",
  "CLOSE_MENU": "Close menu",
  "COLLAPSE_FILTER_SIDEBAR": "Collapse filter sidebar",
  "COLLAPSE_NAVIGATION": "Collapse navigation",
  "COLLEAGUES": "Colleagues",
  "COLLEAGUE_EMAIL_PLACEHOLDER": "colleague@example.com",
  "COLLEAGUE_NAME": "Colleague Name",
  "COLLEAGUE_QUOTE": "Quote",
  "COLLEAGUE_QUOTES": "Colleague quotes",
  "COLLEAGUE_QUOTES_HINT": "What do your colleagues think about this job and your company?",
  "COLLEAGUE_REMOVED_FROM_PROJECT": "Colleague removed from project",
  "COLOR_SCHEME_DARK": "Dark",
  "COLOR_SCHEME_LIGHT": "Light",
  "COLOR_SCHEME_SYSTEM": "Match system",
  "COMMENT": "Comment",
  "COMMENTS": "Comments",
  "COMMUNICATION_PERMISSIONS_WITH_AGENCIES": "Set communication permissions for interacting with agencies.",
  "COMPANY_ACTIVITY_FEED": "Activity feed",
  "COMPANY_AGREEMENT_CONTRACT": "Upload Contract",
  "COMPANY_AGREEMENT_DOWNLOAD_CONTRACT": "Download contract",
  "COMPANY_AGREEMENT_ET_CAO": "Collective Labor Agreements — link and details",
  "COMPANY_AGREEMENT_ET_CAO_SHORT": "Collective Labor Agreements",
  "COMPANY_AGREEMENT_ET_DETAILS": "{{employmentType}} Fee Details",
  "COMPANY_AGREEMENT_ET_GDA": "General Delivery Agreements (general pricing agreements, hours until takeover, factor limitations, etc.)",
  "COMPANY_AGREEMENT_ET_GDA_SHORT": "General Delivery Agreements",
  "COMPANY_AGREEMENT_PAYMENT_TERMS_PLACEHOLDER": "Days",
  "COMPANY_BANNER": "Upload a wide banner image for your company profile (recommended: 1200×400px).",
  "COMPANY_BANNER_IMAGE": "Company Profile Banner Image",
  "COMPANY_CULTURE_LABEL": "Company culture",
  "COMPANY_DEFAULT_QUESTIONS": "Company Default Questions",
  "COMPANY_DEFAULT_QUESTIONS_DESCRIPTION": "These questions are automatically shown on all jobs. You can hide specific questions from this job if needed.",
  "COMPANY_FORM_ABOUT_COMPANY_2_TOOLTIP": "Additional information about your company",
  "COMPANY_FORM_ABOUT_COMPANY_CULTURE_TOOLTIP": "Describe your company culture and values",
  "COMPANY_FORM_ABOUT_COMPANY_TOOLTIP": "Tell us about your company",
  "COMPANY_FORM_ADDRESS_TOOLTIP": "Company address",
  "COMPANY_FORM_LOCATION_CITY_TOOLTIP": "City where the company is located",
  "COMPANY_FORM_MALE_FEMALE_TOOLTIP": "Gender distribution in the company",
  "COMPANY_FORM_OFFICE_LOCATIONS_TOOLTIP": "All office locations",
  "COMPANY_IMAGES_TITLE": "Company images",
  "COMPANY_INFO_TITLE": "Company info",
  "COMPANY_LOGO": "Company logo",
  "COMPANY_NAME_PLACEHOLDER": "Filter by company name",
  "COMPANY_NAME_TITLE": "Company name",
  "COMPANY_PROFILE": "Company Profile",
  "COMPANY_PROFILE_SETTINGS": "Company Profile Settings",
  "COMPANY_TITLE": "Company Name",
  "COMPANY_TYPE": "Company Info",
  "COMPANY_USPS": "Competitive USPs/Summary",
  "COMPANY_VIEW": "Company view",
  "COMPENSATION": "Compensation",
  "COMPENSATION_ALREADY_PROVIDED": "You have already provided {{employmentType}} compensation preferences for {{candidateName}}, although you can override them below:",
  "COMPENSATION_AND_BENEFITS": "Compensation & benefits",
  "COMPENSATION_FIT": "Compensation fit",
  "COMPENSATION_NOT_PROVIDED": "You have not provided default {{employmentType}} compensation preferences for {{candidateName}}, please provide them below:",
  "COMPENSATION_TYPE": "Fee structure",
  "COMPENSATION_TYPE_CUSTOM": "Custom",
  "COMPENSATION_TYPE_FIXED": "Fixed Amount",
  "COMPENSATION_TYPE_PERCENTAGE": "Percentage",
  "COMPENSATION_TYPE_UP_TO": "Up to",
  "CONDITION_HINT": "Leave empty to show for all types",
  "CONFIGURE_PROJECT_SETTINGS": "Configure your project settings",
  "CONFIRM": "Confirm",
  "CONFIRM_CONTRACT_FORK_CREATE": "Create master contract",
  "CONFIRM_CONTRACT_FORK_NAME_DESC": "These terms will be saved as a new master contract and linked to this agency. Other agencies on the previous contract are not affected.",
  "CONFIRM_CONTRACT_FORK_NAME_LABEL": "Master contract name",
  "CONFIRM_CONTRACT_FORK_NAME_REQUIRED": "Enter a name for the new master contract",
  "CONFIRM_CONTRACT_FORK_NAME_TITLE": "Name the new master contract",
  "CONFIRM_CONTRACT_FORK_SUCCESS": "New master contract created and linked to this agency.",
  "CONFIRM_CONTRACT_SAVE_AGENCY_ONLY": "Create new master contract for this agency",
  "CONFIRM_CONTRACT_SAVE_SCOPE_DESC": "Choose whether to update the existing master contract for all assigned agencies, or create a new master contract with these terms for this agency only.",
  "CONFIRM_CONTRACT_SAVE_SCOPE_NOTICE_DESC": "When you save, you can apply the changes to the master contract for all agencies working under this template, or create a new master contract with these terms for this agency only.",
  "CONFIRM_CONTRACT_SAVE_SCOPE_NOTICE_TITLE": "Changes can apply to the whole template or a new contract for this agency",
  "CONFIRM_CONTRACT_SAVE_SCOPE_TITLE": "Save contract changes",
  "CONFIRM_CONTRACT_SAVE_TEMPLATE": "Change the template",
  "CONFIRM_DATE": "Confirm date",
  "CONFIRM_DECLINE_CONTRACT": "Are you sure you want to decline this contract?",
  "CONFIRM_DELETE_ATS_QUESTION_CONTENT": "This will remove this optional ATS question from this job only. It will not appear in the candidate introduction form.",
  "CONFIRM_DELETE_ATS_QUESTION_TITLE": "Remove ATS question from this job?",
  "CONFIRM_DELETE_CUSTOM_QUESTION_CONTENT": "This will permanently remove this custom question from this job.",
  "CONFIRM_DELETE_CUSTOM_QUESTION_TITLE": "Remove this custom question?",
  "CONFIRM_DELETE_FIELD_CONTENT": "Are you sure you want to delete this field?",
  "CONFIRM_DELETE_FIELD_TITLE": "Delete field",
  "CONFIRM_DELETE_SCREENING_QUESTION": "Delete this screening question?",
  "CONFIRM_DELETE_SCREENING_QUESTION_CONTENT": "This action cannot be undone. Jobs using company defaults will no longer show this question.",
  "CONFIRM_HIDE_DEFAULT_QUESTION": "Hide this question from this job?",
  "CONFIRM_HIDE_DEFAULT_QUESTION_CONTENT": "This question will not appear for this job, but it will remain available in your company defaults. You can re-add it later.",
  "CONFIRM_REMOVE_AGENCIES": "Remove selected agencies?",
  "CONFIRM_REMOVE_AGENCIES_DESC": "This will remove the agency from your ATS entirely. This action cannot be undone.",
  "CONFIRM_REMOVE_AGENCIES_JOB_WARNING": "If this agency is re-invited later, they will need to be manually added back to any jobs.",
  "CONSENT_MUST_BE_ACCEPTED": "You must accept this consent to continue",
  "CONTACT": "Contact Information",
  "CONTACT_CLIENT": "Chat with Company",
  "CONTACT_PERSON_NAME": "Contact person name",
  "CONTACT_RECRUITER": "Chat with Agency",
  "CONTINUE": "Continue",
  "CONTRACT": "Contract",
  "CONTRACTS_LISTING_TITLE": "Active contracts",
  "CONTRACT_ACCEPTED_SUCCESS": "Contract accepted successfully",
  "CONTRACT_ACCEPT_ERROR": "Failed to accept contract",
  "CONTRACT_ACTION_REQUIRED_MESSAGE": "You must accept this contract to see jobs from this company.",
  "CONTRACT_DECLINED_SUCCESS": "Contract declined",
  "CONTRACT_DECLINE_ERROR": "Failed to decline contract",
  "CONTRACT_DETAILS_TITLE": "Contract Details with {{company}}",
  "CONTRACT_FILE_NAME_TOO_LONG": "The file name cannot exceed {{number}} characters.",
  "CONTRACT_HISTORY": "Contract History",
  "CONTRACT_LENGTH": "Contract Length",
  "CONTRACT_RATE": "Contract Rate",
  "CONTRACT_STATUS_ACCEPTED": "Accepted",
  "CONTRACT_STATUS_DECLINED": "Declined",
  "CONTRACT_STATUS_PENDING": "Pending",
  "CONTRACT_TYPE": "Select contract type",
  "CONTRACT_TYPES": "Contract types",
  "CONTRACT_VALUE": "Contract Value",
  "CONTRACT_VERSION": "Version",
  "CONTROL_ACCESS_TO_MASTER_CONTRACTS": "Control access to view, manage, or administer master contracts.",
  "COORDINATOR": "Coordinator",
  "COPYRIGHT_HIREPORT": "© {{year}} HirePort",
  "COPY_INVITE_LINK": "Copy sourcer link",
  "CREATE": "Create",
  "CREATED_AT": "Created",
  "CREATED_BY": "Created by",
  "CREATED_BY_ME": "Created by: me",
  "CREATED_BY_USER": "Created by: {{name}}",
  "CREATE_CUSTOM_FIELD": "Also create custom field on candidate profile",
  "CREATE_FEE_SETUP": "Create contract",
  "CREATE_JOB": "Create job",
  "CREATE_LIST": "Create List",
  "CREATE_LIST_AND_ADD": "Create and add",
  "CREATE_LIST_NAMED": "Create \"{{name}}\"",
  "CREATING_ACCOUNTS_BY_DOMAIN": "Creating accounts and assigning them to companies by specialization",
  "CREATING_DEMO_DATA": "Creating demo data...",
  "CREATING_LINKED_JOB": "Creating linked job...",
  "CREDIT_SYSTEM": "Credit System",
  "CSV_IMPORTED_COUNT": "Imported: {{count}}",
  "CSV_IMPORT_ERROR": "Failed to parse CSV file",
  "CSV_IMPORT_NO_VALID_ROWS": "No valid rows were found in the CSV file",
  "CSV_IMPORT_PARTIAL_SUCCESS": "Imported {{importedCount}} rows and skipped {{skippedCount}} invalid rows",
  "CSV_IMPORT_ROW_INVALID": "Invalid row",
  "CSV_IMPORT_SUCCESS": "Imported {{count}} agencies from CSV",
  "CSV_SKIPPED_COUNT": "Skipped: {{count}}",
  "CSV_SKIPPED_ROWS": "Skipped rows",
  "CSV_SKIPPED_ROW_MESSAGE": "Row {{rowNumber}}: {{message}}",
  "CSV_TOTAL_COUNT": "Total rows: {{count}}",
  "CSV_UPLOAD_CHECK_FORMAT": "Please verify that your CSV file has the correct format with all required columns (email, specializations).",
  "CSV_UPLOAD_PROCESSING_FAILED": "Failed to process CSV file.",
  "CSV_UPLOAD_TECHNICAL_ERROR": "Technical details",
  "CTP": "Contract-to-perm",
  "CULTURE": "Culture-fit",
  "CURRENCY": "Currency",
  "CURRENCY_FIELD_TOOLTIP_CLIENTS": "The currency in which the employment details will be presented to agencies",
  "CURRENCY_FIELD_TOOLTIP_RECRUITERS": "The currency in which the employment details will be presented to companies",
  "CURRENCY_MISMATCH_WARNING": "the currency for this job is {{jobCurrency}}, but compensation preferences for {{candidateName}} have been recorded in {{candidateCurrency}}.",
  "CURRENCY_UPDATED": "Currency updated successfully",
  "CURRENTLY_INHERITING_CURRENCY": "Currently inheriting: {{currency}}",
  "CURRENT_COMPANY": "Current company",
  "CURRENT_CONTRACT": "Current contract",
  "CURRENT_PASSWORD": "Current password",
  "CURRENT_PERMISSIONS": "Current Permissions",
  "CURRENT_PROJECTS": "Projects the team is working on",
  "CURRENT_ROLE": "Current role",
  "CURRENT_STAGE": "Current stage",
  "CURRENT_STATUS": "Current status",
  "CURRENT_VERSION": "Current Version",
  "CURRENT_WORKSPACE": "Current workspace",
  "CUSTOMIZE_TABLE": "Customize table",
  "CUSTOM_INTERVIEW_STAGES": "Custom Interview Stages (question shown in chat)",
  "CUSTOM_INVITE_TEMPLATE_ACTIVE": "Custom invite template is active.",
  "CUSTOM_INVITE_TEMPLATE_LANGUAGE": "This shared company template is currently based on {{language}}.",
  "CUSTOM_QUESTIONS": "Additional Questions",
  "CUSTOM_QUESTIONS_DESCRIPTION": "Job-specific custom questions that only apply to this job.",
  "CV": "CV",
  "DAILY": "Daily",
  "DANGER_ZONE": "Danger zone",
  "DASHBOARD_ACTION_REQUIRED_TOOLTIP": "These tasks need your attention now or in the near future",
  "DASHBOARD_ALL_JOBS_FILTER_TITLE_TOOLTIP": "Show all jobs",
  "DASHBOARD_ARCHIVED_TOOLTIP": "Archived jobs",
  "DASHBOARD_ARCHIVE_ICON_TOOLTIP": "Archive job for now, it will still be visible in the \"All jobs\" view",
  "DASHBOARD_AVAILABLE_JOBS": "Available jobs",
  "DASHBOARD_FAVORITE_ICON_TOOLTIP": "Add this job to your notifications",
  "DASHBOARD_HIRED_CANDIDATES": "Successful hires",
  "DASHBOARD_INTRODUCED_CANDIDATES": "New Candidates",
  "DASHBOARD_INTRODUCED_CANDIDATES_TOOLTIP": "Number of candidates you have introduced for this job",
  "DASHBOARD_IN_PROCESS_CANDIDATES": "Candidates in process",
  "DASHBOARD_IN_PROCESS_INTERVIEWS": "Applications in process",
  "DASHBOARD_NEW_TOOLTIP": "New jobs",
  "DASHBOARD_NOTIFY_ME_BELL_TOOLTIP": "Notify me when this job has new changes",
  "DASHBOARD_NOTIFY_ME_TOOLTIP": "Jobs you follow",
  "DASHBOARD_OFFERED_CANDIDATES": "Offers",
  "DASHBOARD_OPEN_JOBS": "Open jobs",
  "DASHBOARD_STOP_NOTIFY_ME_TOOLTIP": "Stop notifying me when this job has new changes",
  "DASHBOARD_TAB_ADOPTION_METRICS": "Adoption Metrics",
  "DASHBOARD_TAB_METRICS": "Metrics",
  "DASHBOARD_TAB_MONITORING": "Monitoring",
  "DASHBOARD_TAB_TICKETS": "Tickets",
  "DASHBOARD_TITLE": "Dashboard",
  "DASHBOARD_TOTAL_CLIENTS": "Total companies",
  "DASHBOARD_UNARCHIVE_ICON_TOOLTIP": "Restore job to new jobs",
  "DASHBOARD_UPCOMING_TOOLTIP": "Tasks here do not need immediate action",
  "DASHBOARD_UPLOADED_CANDIDATES": "Uploaded candidates",
  "DASHBOARD_VIEWS_TOOLTIP": "Number of times you have viewed this job",
  "DATA_MODE": "Data Mode",
  "DATES": "Dates",
  "DATES_PROPOSED": "Dates scheduled",
  "DATE_ADDED": "Date added",
  "DATE_CONFIRMED": "Date confirmed",
  "DAYS": "days",
  "DAYS_AT_THE_OFFICE": "Days at the office",
  "DAYS_IN_PROCESS": "Days in process",
  "DAYS_ONLINE": "Days online",
  "DAYS_WORKING_FROM_HOME": "Days working from home",
  "DAY_TO_DAY_ACTIVITIES": "Weekly tasks the candidate is working on",
  "DECLINE_CONTRACT": "Decline",
  "DECLINE_CONTRACT_WARNING_JOBS": "If you decline, you will not see jobs from this company until you accept the contract.",
  "DEFAULT_CREDITS_PER_JOB": "Amount of credits per job",
  "DEFAULT_CREDITS_PER_JOB_DESC": "Number of candidates each agency recruiter can submit to a job. Changes apply when a job is published or republished. Live jobs keep their current credits until then, and credits already used are kept.",
  "DEFAULT_CURRENCY": "Default currency",
  "DEFAULT_CURRENCY_DESC": "The currency used for all new jobs. If your ATS provides a different currency for a specific job, we'll use that instead.",
  "DEFAULT_FIELD_ADDED_SUCCESS": "Default field added successfully",
  "DEFAULT_INVITE_TEMPLATE_ACTIVE": "You are currently using the default invite template.",
  "DEFAULT_INVITE_TEMPLATE_LANGUAGE": "The default template is generated from your company's current language: {{language}}.",
  "DEFAULT_JOB_BANNER_IMAGE": "Default Job Banner Image",
  "DEFAULT_JOB_QUESTIONS": "Default Job Questions",
  "DEFAULT_JOB_QUESTIONS_DESC": "Default questions that will be asked for all jobs",
  "DEFAULT_LANGUAGE": "Default Language",
  "DEFAULT_LANGUAGE_PORTAL_DESC": "The language used for all communications with agencies and notes in your ATS.",
  "DEFAULT_TIMEZONE": "Timezone",
  "DELETE": "Delete",
  "DELETED": "Deleted",
  "DELETE_LIST": "Delete list",
  "DELETE_LIST_CONFIRM_DESC": "This cannot be undone.",
  "DELETE_LIST_CONFIRM_DESC_WITH_MEMBERS": "This list has {{count}} member(s). Deleting removes the list only; agencies stay in your account.",
  "DELETE_LIST_CONFIRM_TITLE": "Delete this list?",
  "DELETE_POPUP_TITLE": "Are you sure you want to delete this job",
  "DEMO_DATA": "Demo Data",
  "DEMO_DATA_ACTIONS": "Demo data actions",
  "DEMO_DATA_ACTIVE": "Demo data is active",
  "DEMO_DATA_CREATION_STARTED": "Demo data creation started",
  "DEMO_DATA_DESCRIPTION": "Generate realistic demo data to explore the platform features. This will create sample agency recruiters, candidates, and conversations.",
  "DEMO_DATA_EXISTS_ERROR": "Demo data already exists. Please remove existing demo data first.",
  "DEMO_DATA_REMOVAL_STARTED": "Demo data removal started",
  "DEMO_JOB_SELECTION_HELP": "For the best demo experience, we recommend selecting just one job. The system will create a comprehensive ecosystem with 6 specialized recruiters and 18 candidates across all employment types.",
  "DEPARTMENT_TITLE": "Department",
  "DESCRIBE_CAREER_PATH": "Describe Career path",
  "DESCRIBE_DISPUTE_DETAILS": "Describe the details of your dispute...",
  "DESCRIPTION": "Description",
  "DESELECT_ALL": "deselect all",
  "DIRECT_CHAT_DISABLED_MESSAGE": "This company has disabled this inbox. You can still send messages after introducing a candidate.",
  "DIRECT_CHAT_WELCOME_MESSAGE": "Chatbox opened, you are now connected. Feel free to reach out for any questions or updates.",
  "DIRECT_CONVERSATION": "Direct conversation",
  "DISCARD_CHANGES": "Discard changes",
  "DISMISS": "Dismiss",
  "DISPUTE": "Dispute",
  "DISPUTED": "Disputed",
  "DISPUTE_HISTORY": "Dispute History",
  "DISPUTE_INVOICE": "Dispute Fee Approval",
  "DISPUTE_REASON_CANDIDATE_ISSUE": "Issue with candidate",
  "DISPUTE_REASON_CANDIDATE_LEFT_COMPANY": "Candidate left company",
  "DISPUTE_REASON_CANDIDATE_NO_SHOW": "Candidate did not start",
  "DISPUTE_REASON_INCORRECT_AMOUNT": "Incorrect amount",
  "DISPUTE_REASON_JOB_ISSUE": "Issue with job",
  "DISPUTE_REASON_OTHER": "Other issue",
  "DOMAIN": "Specialisation",
  "DOMAIN_PLACEHOLDER": "Select specialisation",
  "DONE": "Done",
  "DOUBLE_CHECKED": "I double checked the above",
  "DOWNLOAD_CSV": "Download CSV",
  "DOWNLOAD_CSV_TEMPLATE": "Download CSV template",
  "DOWNLOAD_CSV_TEMPLATE_TOOLTIP": "Downloads a template file with example (mock) rows. Replace them with your agency contacts before uploading.",
  "DOWNLOAD_CV_TITLE": "Download CV",
  "DOWNLOAD_FAILED_ENTRIES_CSV": "Download Failed Entries CSV",
  "DOWNLOAD_FILE": "Download File",
  "DOWNLOAD_OFFER": "Download offer",
  "DRAFT_SAVED_SUCCESS": "Draft saved successfully",
  "DRESSCODE_LABEL": "Dress code",
  "DUE_DATE": "Due date",
  "DUPLICATE_CANDIDATE_PREVENTION": "Duplicate candidate prevention",
  "DUPLICATE_CANDIDATE_PREVENTION_DESC": "Prevent agencies from introducing a previously introduced candidate (identified by email, phone, or LinkedIn) multiple times.",
  "DUPLICATE_CHECK_ATS_STAGES_DESC": "Select ATS stages to check for duplicates. Leave empty to check all stages. Includes a Sourced option for candidates not yet in your ATS.",
  "DUPLICATE_CHECK_MONTHS": "Look Back Period",
  "DUPLICATE_CHECK_MONTHS_DESC": "How far back in time to check. For example, 12 months means we'll only block duplicates from the last year.",
  "DUPLICATE_CHECK_STATUSES": "Which Candidate Stages to Check",
  "DUPLICATE_CHECK_STATUSES_DESC": "Select specific stages to check for duplicates. For example, if you only select 'Hired', we'll only block previously introduced candidates who were previously hired. Leave empty to check all stages.",
  "DURATION": "Duration",
  "EDITED_BY": "Edited by",
  "EDIT_CANDIDATE": "Edit candidate",
  "EDIT_CLIENT": "Edit company",
  "EDIT_DISPUTE": "Edit dispute",
  "EDIT_INVITE_EMAIL": "Edit Invite Email",
  "EDIT_INVITE_EMAIL_TEMPLATE": "Edit Invite Email Template",
  "EDIT_INVOICE": "Edit Fee Approval",
  "EDIT_JOB": "Edit job",
  "EDIT_OFFER": "Edit offer",
  "EDIT_RECRUITER": "Edit agency recruiter",
  "EDIT_SCHEDULE": "Edit Scheduled Access",
  "EDIT_TITLE": "Edit",
  "EDUCATION_MINIMUM": "Education minimum",
  "EDUCATION_NICE_TO_HAVE": "Education nice to have",
  "EMAIL": "Email",
  "EMAIL_BODY": "Email Body",
  "EMAIL_NOTIFICATIONS": "All Agency Hiring Email Notifications",
  "EMAIL_NOTIFICATIONS_DESC": "Enables or disables all email notifications related to agency hiring across your organization. Users will only receive emails if their role also allows email notifications in the Permissions tab.",
  "EMAIL_NOTIFICATIONS_ROLE_BASED": "Email Notifications for This Role",
  "EMAIL_NOTIFICATIONS_ROLE_BASED_DESC": "Controls whether users with this role are allowed to receive agency-hiring–related chat messages. This applies to all users assigned to this role in your ATS when chat-message notifications are enabled in the Chat & Communication settings tab.",
  "EMAIL_SENT_TEXT": "Email sent!",
  "EMAIL_SUBJECT": "Email Subject",
  "EMAIL_SUBJECT_PLACEHOLDER": "Write the invitation subject...",
  "EMBED_ACTIVATE_COMPLETE": "Activation complete",
  "EMBED_ACTIVATE_ERROR": "Error: {{error}}",
  "EMBED_ACTIVATE_INVALID_TOKEN": "Invalid token format",
  "EMBED_ACTIVATE_IN_PROGRESS": "Activating...",
  "EMBED_ASSIGN_JOB_CLOSED_DESCRIPTION": "This job is closed, so agencies can't be assigned to it. Reopen the job in your ATS to work with agencies.",
  "EMBED_ASSIGN_JOB_CLOSED_TITLE": "This job is closed",
  "EMBED_ASSIGN_JOB_NOT_FOUND_DESCRIPTION": "New jobs can take a little while to appear. Please try again in a few minutes.",
  "EMBED_ASSIGN_JOB_NOT_FOUND_TITLE": "We still can't find this job",
  "EMBED_ASSIGN_MULTIPLE_MATCHES_DESCRIPTION": "This job is linked to more than one job in HirePort, so we can't tell which one to use. Please contact HirePort support and we'll sort it out.",
  "EMBED_ASSIGN_MULTIPLE_MATCHES_TITLE": "We found more than one match",
  "EMBED_ASSIGN_NO_PERMISSION_DESCRIPTION": "You don't have permission to assign agencies to jobs. Ask your HirePort admin to give you access to manage agencies.",
  "EMBED_ASSIGN_NO_PERMISSION_TITLE": "You can't assign agencies",
  "EMBED_CHAT_HIRING_TEAM_ROLE_DESCRIPTION": "Your role on this job's hiring team doesn't include candidate chats. Ask your HirePort admin if you need access.",
  "EMBED_CHAT_HIRING_TEAM_ROLE_TITLE": "Your role can't open this chat",
  "EMBED_CHAT_INSUFFICIENT_PARAMS": "Could not load chat due to missing information. Please check the URL parameters.",
  "EMBED_CHAT_NOT_ASSIGNED_DESCRIPTION": "This candidate belongs to a job you don't have access to in HirePort.",
  "EMBED_CHAT_NOT_ASSIGNED_TITLE": "You don't have access to this candidate",
  "EMBED_CHAT_NOT_CONNECTED_TITLE": "ATS not connected",
  "EMBED_CHAT_NOT_FOUND_DESCRIPTION": "We couldn't find a HirePort conversation for this candidate. Their application may have been removed or moved to another job.",
  "EMBED_CHAT_NOT_FOUND_TITLE": "Conversation not available",
  "EMBED_CHAT_NOT_ON_HIRING_TEAM_DESCRIPTION": "Only hiring team members can chat with the agency about this candidate. Ask the job's hiring manager to add you.",
  "EMBED_CHAT_NOT_ON_HIRING_TEAM_TITLE": "You're not on the hiring team",
  "EMBED_CHAT_NO_PERMISSION_DESCRIPTION": "Your account doesn't have permission to view candidate chats. Ask your HirePort admin to update your role.",
  "EMBED_CHAT_NO_PERMISSION_TITLE": "You can't view candidate chats",
  "EMPLOYEES": "employees",
  "EMPLOYEES_LABEL": "Number of employees",
  "EMPLOYMENT_TYPE": "Employment Type",
  "EMPLOYMENT_TYPE_PERMANENT": "Permanent Employment",
  "EMPTY_COMPANY_ACTIVITY_FEED": "Nothing to see here yet",
  "EMPTY_JOB_ACTIVITY_FEED": "Nothing to see here yet, turn on job notifications to receive updates",
  "ENABLE_CREDIT_SYSTEM_DESC": "Limit how many candidates each agency recruiter can introduce per job. When disabled, agency recruiters can introduce unlimited candidates. Spots become available again when candidates are rejected or hired.",
  "END_PROCESS": "End process",
  "ENGLISH_SPEAKING_WELCOME": "English speaking welcome",
  "ENSURE_CANDIDATE_COMPENSATION_IN_CURRENCY": "Please ensure candidate compensation information below is given in that currency to avoid confusion.",
  "ENTER_ANSWER": "Enter your answer",
  "ENTER_COMPANY_NAME": "Enter company name",
  "ENTER_FIELD_NAME_PLACEHOLDER": "Field name",
  "ERROR": "Error",
  "ERROR_ADDING_FIELD": "Failed to add field",
  "ERROR_ADDING_QUESTION": "Failed to add question",
  "ERROR_ADDING_TAG": "Failed to add tag",
  "ERROR_ADDING_TO_LIST": "Failed to add to list",
  "ERROR_BACK_TO_LOGIN": "Clear session and log in",
  "ERROR_CANNOT_CREATE_DEMO_DATA": "Cannot Create Demo Data",
  "ERROR_CANNOT_DELETE_INHERITED": "Cannot delete inherited questions",
  "ERROR_CODE": "Error code",
  "ERROR_CREATING_DEMO_DATA": "Error creating demo data",
  "ERROR_CREATING_LIST": "Failed to create list",
  "ERROR_CREATING_SCREENING_QUESTION": "Error creating screening question",
  "ERROR_DELETING_FIELD": "Failed to delete field",
  "ERROR_DELETING_QUESTION": "Error deleting question",
  "ERROR_DELETING_SCREENING_QUESTION": "Error deleting screening question",
  "ERROR_FAILED_TO_ACCEPT_INVITE": "Failed to accept invite.",
  "ERROR_FAILED_TO_LOAD_AGREEMENT": "Failed to load agreement details.",
  "ERROR_FETCHING_HISTORY": "Failed to fetch history",
  "ERROR_FETCHING_MESSAGES": "Failed to fetch messages",
  "ERROR_FETCHING_ORGANIZATION_SETTINGS": "Failed to fetch organization settings",
  "ERROR_FETCHING_QUESTIONS": "Failed to load screening questions",
  "ERROR_HIDING_QUESTION": "Error hiding question",
  "ERROR_INTRODUCING_CANDIDATE": "Failed to introduce candidate. Please try again.",
  "ERROR_INVITATION_FAILED": "Invitation failed, please try again later",
  "ERROR_LOADING_AGENCIES": "Error loading agencies",
  "ERROR_LOADING_AGENCY_LISTS": "Failed to load agency lists",
  "ERROR_LOADING_CHART": "Error loading chart",
  "ERROR_LOADING_DATA": "Error loading data",
  "ERROR_MARKING_MESSAGES_READ": "Failed to mark messages as read",
  "ERROR_MESSAGE": "Something went wrong, will be back soon ...",
  "ERROR_MISSING_INFO": "Missing information",
  "ERROR_MISSING_USER_ID": "User ID is missing",
  "ERROR_NO_JOB_ID_PREVIEW": "No job ID to preview",
  "ERROR_PLEASE_ENTER_NAME_AND_EMAIL": "Please enter your name and email.",
  "ERROR_PLEASE_ENTER_NAME_EMAIL": "Please enter your first name, last name, and email.",
  "ERROR_PLEASE_ENTER_VALID_EMAIL": "Please enter a valid email address!",
  "ERROR_PLEASE_INPUT_EMAIL": "Please input your email!",
  "ERROR_PLEASE_INPUT_NAME": "Please input your name!",
  "ERROR_PLEASE_SELECT_FEE_TYPE": "Please select a fee type!",
  "ERROR_READDING_QUESTION": "Error re-adding question",
  "ERROR_REMOVING_ASSIGNMENT": "Something went wrong, please try again.",
  "ERROR_REMOVING_DEMO_DATA": "Error removing demo data",
  "ERROR_REMOVING_TAG": "Failed to remove tag",
  "ERROR_SAVING_PERMISSIONS": "Failed to save permissions",
  "ERROR_SENDING_MESSAGE": "Failed to send message",
  "ERROR_SOMETHING_WENT_WRONG": "Something went wrong",
  "ERROR_SUBMITTING_ANSWERS": "Error submitting answers. Please try again.",
  "ERROR_SUPPLIER_ALREADY_INVITED": "You've already invited this agency",
  "ERROR_TYPE": "Error type",
  "ERROR_UNABLE_TO_CREATE_DEMO_DATA": "Unable to create demo data. Please check your ATS integration and ensure you have available jobs.",
  "ERROR_UNABLE_TO_REMOVE_RECRUITER_CANDIDATES_IN_PROCESS": "Unable to remove agency recruiter. Candidates are in process.",
  "ERROR_UPDATING_AGENCIES": "Failed to update agency assignments",
  "ERROR_UPDATING_COMPANY_RECRUITER_AGREEMENT": "Unable to update agency agreement. Please try again.",
  "ERROR_UPDATING_FIELD": "Failed to update field",
  "ERROR_UPDATING_JOB_STATUS": "Failed to update job status",
  "ERROR_UPDATING_ORDER": "Error updating question order",
  "ERROR_UPDATING_SCREENING_QUESTION": "Error updating screening question",
  "ERROR_UPDATING_SETTINGS": "Failed to update settings",
  "ERROR_UPLOADING_FILE": "Failed to upload file. Please try again.",
  "ET_CAO_CTP": "Collective Labor Agreement",
  "ET_DETAILS_CTP": "Collective Labor Agreement details",
  "ET_DETAILS_FREELANCE": "Freelance details",
  "ET_GDA_CTP": "General Data Access",
  "EXCLUDED_COMPANIES_LABEL": "Companies candidates may not come from",
  "EXPAND_FILTER_SIDEBAR": "Expand filter sidebar",
  "EXPAND_NAVIGATION": "Expand navigation",
  "EXPIRED_LINK_ERROR": "This link has expired. Please request another Magic Link from the Admin.",
  "EXPORT": "Export",
  "EXPORT_CANCELLED": "Export cancelled",
  "EXPORT_ERROR": "Failed to export job assignments",
  "EXPORT_ERROR_TIP": "An error occurred during export. Please try again.",
  "EXPORT_PROCESSING_DATA": "Processing data",
  "EXPORT_STARTING": "Starting export",
  "EXPORT_SUCCESS": "Exported job assignments successfully",
  "EXPORT_TEXT": "Export to Calendar",
  "EXPORT_WARNING": "This export may take a while",
  "EXTENSION_FIELDS": "Additional Information",
  "EXTRAS": "Extras (coffee, pizza, study sessions, etc)",
  "EXTRAS_TITLE": "Extras",
  "EXTRA_NOTES_LABEL": "Extra notes",
  "FAILED_ACCEPT_INVITATION": "Failed to accept invitation",
  "FAILED_DECLINE_INVITATION": "Failed to decline invitation",
  "FAILED_TO_LOAD_INVOICES": "Failed to load fee approvals",
  "FAILED_TO_SAVE_ANSWERS": "Failed to save your answers",
  "FAILED_TO_UPDATE_INFORMATION": "Failed to update information",
  "FEEDBACK": "feedback",
  "FEEDBACK_RECEIVED": "Feedback received",
  "FEEDBACK_REQUIRED": "Feedback required",
  "FEEDBACK_SENT": "Feedback was successfully sent.",
  "FEEDBACK_TEXT_1": "Traveling distance is still acceptable.",
  "FEEDBACK_TEXT_2": "Salary double check still okay.",
  "FEES": "Fees",
  "FEE_AMOUNT": "Fee Amount",
  "FEE_APPROVALS": "Fee Approvals",
  "FEE_APPROVALS_DESC": "When turned off, the fee approval page is hidden from your team, existing records stay saved, and new hires will no longer create fee approvals.",
  "FEE_APPROVAL_AMOUNT": "Fee Approval Amount",
  "FEE_APPROVAL_AMOUNT_CALCULATED": "Calculated automatically: {{percentage}}% of {{salary}}",
  "FEE_APPROVAL_AMOUNT_CALCULATED_FROM_BRACKETS": "Calculated automatically from the agreed salary brackets",
  "FEE_APPROVAL_AMOUNT_NEEDS_PERCENTAGE": "Add the fee percentage and this is calculated for you",
  "FEE_APPROVAL_AMOUNT_NEEDS_SALARY": "Add the annual salary and this is calculated for you",
  "FEE_CURRENCY_FIELD_LABEL": "Fee currency",
  "FEE_DESC": "Fee",
  "FEE_DETAILS_FORM_LABEL": "Fee details",
  "FEE_ET_TYPE": "{{employmentType}} Jobs",
  "FEE_PERCENTAGE": "Fee Percentage",
  "FEE_SETTINGS_CREATED": "Fee template was successfully created",
  "FEE_SETTINGS_DELETED": "Fee template was successfully deleted",
  "FEE_SETTINGS_DELETE_ERROR": "Unable to delete fee template. Please try again.",
  "FEE_SETTINGS_UPDATED": "Fee template was successfully updated",
  "FEE_STRUCTURE": "Fee Structure",
  "FEE_TEMPLATE": "Master Contract",
  "FEE_TYPE": "Fee type",
  "FEE_TYPE_CUSTOM": "Custom",
  "FEE_TYPE_FIXED": "Fixed",
  "FEE_TYPE_HEADER": "Fee Type",
  "FEE_TYPE_PERCENTAGE": "Percentage",
  "FEE_TYPE_UP_TO": "Up to",
  "FIELD_ADDED_FROM_DEFAULTS_SUCCESS": "Field added from defaults",
  "FIELD_ADDED_SUCCESS": "Field added successfully",
  "FIELD_DELETED_SUCCESS": "Field deleted successfully",
  "FIELD_NAME": "Field Name",
  "FIELD_NAME_AND_TITLE_REQUIRED": "Both question title and field name are required",
  "FIELD_UPDATED_SUCCESS": "Field updated successfully",
  "FILE_FORMAT_VALIDATION": "Please upload a JPG or PNG file",
  "FILE_SIZE_TOO_LARGE": "File size is too large. Maximum file size is 10MB.",
  "FILL_IN": "Please fill in the below form",
  "FILTER_COLUMN": "Filter {{column}}",
  "FIRST_NAME_LABEL": "First name",
  "FORGOT_PASSWORD_TEXT": "Forgot password",
  "FORM_CLOSE_CONFIRMATION": "Your changes will be lost if you leave without saving.",
  "FREELANCE": "Freelance",
  "FROM_EU_NO_PACKAGE": "Relocation from within EU possible without relocation package",
  "FROM_EU_WITH_PACKAGE": "Relocation from within EU possible with relocation package",
  "FROM_WORLD_NO_PACKAGE": "Relocation from anywhere possible without relocation package",
  "FROM_WORLD_WITH_PACKAGE": "Relocation from anywhere possible with relocation package",
  "FULL_CONTROL": "Full Control (ATS Synced)",
  "FULL_NAME": "Full Name",
  "GDPR_CONSENT_DAYS": "GDPR Consent Duration",
  "GDPR_CONSENT_DAYS_DESC": "Choose how to determine the GDPR consent duration for candidate data processing after introduction.",
  "GDPR_CUSTOM_DAYS_DESC": "Set a custom number of days for GDPR consent validity.",
  "GDPR_CUSTOM_DAYS_LABEL": "Custom Consent Duration",
  "GDPR_RECRUITEE_DAYS_LABEL": "Recruitee Consent Duration",
  "GDPR_RECRUITEE_DAYS_VALUE": "The consent period configured in Recruitee.",
  "GDPR_RECRUITEE_LOADING": "Fetching consent duration from Recruitee...",
  "GDPR_RECRUITEE_NOT_FOUND": "Could not retrieve the GDPR consent period from Recruitee. The system will use the default of 180 days as a fallback.",
  "GDPR_USE_RECRUITEE": "Use Recruitee",
  "GENDER_FEMALE": "Female",
  "GENDER_MALE": "Male",
  "GENERAL_COMMENTS": "Your feedback about the interview",
  "GENERATE_DEMO_DATA": "Generate demo data",
  "GET_STARTED_LABEL": "Let's get\nstarted",
  "GIVE_FEEDBACK": "Give feedback",
  "GOAL": "Goal",
  "GOT_IT": "Got it",
  "GO_TO_CONTRACTS": "Go to contracts",
  "GO_TO_TITLE": "Go to",
  "GUARANTEE_PERIOD": "Guarantee period",
  "H1": "H1",
  "HAVE_ACCOUNT_QUESTION": "Already have an account?",
  "HEADING": "Heading",
  "HELLO": "Hello",
  "HELLO_DESCRIPTION": "Plenty of work ahead! Shall we start?",
  "HELP_CENTER_LINK_MISSING_WARNING": "Help Center link required",
  "HELP_CENTER_LINK_MISSING_WARNING_DESC": "Add a \"Visit Help Center\" link before saving by clicking the \"Visit Help Center\" button in the toolbar.",
  "HERE": "here",
  "HIDDEN_QUESTIONS": "Hidden Questions",
  "HIDDEN_QUESTIONS_DESCRIPTION": "These company default questions are hidden from this job. Click \"Add\" to make them visible again.",
  "HIDE": "Hide",
  "HIDE_HIRING_TEAM": "Hide Hiring Team",
  "HIDE_HIRING_TEAM_DESC": "When enabled, the hiring team information will be hidden on jobs.",
  "HIDE_REJECTION_REASON": "Hide Rejection Reason from Agencies",
  "HIDE_REJECTION_REASON_DESC": "When enabled, the rejection reason will not be stored or shared with recruiting agencies. They will only see that the candidate was rejected, but not the specific reason.",
  "HIDE_SYSTEM_MESSAGES_IN_CHAT": "Hide System Messages",
  "HIDE_SYSTEM_MESSAGES_IN_CHAT_DESC": "Hide automated system messages (e.g. star ratings, stage changes) from the chat view. Only user-written messages will be visible.",
  "HIRED": "Hired",
  "HIREPORT": "HirePort",
  "HIREPORT_INSTRUCTION_VIDEO": "HirePort Instruction video",
  "HIREPORT_SCREENING_QUESTIONS_ENABLED": "Enable HirePort Custom Screening Questions",
  "HIREPORT_SCREENING_QUESTIONS_ENABLED_DESC": "Ask agencies custom questions when they introduce candidates (e.g., 'Do they have a driver's license?'). You can configure which questions to ask below.",
  "HIREPORT_SUPPORT_TITLE": "HirePort Support",
  "HIREPORT_SYSTEM_MESSAGE_NAME": "System Message",
  "HIRES_TITLE": "Hires",
  "HIRING_APPROVALS_DESCRIPTION": "Hires from your Customers are added automatically. This can take up to 24 hours.",
  "HIRING_APPROVALS_LISTING_TITLE": "Approval queue",
  "HIRING_APPROVAL_MANAGERS": "Fee Approvers",
  "HIRING_APPROVAL_MANAGERS_DESC": "Choose which team members can review and approve new hires and access the fee approval page. Company admins always have this access by default.",
  "HIRING_DSP": "Hiring DSP",
  "HIRING_MANAGER": "Hiring manager",
  "HIRING_TEAM": "Hiring Team",
  "HIRING_TEAM_MEMBERSHIP_MANAGED_BY_ATS": "Managed by your ATS",
  "HIRING_TEAM_ROLE_RECRUITER": "Recruiting Specialist",
  "HISTORY": "History",
  "HOME": "Home",
  "HOME_OFFICE_BALANCE": "Days at the office: {{office}} / Home: {{home}}",
  "HOURS": "hours",
  "HOURS_SHORTCODE": "hrs",
  "HOW_ENJOY": "How was your experience working with",
  "HOW_IT_WORKS": "How it works:",
  "IAM": " IAM",
  "IDEAL_CANDIDATE": "Ideal candidate",
  "INACTIVE": "Inactive",
  "INBOX_WITH_HIRING_TEAM": "Inbox with hiring team",
  "INDUSTRIES_LABEL": "Active in industry",
  "INDUSTRY_EXP": "(Industry) Experiences",
  "INFORMATION_CORRECT_TEXT": "You're about to introduce your candidate. Please check and if necessary change the pre-filled information to match the company's requirements. Once submitted, you are not able to change this information.\n\nNote; this is a submission form to a specific job, you are not changing the candidate default information. If you want to change the default information for this specific candidate, please click the \"edit candidate\" button below.",
  "INFORMATION_SAVE_SUCCESS": "Information was successfully saved.",
  "INFORMATION_UPDATED_SUCCESSFULLY": "Information updated successfully",
  "INHERITED_BADGE": "Inherited",
  "INSERT_HELP_CENTER_LINK": "Insert Help Center link",
  "INSERT_PLACEHOLDER": "Insert placeholder",
  "INSERT_PRODUCT_TOUR_LINK": "Insert product tour link",
  "INTERIM_TITLE": "Interim",
  "INTERVIEW": "Interview",
  "INTERVIEWER": "Interviewer",
  "INTERVIEWERS": "Match with interviewers",
  "INTERVIEW_HISTORY": "Candidate history",
  "INTERVIEW_INVITE": "Invite to interview",
  "INTERVIEW_INVITE_SENT": "Interview invitation was sent",
  "INTERVIEW_PROCESS": "Interview process",
  "INTERVIEW_STAGE": "Interview stage",
  "INTERVIEW_TEXT_CLIENT": "Use the chatbox to plan an interview date together with the agency and schedule it via the button below",
  "INTERVIEW_TEXT_RECRUITER": "Use the chatbox to plan an interview date together with the company and schedule it via the button below",
  "INTERVIEW_TOTAL": "Total within {{days}} days",
  "INTRODUCE": "Introduce candidate",
  "INTRODUCED": "Introduced",
  "INTRODUCING_AS_AGENCY_FOR_CLIENT": "Introducing as {{agencyCompany}} for {{client}}",
  "INTRODUCTIONS": "Introductions",
  "INTRODUCTION_FAILED": "Introduction Failed",
  "INTRODUCTION_RULE_1": "The candidate has provided consent for me to represent them for this job.",
  "INTRODUCTION_RULE_2": "The candidate has been informed about the company.",
  "INTRODUCTION_RULE_3": "The candidate wants to have an interview at this company for this job.",
  "INTRODUCTION_RULE_4": "The location of the company is okay for the candidate.",
  "INTRODUCTION_RULE_5": "The remuneration is within the range of the job details.",
  "INVALID_FILE_TYPE_CANDIDATE_CV": "Invalid file type. Only PDF, DOC, DOCX, and TXT files are allowed.",
  "INVALID_FILE_TYPE_CANDIDATE_DOCUMENT": "Invalid file type. Only PDF, DOC, DOCX, TXT, PNG, and JPG files are allowed.",
  "INVALID_FILE_TYPE_CV": "Invalid file type. Only PDF, DOCX, and TXT files are allowed for CV uploads.",
  "INVITATION_ACCEPTED_SUCCESS": "You are now a member of {{company}}",
  "INVITATION_DECLINED": "Invitation declined",
  "INVITATION_RESULTS": "Invitation Results",
  "INVITATION_SENT": "Invitation sent successfully",
  "INVITATION_SENT_TO": "Invitation sent to {{email}}",
  "INVITED_BY": "Invited by {{name}}",
  "INVITED_BY_CLIENT_NOTICE": "You were invited to HirePort by {{client}}. Colleagues you invite can collaborate with you on the jobs shared with your agency, if your customer allows this.",
  "INVITED_TO_JOIN_AS": "Invited to join as",
  "INVITE_ACCEPTED_SUCCESS": "Invite accepted! You can now introduce a candidate.",
  "INVITE_AGENCY": "Invite Agency",
  "INVITE_AGENCY_FAILED": "Failed to invite agency",
  "INVITE_AGENCY_INTRODUCED_STAGE_WARNING_DESC": "Agencies will not be able to introduce candidates until you connect at least one ATS stage to the \"Introduced\" HirePort stage in your ATS settings.",
  "INVITE_AGENCY_INTRODUCED_STAGE_WARNING_TITLE": "Agencies will not be able to introduce candidates yet",
  "INVITE_AGENCY_LIST": "Agency List",
  "INVITE_AGENCY_START_FAILED": "Failed to start invitation process",
  "INVITE_AGENCY_STEP_1": "Enter email addresses for the agency team you want to work with",
  "INVITE_AGENCY_STEP_2": "Name this group for your reference (e.g., \"Agency Paris\")",
  "INVITE_AGENCY_STEP_3": "Each person will be able to invite their own colleagues later",
  "INVITE_AGENCY_STEP_4": "All people in this group will have access to jobs you assign to them",
  "INVITE_AT_LEAST_ONE_EMAIL": "Please enter at least one email address",
  "INVITE_A_COLLEAGUE": "Invite a Colleague",
  "INVITE_COLLEAGUE": "Invite Colleague",
  "INVITE_COLLEAGUES_PROMPT": "You're currently the only member of your agency. Invite colleagues to share candidates.",
  "INVITE_COLLEAGUE_INFO": "Invite a colleague to join your agency. They will receive an email invitation and can accept or decline it.",
  "INVITE_COLLEAGUE_PROJECT_INFO": "Invite a colleague to this project. They keep their own agency and join this project as an extra membership after they accept.",
  "INVITE_COLLEAGUE_SELECT_PROJECTS_INFO": "Choose which projects to invite this colleague into. They will join each selected project after they accept.",
  "INVITE_EMAIL_DEFAULT_SUBJECT": "Please enter a subject on the left before saving the email",
  "INVITE_EMAIL_NAME_REQUIRED": "Please enter names for all email addresses",
  "INVITE_EMAIL_TEMPLATE_BODY_REQUIRED": "Body content is required.",
  "INVITE_EMAIL_TEMPLATE_LANGUAGE_LOCKED": "You need to reset the email template to change the language.",
  "INVITE_EMAIL_TEMPLATE_PREVIEW_FAILED": "Failed to render invite email preview.",
  "INVITE_EMAIL_TEMPLATE_RESET": "Invite email template reset to default.",
  "INVITE_EMAIL_TEMPLATE_RESET_FAILED": "Failed to reset invite email template.",
  "INVITE_EMAIL_TEMPLATE_SAVED": "Invite email template saved.",
  "INVITE_EMAIL_TEMPLATE_SAVE_FAILED": "Failed to save invite email template.",
  "INVITE_LINK_COPIED": "Invite link copied",
  "INVITE_LINK_FAILED": "Failed to copy invite link",
  "INVITE_MODAL_CONTINUE_BTN": "Start sourcing",
  "INVITE_MODAL_EMAIL": "Work email",
  "INVITE_MODAL_EXPLANATION": "You've been invited to help source candidates for this job. Please fill in your details so we can set up your account and keep you updated on your progress.",
  "INVITE_MODAL_TITLE": "You're invited to source candidates",
  "INVITE_SEND_NOTIFICATION": "Invite e-mail has been sent.",
  "INVITE_SENT": "Invite sent",
  "INVITE_SINGLE_AGENCY": "Single Agency",
  "INVITE_TO_COMPANY": "Invite to {{company}}",
  "INVITE_TO_PROJECT": "Invite to {{project}}",
  "INVITE_YOUR_FIRST_COLLEAGUE": "Invite Your First Colleague",
  "INVOICE": "Invoice",
  "INVOICE_AI_DRAFT_WARNING_MESSAGE": "This fee approval has not been reviewed or approved yet. Please verify the generated values and edit them if needed before approving.",
  "INVOICE_AI_DRAFT_WARNING_TITLE": "These values were generated automatically by AI",
  "INVOICE_APPROVED": "Fee Approved",
  "INVOICE_APPROVED_SUCCESS": "Fee Approval has been approved successfully",
  "INVOICE_APPROVED_SYSTEM_MESSAGE": "Fee Approval has been approved",
  "INVOICE_APPROVE_ERROR": "Failed to approve fee approval. Please try again.",
  "INVOICE_DISPUTED": "Fee Disputed",
  "INVOICE_DISPUTED_SUCCESS": "Fee Approval has been disputed successfully",
  "INVOICE_DISPUTED_SYSTEM_MESSAGE": "Fee Approval has been disputed",
  "INVOICE_DISPUTE_ERROR": "Failed to dispute fee approval. Please try again.",
  "INVOICE_FEE_STRUCTURE_FIXED_FEE": "Fixed Fee",
  "INVOICE_FEE_STRUCTURE_PERCENTAGE_OF_ANNUAL_SALARY": "Percentage of Annual Salary",
  "INVOICE_HISTORY": "Fee Approval History",
  "INVOICE_NOTIFICATION_RECIPIENTS": "Fee Approval Notification Recipients",
  "INVOICE_NOTIFICATION_RECIPIENTS_DESC": "Select which users receive system chat messages and notifications related to fee approvals. If no users are selected, notifications will be sent to all admins.",
  "INVOICE_NUMBER": "Fee Approval Number",
  "INVOICE_RATE_FREQUENCY_ONE_OFF": "One off",
  "INVOICE_RATE_FREQUENCY_PER_DAY": "Per day",
  "INVOICE_RATE_FREQUENCY_PER_HOUR": "Per hour",
  "INVOICE_RATE_FREQUENCY_PER_MONTH": "Per month",
  "INVOICE_RATE_FREQUENCY_PER_TWO_WEEKS": "Per two weeks",
  "INVOICE_RATE_FREQUENCY_PER_WEEK": "Per week",
  "INVOICE_RATE_FREQUENCY_PER_YEAR": "Per year",
  "INVOICE_REFERENCE": "Reference",
  "INVOICE_SNAPSHOT": "Fee Approval Snapshot",
  "IN_PROCESS": "In Process",
  "IN_PROCESS_AT": "In process at",
  "IN_PROCESS_FOR": "In process for",
  "IN_PROCESS_FOR_JOBS": "In process for job(s)",
  "IN_PROCESS_TITLE": "In process",
  "ITALIC": "Italic",
  "JOB": "Current job",
  "JOBS": "Jobs",
  "JOBS_VIEW_FILTER_IN_PROCESS": "Jobs with candidates in process",
  "JOBS_VIEW_FILTER_NOTIFICATIONS": "Jobs with notifications",
  "JOBS_VIEW_FILTER_TITLE": "Show",
  "JOB_ACTIVITY_FEED": "New activity on Job",
  "JOB_ASSIGNMENTS": "Job Assignments",
  "JOB_ATS_FIELD_HOURS_PER_WEEK": "Hours per week",
  "JOB_ATS_FIELD_SALARY_FROM": "Salary from",
  "JOB_ATS_FIELD_SALARY_TO": "Salary to",
  "JOB_CLOSED_FOR_NEW_CANDIDATES": "This job is no longer open for new candidates",
  "JOB_CODE": "Job code",
  "JOB_CUSTOM_RESTITUTION_AGREEMENT": "Restitution information",
  "JOB_DESCRIPTION": "Job description",
  "JOB_DESCRIPTION_2_SENTENCES": "Job description in 2 sentences",
  "JOB_DRAFT_SUCCESSFULLY_CREATED": "Job draft successfully created!",
  "JOB_EXCLUSIVITY_FOR_REPLACEMENT": "Exclusivity for replacement",
  "JOB_EXTENSION_FIELDS_DESC": "Add custom fields agencies must answer",
  "JOB_FAVORITE_REMOVE_TOOLTIP": "Stop notifications for this job",
  "JOB_FEE_DETAILS_PLACEHOLDER": "Enter fee details",
  "JOB_FIELD_SYNCED_FROM_ATS": "Synced from your ATS",
  "JOB_FIT": "Job fit",
  "JOB_INBOX": "Job Inbox",
  "JOB_INFO_FORM_ACTIVITY_HOURS_TOOLTIP": "Expected hours for this activity",
  "JOB_INFO_FORM_ACTIVITY_NAME_TOOLTIP": "Name of the activity",
  "JOB_INFO_FORM_BACKGROUND_IMAGE_TOOLTIP": "Background image for the job posting",
  "JOB_INFO_FORM_COMPANY_TOOLTIP": "Company offering this position",
  "JOB_INFO_FORM_CURRENT_PROJECTS_TOOLTIP": "Current projects the candidate will work on",
  "JOB_INFO_FORM_DAYS_AT_THE_OFFICE_TOOLTIP": "Expected days working at the office per week",
  "JOB_INFO_FORM_DAYS_WORKING_FROM_HOME_TOOLTIP": "Expected days working from home per week",
  "JOB_INFO_FORM_DEPARTMENT_TOOLTIP": "Department where this role belongs",
  "JOB_INFO_FORM_DESCRIPTION_TOOLTIP": "Detailed job description",
  "JOB_INFO_FORM_PROBLEM_DESCRIPTION_TOOLTIP": "Problem this role will solve",
  "JOB_INFO_FORM_REQUIRED_SENIORITY_TOOLTIP": "Required seniority level",
  "JOB_INFO_FORM_SHORT_DESCRIPTION_TOOLTIP": "Short job description",
  "JOB_INFO_FORM_SPECIALIZATION_TOOLTIP": "Specialization or focus area",
  "JOB_INFO_FORM_TITLE_TOOLTIP": "Enter the job title",
  "JOB_INFO_FORM_TOOLS_USED_TOOLTIP": "Tools and technologies used in this role",
  "JOB_INFO_FORM_TYPE_TOOLTIP": "Employment type (full-time, part-time, etc.)",
  "JOB_INFO_TITLE": "Job info",
  "JOB_IS_DELETED": "Job is deleted",
  "JOB_IS_ONHOLD": "Job is on hold",
  "JOB_IS_UNPUBLISHED": "Job is unpublished",
  "JOB_IS_UPDATED": "Job is updated",
  "JOB_OFFER_FORM_EXTRAS_TOOLTIP": "Additional benefits and perks",
  "JOB_OFFER_FORM_GROWTH_PATH_TOOLTIP": "Career growth opportunities",
  "JOB_ONLINE": "{{jobTitle}} job is now online!",
  "JOB_ON_HOLD": "Job on Hold",
  "JOB_OTHER_INFORMATION": "Other information",
  "JOB_PAYMENT_TERMS": "Payment terms",
  "JOB_PAYMENT_TERMS_START": "Payment terms start",
  "JOB_PIPELINE_PENDING_DESC": "You can view this job and work with candidates already in the pipeline, but you must accept the contract with this company before introducing new candidates.",
  "JOB_PIPELINE_PENDING_TITLE": "Contract not accepted yet",
  "JOB_PIPELINE_VIEW_ONLY_DESC": "You can still view it and continue working with candidates already in the pipeline, but you cannot introduce new candidates.",
  "JOB_POSTING_TYPE_INTERNAL": "Internal",
  "JOB_POSTING_TYPE_PRIVATE": "Private",
  "JOB_POSTING_TYPE_PUBLIC": "Public",
  "JOB_PROCESS_FORM_EXTRA_NOTES_TOOLTIP": "Additional notes about the process",
  "JOB_PROCESS_FORM_TOTAL_DURATION_TOOLTIP": "Total process duration",
  "JOB_PROFILE_FORM_IDEAL_CANDIDATE_TOOLTIP": "Description of the ideal candidate",
  "JOB_PROFILE_FORM_INDUSTRY_EXP_TOOLTIP": "Required industry experience",
  "JOB_PROFILE_FORM_KEY_SKILLS_TOOLTIP": "Key skills required",
  "JOB_PROFILE_FORM_LANGUAGES_TOOLTIP": "Required languages",
  "JOB_PROFILE_FORM_MIN_CERTIFICATES_TOOLTIP": "Minimum required certificates",
  "JOB_PROFILE_FORM_MIN_EDUCATION_TOOLTIP": "Minimum education level",
  "JOB_PROFILE_FORM_PREFERABLE_CERTIFICATES_TOOLTIP": "Preferred certificates",
  "JOB_PROFILE_FORM_PREFERABLE_EDUCATION_TOOLTIP": "Preferred education level",
  "JOB_PROFILE_FORM_PREFERABLE_LANGUAGE_TOOLTIP": "Preferred languages",
  "JOB_PROFILE_FORM_PREFERABLE_SKILLS_TOOLTIP": "Preferred skills",
  "JOB_PROFILE_FORM_RELOCATION_PACKAGE_TOOLTIP": "Relocation package available",
  "JOB_PROFILE_FORM_REMOTE_TITLE": "Remote working possibilities",
  "JOB_PUBLISHED": "New job is published",
  "JOB_REPLACEMENT_TIME": "Replacement time",
  "JOB_RESTITUTION": "Restitution",
  "JOB_RESTITUTION_PAYMENT_TERMS": "Payment terms restitution",
  "JOB_SCREENING_QUESTIONS": "Job Screening Questions",
  "JOB_SCREENING_QUESTIONS_VIEW_DESC": "These questions will be asked when agencies introduce candidates to this job. Questions are inherited from your company settings and the ATS. Dimmed questions will not appear for this job based on conditional logic rules.",
  "JOB_STATUS_PENDING": "Pending",
  "JOB_STATUS_PENDING_TOOLTIP": "Accept the contract with this company before you can introduce candidates to this job.",
  "JOB_STATUS_PLACEHOLDER": "e.g. Published",
  "JOB_STATUS_SET_PUBLISHED_SUCCESS": "Job published successfully",
  "JOB_STATUS_UNASSIGNED": "Unassigned",
  "JOB_TAGS": "Job tags",
  "JOB_TEAM_FORM_NUMBER_OF_PEOPLE_TOOLTIP": "Number of people in the team",
  "JOB_TEAM_FORM_OTHER_TEAM_ROLES_TOOLTIP": "Other roles in the team",
  "JOB_TEAM_FORM_SPOKEN_LANGUAGES_TOOLTIP": "Languages spoken in the team",
  "JOB_TEAM_FORM_TEAM_MEMBERS_NUM_TOOLTIP": "Total team size",
  "JOB_TITLE": "Job Title",
  "JOB_TITLE_OR_CODE_LABEL": "Job title or code",
  "JOB_TITLE_OR_CODE_PLACEHOLDER": "Enter job title or job code",
  "JOB_TITLE_PLACEHOLDER": "Filter by job title",
  "JOB_TYPE": "Job type",
  "JOB_TYPE_BADGE": "Job",
  "JOB_TYPE_CONSULTANCY": "External",
  "JOB_TYPE_INHOUSE": "Inhouse",
  "JOB_UNDER_REVIEW": "This job cannot be edited right now. Please send us a message in the bottom-right support chat to contact us.",
  "JOB_UPDATED": "Job successfully updated",
  "JUST_NOW": "just now",
  "KANBAN_COLUMN_LARGE_HINT": "Large column — consider filtering; use Load more to reveal additional cards.",
  "KANBAN_HIDE_STAGES_LABEL": "Visible stages",
  "KANBAN_HIDE_STAGES_PLACEHOLDER": "Select stages to show",
  "KANBAN_HIRED_TOOLTIP": "Hired Stage",
  "KANBAN_INTRODUCED_TOOLTIP": "Introduced Stage",
  "KANBAN_ITEM_TOOLTIP": "Click on candidate name for the candidate info, click elsewhere in the card for task overview",
  "KANBAN_OFFERED_TOOLTIP": "Offer Stage",
  "KANBAN_ON_HOLD_TOOLTIP": "On hold stage",
  "KANBAN_REJECTED_TOOLTIP": "Rejected Stage",
  "KANBAN_SOURCED_TOOLTIP": "Sourced Stage",
  "KANBAN_STAGE_TOOLTIP": "Interview Stage",
  "KEEP_EDITING": "Keep editing",
  "KEY_METRICS": "Key Metrics",
  "KEY_SKILLS": "Must haves",
  "KOMBO_LOGS": "Kombo Logs",
  "LANGUAGE": "Language",
  "LANGUAGES": "Minimum required language(s)",
  "LANGUAGE_LOCAL_ONLY_ADMIN": "Language preference updated locally only (admin cannot change company language while using 'login as')",
  "LANGUAGE_LOCKED": "Language is locked and protected from external changes",
  "LANGUAGE_UPDATED": "Language updated successfully",
  "LANGUAGE_UPDATE_FAILED": "Failed to update language",
  "LAST_MESSAGES_HEADER": "Last messages",
  "LAST_NAME_LABEL": "Last name",
  "LAST_UPDATED": "Last updated",
  "LAST_UPDATE_AFTER": "Last Update After",
  "LAST_UPDATE_BEFORE": "Last Update Before",
  "LATEST_CHANGES": "Latest changes",
  "LEAVE_EMPTY_FOR_NO_UPPER_LIMIT": "Leave empty for no upper limit",
  "LEAVE_FEEDBACK": "Please leave your feedback; it will help us improve our service.",
  "LEAVE_FEEDBACK_RATE": "Leave feedback",
  "LINKEDIN_LINK": "Linkedin profile link",
  "LINKEDIN_PROFILE": "Linkedin profile",
  "LISTS": "lists",
  "LIST_ASSIGNABLE_COUNT": "Assignable",
  "LIST_CREATED": "List created",
  "LIST_DELETED": "List deleted",
  "LIST_DELETE_FAILED": "Failed to delete list",
  "LIST_EMPTY_HINT": "This list has no members.",
  "LIST_MEMBERS": "Members",
  "LIST_MEMBER_PENDING_INVITE": "This agency is still being invited and cannot be assigned to the job yet.",
  "LIST_NAME": "List Name",
  "LIST_NAME_HINT": "This name is only visible to you for organizing your agency contacts",
  "LIST_NOT_ASSIGNABLE_HINT": "No members in this list can be assigned from here.",
  "LIST_RENAMED": "List renamed",
  "LIST_RENAME_FAILED": "Failed to rename list",
  "LIVES_IN": "Lives in",
  "LIVE_DATA": "Live Data",
  "LOADING": "Loading...",
  "LOADING_JOB_CONNECTION": "Loading job connection...",
  "LOADING_LANGUAGES": "Loading languages...",
  "LOADING_PERMISSIONS": "Loading permissions...",
  "LOAD_ALL": "Load all",
  "LOAD_MORE": "Load more",
  "LOCATION": "Location",
  "LOCATIONS": "Locations",
  "LOCATION_CITY_LABEL": "Location (City)",
  "LOCATION_CITY_PLACEHOLDER": "Search for a city",
  "LOCATION_DELETE_SUCCESS": "Location was successfully deleted.",
  "LOCATION_PLACEHOLDER": "e.g. Amsterdam",
  "LOGIN_BANNER_TEXT": "Agency portal",
  "LOGIN_TITLE": "Login",
  "LOGOUT": "Log out",
  "LOG_IN_TEXT": "Log in",
  "LOWERCASE_RULE": "This password must contain at least 1 lower case character.",
  "MAGIC_LINK_TITLE": "Send Magic Link",
  "MAKE_OFFER": "Make offer",
  "MALE_FEMALE_LABEL": "Male / female %",
  "MANAGE": "Manage",
  "MANAGED_BY": "Managed by {{company}}",
  "MANAGE_AGENCIES": "Manage Agencies",
  "MANAGE_LISTS": "Manage lists",
  "MANAGE_PROJECT_SETTINGS": "Manage project settings",
  "MARKETPLACE": "Marketplace",
  "MARK_ALL_READ": "Mark all read",
  "MARK_AS_READ": "Mark as read",
  "MASTER_CONTRACT_NAME": "Contract name",
  "MASTER_CONTRACT_TEMPLATE": "Master Contract Template",
  "MATCHING": "Matching criteria",
  "MATCH_WITH_COMPANY": "Match with company",
  "MATCH_WITH_ROLE": "Match with role",
  "MAX": "max",
  "MAX_FILES_REACHED": "Maximum number of files reached.",
  "MAX_LENGTH_RULE": "Input can not be more than {{number}} characters.",
  "MAYBE_LATER": "Maybe later",
  "ME": "me",
  "MEASURE_AVG": "Average",
  "MEASURE_COUNT": "Count",
  "MEASURE_COUNT_DISTINCT": "Count Distinct",
  "MEASURE_COUNT_UNIQUE": "Count Unique",
  "MEASURE_MAX": "Maximum",
  "MEASURE_MIN": "Minimum",
  "MEASURE_SUM": "Sum",
  "MEMBER": "Member",
  "MEMBER_ADDED": "Added to list",
  "MEMBER_REMOVED": "Removed from list",
  "MENU": "Menu",
  "MENU_ANALYTICS_TOOLTIP": "Analytics",
  "MENU_CALENDAR_TOOLTIP": "Calendar",
  "MENU_CONTRACTS": "Contracts",
  "MENU_DASHBOARD_TOOLTIP": "Dashboard",
  "MENU_MASTER_CONTRACTS_TOOLTIP": "Master Contracts",
  "MENU_MESSAGES_TOOLTIP": "Inbox",
  "MESSAGE": "Message",
  "MESSAGES_TITLE": "Messages",
  "MESSAGE_NOTIFICATION_HIRING_TEAM_ROLES": "Specific Hiring Team roles",
  "MESSAGE_NOTIFICATION_HIRING_TEAM_ROLES_DESC": "Choose which hiring team roles should be notified. If none are selected, no one will receive notifications.",
  "MESSAGE_NOTIFICATION_HIRING_TEAM_ROLES_SELECT": "Select Hiring Team Roles to Notify",
  "MESSAGE_NOTIFICATION_RECIPIENTS": "Email notification recipients for candidate related chat messages",
  "MESSAGE_NOTIFICATION_RECIPIENTS_DESC": "Control who receives email notifications for candidate related chat messages. Users will only receive emails if their role also allows email notifications in the Permissions tab.",
  "MESSAGE_NOTIFICATION_SPECIFIC_USERS": "Specific Users",
  "MESSAGE_NOTIFICATION_SPECIFIC_USERS_DESC": "Choose which team members should be notified. If none are selected, no one will receive notifications.",
  "MESSAGE_NOTIFICATION_SPECIFIC_USERS_SELECT": "Select Users to Notify",
  "MESSAGE_OPTIONAL": "Message (optional)",
  "MESSAGE_SENT_SUCCESS": "Message sent successfully",
  "MFA_APP_SETUP_INSTRUCTION": "Scan the QR code with your authenticator app (Authy, Google Authenticator, etc.), then enter the 6-digit code to complete setup.",
  "MFA_APP_SETUP_TITLE": "Set up authenticator app",
  "MFA_BACKUP_CODES_COPIED": "Backup codes copied to clipboard",
  "MFA_BACKUP_CODES_COPY": "Copy codes",
  "MFA_BACKUP_CODES_COPY_DONE": "Copied",
  "MFA_BACKUP_CODES_COPY_FAILED": "Could not copy. Please select the codes and copy manually.",
  "MFA_BACKUP_CODES_DOWNLOAD": "Download as text file",
  "MFA_BACKUP_CODES_DOWNLOADED": "Backup codes downloaded",
  "MFA_BACKUP_CODES_FILENAME": "hireport-backup-codes.txt",
  "MFA_BACKUP_CODES_FILE_INTRO": "Keep these codes somewhere safe. Each code can only be used once to log in if you lose access to your authenticator app.",
  "MFA_BACKUP_CODES_FILE_TITLE": "HirePort backup codes",
  "MFA_BACKUP_CODES_WARNING": "Store these codes somewhere safe. Each code can only be used once. If you lose access to your authenticator app, you can use one of these codes to log in.",
  "MFA_BACKUP_CODES_WARNING_TITLE": "Save your backup codes",
  "MFA_BACKUP_DONE_BUTTON": "I've saved my codes — continue",
  "MFA_BACK_TO_LOGIN": "Back to login",
  "MFA_CODE_LABEL": "Authentication code",
  "MFA_DEFERRED_BANNER": "Two-factor authentication is postponed until {{date}}. Set it up below before then.",
  "MFA_DISABLE_UNTIL_ENFORCE": "Turn off 2FA until {{date}}",
  "MFA_DISABLE_UNTIL_ENFORCE_CONFIRM_BUTTON": "Turn off until {{date}}",
  "MFA_DISABLE_UNTIL_ENFORCE_MODAL_TITLE": "Temporarily turn off 2FA",
  "MFA_ENABLE_BUTTON": "Enable two-factor authentication",
  "MFA_GRACE_BANNER_BODY": "You can temporarily turn off 2FA until {{date}}. Shared accounts still share one session — a colleague logging in no longer kicks you out, but logging out ends the session for everyone. Invite each person as their own user.",
  "MFA_GRACE_BANNER_TITLE": "Temporary opt-out available until {{date}}",
  "MFA_INVALID_CODE": "Invalid code. Please try again.",
  "MFA_MANUAL_ENTRY_LABEL": "Can't scan? Enter this key manually:",
  "MFA_METHOD_APP_ACTIVE_SUB": "Using Authy, Google Authenticator, or similar. Backup codes remaining: {{count}}",
  "MFA_METHOD_APP_INACTIVE_SUB": "Use Authy, Google Authenticator, or any TOTP app.",
  "MFA_METHOD_APP_TITLE": "Authenticator app",
  "MFA_METHOD_EMAIL_SUB": "A 6-digit code is sent to your email on every login.",
  "MFA_METHOD_EMAIL_TITLE": "Email verification code",
  "MFA_METHOD_ERROR": "Something went wrong. Please try again.",
  "MFA_OPTION_APP_SUB": "Use Authy, Google Authenticator, or any TOTP app",
  "MFA_OPTION_APP_TITLE": "Set up an authenticator app",
  "MFA_OPTION_EMAIL_SUB": "Send a 6-digit code to {{email}}",
  "MFA_POSTPONE_CTA": "I will set it up later",
  "MFA_POSTPONE_LOADING": "Continuing…",
  "MFA_QR_CODE_ALT": "MFA QR code",
  "MFA_REMOVE_APP": "Remove app",
  "MFA_REMOVE_APP_CONFIRMATION": "Enter your current authenticator code to remove the app. You will be logged out and asked to verify via email on your next login.",
  "MFA_REMOVE_APP_CONFIRM_BUTTON": "Remove & log out",
  "MFA_REMOVE_APP_MODAL_TITLE": "Remove authenticator app",
  "MFA_SECTION_TITLE": "Two-factor authentication",
  "MFA_SELECTION_DESCRIPTION": "Choose how you want to receive your verification code for this login.",
  "MFA_SELECTION_SETTINGS_HINT": "You can switch between email and app at any time in your profile settings.",
  "MFA_SELECTION_TITLE": "Verify your identity",
  "MFA_SETTINGS_SUBTITLE": "Choose how you verify your identity when logging in.",
  "MFA_SETTINGS_SUBTITLE_MANDATORY": "Two-factor authentication is mandatory for your account.",
  "MFA_SETUP_APP": "Set up app",
  "MFA_SETUP_DONE_TITLE": "Authenticator app enabled",
  "MFA_SETUP_EMAIL": "Set up email",
  "MFA_SETUP_ERROR": "Failed to load MFA setup. Please try again.",
  "MFA_SETUP_FAILED": "Setup failed. Please try again.",
  "MFA_SETUP_INSTRUCTION": "Scan the QR code below with your authenticator app (such as Google Authenticator or Authy), then enter the 6-digit code to complete setup.",
  "MFA_SETUP_TITLE": "Two-factor authentication setup",
  "MFA_SHARED_LOGIN_AFTERMATH": "After this date, the shared login will stop working, and anyone not yet invited individually will lose access.",
  "MFA_SHARED_LOGIN_DEADLINE": "⚠️ Send your list by {{date}}.",
  "MFA_SHARED_LOGIN_HELPDESK": "Helpdesk article",
  "MFA_SHARED_LOGIN_IGNORE": "(Already have separate logins for every user in your agency company? Ignore this message).",
  "MFA_SHARED_LOGIN_INTRO": "HirePort has turned on <bold>two-factor authentication (2FA)</bold>. Because 2FA is tied to one person, your team can no longer share a single login (a \"SPOC\" account) to work in your customers' HirePort accounts — <bold>everyone who needs access must have their own individual login.</bold>",
  "MFA_SHARED_LOGIN_STEP_1": "Make a list of <bold>every person at your agency</bold> who currently uses the shared login, or who needs access going forward.",
  "MFA_SHARED_LOGIN_STEP_2": "Full name + work email address for each person.",
  "MFA_SHARED_LOGIN_STEP_3": "Send that list to your contact at the customer, <bold>directly through the Agency Chat</bold> in HirePort.",
  "MFA_SHARED_LOGIN_STEP_4": "This is how the customer knows who to invite.",
  "MFA_SHARED_LOGIN_STEP_5": "Wait for your individual invite email, then log in and set up 2FA on your own device.",
  "MFA_SHARED_LOGIN_STEP_6": "Check your spam folder if it doesn't arrive",
  "MFA_SHARED_LOGIN_TITLE": "Your team's shared login is going away",
  "MFA_STAFF_APP_LOCKED": "Staff accounts must keep the authenticator app (also used for admin login).",
  "MFA_STATUS_DISABLED": "Disabled",
  "MFA_STEP_DESCRIPTION": "Enter the 6-digit code from your authenticator app, or use a backup code.",
  "MFA_STEP_EMAIL_DESCRIPTION": "We sent a 6-digit verification code to {{email}}. Enter it below to continue.",
  "MFA_SWITCH_EMAIL_CONFIRMATION": "Enter your current authenticator code to confirm. You will be switched to email-based verification and logged out to re-authenticate.",
  "MFA_SWITCH_EMAIL_CONFIRM_BUTTON": "Switch & log out",
  "MFA_SWITCH_EMAIL_MODAL_TITLE": "Switch to email verification",
  "MFA_SWITCH_TO_EMAIL": "Switch to email",
  "MFA_VERIFY_BUTTON": "Verify",
  "MFA_VERIFY_FAILED": "Verification failed. Please try again.",
  "MFA_YOUR_EMAIL": "your email",
  "MISSING_CV_INTRODUCE_WARNING": "This candidate has no CV. Clients often need a CV to review the introduction. You can still send the introduction or upload a CV from the candidate profile first.",
  "MONITORING_DATA_FETCH_ERROR": "Failed to fetch monitoring data",
  "MONITORING_DISMISSED_SECTION": "Hidden ({{count}})",
  "MONITORING_DISMISS_PROVIDER": "Dismiss provider",
  "MONITORING_END_DATE": "End date",
  "MONITORING_GENERATE_RECONNECT_LINK": "Generate a reconnect link",
  "MONITORING_NO_CANDIDATES_FOUND": "No candidates found",
  "MONITORING_NO_LOGS_YET": "No logs yet",
  "MONITORING_NO_MATCHING_LOGS": "No matching logs",
  "MONITORING_NO_OFF_SYNC_COMPANIES": "No off-sync companies",
  "MONITORING_NO_PROVIDERS_NEEDING_REAUTH": "No providers needing re-authentication",
  "MONITORING_OFF_SYNC_COMPANIES": "Off-sync companies",
  "MONITORING_OPEN_RECONNECT_LINK": "Open the reconnect link",
  "MONITORING_PROVIDERS_NEEDING_REAUTH": "Providers needing re-authentication",
  "MONITORING_PROVIDER_DISMISSED": "Provider hidden from view",
  "MONITORING_PROVIDER_DISMISS_ERROR": "Could not hide provider",
  "MONITORING_PROVIDER_UNDISMISSED": "Provider restored",
  "MONITORING_PROVIDER_UNDISMISS_ERROR": "Could not restore provider",
  "MONITORING_REAUTH_DAYS": "{{days}}d",
  "MONITORING_REAUTH_LAST_SYNC": "Last sync {{date}} (issue start unknown)",
  "MONITORING_REAUTH_LAST_SYNC_TOOLTIP": "{{timestamp}} (last sync time — exact issue start unknown for this provider)",
  "MONITORING_REAUTH_REASON_PASSTHROUGH": "ATS token",
  "MONITORING_REAUTH_REASON_SYNC": "Synchronize authentication",
  "MONITORING_REAUTH_SINCE": "Since {{date}}",
  "MONITORING_REAUTH_SINCE_DAYS": "Since {{date}} ({{days}} days)",
  "MONITORING_REAUTH_SINCE_ONE_DAY": "Since {{date}} (1 day)",
  "MONITORING_REAUTH_SINCE_TODAY": "Since {{date}} (today)",
  "MONITORING_RECONNECT_LINK_COPIED": "Reconnect link copied to clipboard",
  "MONITORING_RECONNECT_LINK_COPY_FAILED": "Link generated but couldn’t copy to clipboard",
  "MONITORING_RECONNECT_LINK_CREATED": "Reconnect link has been created",
  "MONITORING_RECONNECT_LINK_ERROR": "Unable to create reconnect link",
  "MONITORING_SEARCH_PLACEHOLDER": "Search logs…",
  "MONITORING_SELECT_ERROR_TYPES": "Select error types",
  "MONITORING_SORT_COMPANY_NAME": "Sort by company name",
  "MONITORING_SORT_NEWEST_FIRST": "Newest issue first",
  "MONITORING_SORT_OLDEST_FIRST": "Oldest issue first",
  "MONITORING_UNDISMISS_PROVIDER": "Restore",
  "MONITORING_VIEW_LOG": "View log",
  "MONTH": "month",
  "MONTHLY": "Monthly",
  "MONTHS": "months",
  "MORE_INFORMATION": "More information",
  "MORE_INFO_SOON": "More information will be added soon",
  "MOVEMENT_FULL_DETAIL_1": "✓ Recruiters can move and reject candidates",
  "MOVEMENT_FULL_DETAIL_2": "✓ Changes sync automatically to your ATS",
  "MOVEMENT_FULL_DETAIL_3": "⚠️ Your team will see all recruiter actions in your ATS",
  "MOVE_COLUMN_DOWN": "Move column down",
  "MOVE_COLUMN_UP": "Move column up",
  "MOVE_QUESTION_TITLE": "Warning; Open tasks or move to unexpected stage. Are you sure?",
  "MOVE_TEXT": "This action will automatically complete all the tasks associated with the current stage. This can not be undone. We will send an email to the agency about this action.",
  "MOVE_TEXT_RECRUITER": "This action will automatically complete all the tasks associated with the current stage. This can not be undone. We will send an email to the company about this action.",
  "MOVE_TITLE": "Move",
  "MOVE_TO_STAGE": "Move to stage",
  "MULTI_SELECT_OPTIONS_DESCRIPTION": "Define the options candidates can choose from (multiple selections allowed).",
  "MUST": "Must",
  "NAME_LABEL": "Name",
  "NATIONALITY_ARGENTINA": "Argentina",
  "NATIONALITY_AUSTRALIA": "Australia",
  "NATIONALITY_AUSTRIA": "Austria",
  "NATIONALITY_BELGIUM": "Belgium",
  "NATIONALITY_BRAZIL": "Brazil",
  "NATIONALITY_BULGARIA": "Bulgaria",
  "NATIONALITY_CANADA": "Canada",
  "NATIONALITY_CHINA": "China",
  "NATIONALITY_CROATIA": "Croatia",
  "NATIONALITY_CZECH_REPUBLIC": "Czech Republic",
  "NATIONALITY_DENMARK": "Denmark",
  "NATIONALITY_FINLAND": "Finland",
  "NATIONALITY_FRANCE": "France",
  "NATIONALITY_GERMANY": "Germany",
  "NATIONALITY_GREECE": "Greece",
  "NATIONALITY_HUNGARY": "Hungary",
  "NATIONALITY_INDIA": "India",
  "NATIONALITY_IRELAND": "Ireland",
  "NATIONALITY_ITALY": "Italy",
  "NATIONALITY_JAPAN": "Japan",
  "NATIONALITY_MEXICO": "Mexico",
  "NATIONALITY_NETHERLANDS": "Netherlands",
  "NATIONALITY_NEW_ZEALAND": "New Zealand",
  "NATIONALITY_NORWAY": "Norway",
  "NATIONALITY_POLAND": "Poland",
  "NATIONALITY_PORTUGAL": "Portugal",
  "NATIONALITY_ROMANIA": "Romania",
  "NATIONALITY_RUSSIA": "Russia",
  "NATIONALITY_SOUTH_AFRICA": "South Africa",
  "NATIONALITY_SOUTH_KOREA": "South Korea",
  "NATIONALITY_SPAIN": "Spain",
  "NATIONALITY_SWEDEN": "Sweden",
  "NATIONALITY_SWITZERLAND": "Switzerland",
  "NATIONALITY_TURKEY": "Turkey",
  "NATIONALITY_UKRAINE": "Ukraine",
  "NATIONALITY_UNITED_KINGDOM": "United Kingdom",
  "NATIONALITY_UNITED_STATES": "United States",
  "NEED_ACTION": "You need to take action",
  "NEGATIVE": "Negative",
  "NEGATIVE_DECISION": "End this process",
  "NEUTRAL": "Neutral",
  "NEW": "New",
  "NEW_CANDIDATE": "New candidate",
  "NEW_CANDIDATES": "New candidates",
  "NEW_COMPANIES": "New Company users",
  "NEW_CONTRACT_VERSION_MESSAGE": "The company has updated the contract terms. Please review and accept the new version.",
  "NEW_JOBS": "New Jobs",
  "NEW_MESSAGE": "New message",
  "NEW_MESSAGE_CANDIDATE": "New message · {{candidateName}}",
  "NEW_MESSAGE_CANDIDATE_JOB": "New message · {{candidateName}} · {{jobTitle}}",
  "NEW_NOTIFICATION": "New notification",
  "NEW_PASSWORD": "New password",
  "NEW_PASSWORD_SUCCESS": "Set new password",
  "NEW_RECRUITERS": "New Agency Users",
  "NEXT": "Next",
  "NEXT_MONTH": "Next month",
  "NO": "No",
  "NON_OPTIMIZED_TEXT": "The page you're viewing is designed for desktop. We're working hard on optimizing our platform for mobile. In the meantime, you can still use the platform, but the experience may differ from what you're used to.\n\nNote: The chat box is optimized for mobile, so you can always chat while on the go.",
  "NOT": "NOT",
  "NOTABLE_CLIENTS_LABEL": "Notable clients",
  "NOTE": "NOTE",
  "NOTE_VISIBILITY_IN_ATS": "Who Can See Notes",
  "NOTE_VISIBILITY_IN_ATS_DESC": "Control who in your company can see notes that HirePort adds. 'Always Public' = everyone sees them, 'Always Private' = Choose who can see them",
  "NOTIFICATION_TITLE": "Notifications",
  "NOTIFY_COMPANIES_QUESTION": "Would you like to notify these companies about the changes?",
  "NOTIFY_COMPANIES_SYSTEM_MESSAGE_EXPLANATION": "If you choose to notify, each company will receive a system manage in their agency chat with you, informing them of the profile update.",
  "NOTIFY_ME": "Notify me on jobs",
  "NOT_ACTUAL": "This link is expired",
  "NOT_APPLICABLE": "Not applicable",
  "NOT_APPLICABLE_TOOLTIP": "This question is not applicable to this job based on conditional logic rules (employment type, job type, or working type). You can modify these conditions in Agency Portal Settings → Screening Questions.",
  "NOT_ASSIGNED": "Not assigned",
  "NOT_CONNECTED": "Not connected",
  "NOT_CONNECTED_MESSAGE": "You have not connected your account to HirePort yet. Click",
  "NOT_FOUND": "We can't find the page you are looking for",
  "NOT_INVITED": "Not invited",
  "NOT_IN_A_LIST": "Not in a list",
  "NOT_SET": "Not set",
  "NOT_VALID_RULE": "Input is not valid",
  "NO_AGENCIES_IN_NETWORK": "No agencies in your network",
  "NO_AGENCY_LISTS": "No agency lists yet",
  "NO_AGREEMENT_INFO_AVAILABLE": "No agreement information available",
  "NO_ASSIGNMENTS_FOUND": "No job assignments found",
  "NO_ATS_JOBS_DESCRIPTION": "No ATS jobs available. Create at least one job in your ATS first.",
  "NO_ATS_JOBS_TITLE": "No ATS Jobs Available",
  "NO_ATTACHMENTS": "No attachments in this conversation.",
  "NO_AVAILABLE_COMPANY_DEFAULTS": "No company defaults available",
  "NO_CANDIDATE_FILES": "No CV or additional files.",
  "NO_CANDIDATE_YET": "There are no candidates yet",
  "NO_CHANGES_TO_SAVE": "No changes to save",
  "NO_COMPANIES_TO_NOTIFY": "This candidate has not been introduced to any companies yet.",
  "NO_COMPANY_DEFAULTS_YET": "No company defaults defined yet",
  "NO_CONTRACT": "Without contract",
  "NO_CONTRACTS_FOUND": "No contracts found",
  "NO_CONTRACT_DETAILS": "No contract details available.",
  "NO_CONTRACT_HISTORY": "No history available for this contract",
  "NO_CV_ATTACHED": "No CV attached",
  "NO_DATA": "No data",
  "NO_DATA_AVAILABLE": "No data available",
  "NO_DATA_TO_EXPORT": "No data available to export",
  "NO_EXTENSION_FIELDS": "No additional information fields defined",
  "NO_FEE_TAG": "No Fee Tag",
  "NO_FEE_TYPES_FILTER": "No fee types in this list",
  "NO_FILE": "No attached file yet",
  "NO_HISTORY": "No history yet",
  "NO_INVOICES_YET": "No fee approvals available yet",
  "NO_INVOICE_HISTORY": "No history available for this fee approval",
  "NO_JOBS_YET": "There are no jobs yet",
  "NO_JOB_EXTENSION_FIELDS_YET": "No additional information fields yet",
  "NO_LISTS": "No lists created yet",
  "NO_LISTS_HINT": "No lists yet. Create one to organize your agencies.",
  "NO_LISTS_YET": "No lists yet. Create a list from the toolbar or sidebar.",
  "NO_MATCHING_INVOICES": "No matching results found",
  "NO_MESSAGES_YET": "No messages yet",
  "NO_NEW_ANSWERS": "No new answers to submit",
  "NO_NOTIFICATIONS": "No new notifications",
  "NO_PDF": "No PDF",
  "NO_PERMISSION": "You do not have the right permissions to view this page.",
  "NO_PERMISSION_EDIT_AGENCIES": "You do not have permission to manage agencies",
  "NO_PERMISSION_REMOVE_AGENCIES": "You do not have permission to remove agencies",
  "NO_PROJECTS": "No projects yet",
  "NO_RELOCATION": "No relocation possible",
  "NO_RELOCATION_POSSIBLE": "No relocation",
  "NO_RESULT": "No results found",
  "NO_SCREENING_QUESTIONS": "No screening questions yet",
  "NO_SCREENING_QUESTIONS_YET": "No screening questions defined for this job yet.",
  "NO_SIMILAR_JOB": "No similar jobs yet",
  "NO_TAGS": "No Tags",
  "NO_TARGET": "No target",
  "NO_TEAM_MEMBERS": "No team members found",
  "NO_UNREAD_CONVERSATIONS": "No unread conversations",
  "NO_VISA_POSSIBLE_TEXT": "No visa sponsorship possible",
  "NUMBERED_LIST": "Numbers",
  "NUMBER_CONTAIN_RULE": "This password must contain at least 1 number.",
  "NUMBER_OF_PEOPLE": "Number of people",
  "NUMBER_OF_RATING": "Number of Ratings",
  "N_A": "N/A",
  "N_HOURS_AGO": "{{count}} hours ago",
  "N_MINUTES_AGO": "{{count}} minutes ago",
  "OBJECTS_COUNT": "Objects",
  "OFFER": "Offer",
  "OFFERED": "Offered",
  "OFFER_CONFIRM": "Offer is accepted",
  "OFFER_CONFIRMED": "Offer was confirmed",
  "OFFER_DETAILS": "Offer details",
  "OFFER_DISAGREE": "New offer is requested",
  "OFFER_MAKE": "New offer",
  "OFFER_REJECT": "Offer is rejected",
  "OFFER_REJECTED": "Offer rejected",
  "OFFER_SENT": "Offer was successfully sent",
  "OFFER_STAGE": "Offer stage",
  "OFFICE_LOCATIONS_LABEL": "Office locations",
  "OF_YEARLY_SALARY": "of yearly salary",
  "OK": "OK",
  "OK_TEXT": "Ok",
  "OLD_VERSION_INFO": "Historical version - view only",
  "ONLY_MY_INTERVIEWS": "Only my interviews",
  "ON_HOLD": "On hold",
  "ON_PLATFORM": "On platform since",
  "OPTIONAL_TEXT": "Optional",
  "OR": "OR",
  "OTHERS": "Others",
  "OTHER_AGENCIES": "All agencies",
  "OTHER_BENEFITS": "Other benefits",
  "OTHER_DATES": "Other dates",
  "OTHER_TEAM_ROLES": "Other team roles",
  "OVERALL_DECISION": "Overall decision",
  "OVERALL_RATING": "Overall rating",
  "OVERVIEW_CANDIDATES": "Overview Candidates",
  "OWN_SUPPLIER": "Contracted agency",
  "PAGINATION_INFO": "Showing {{start}} to {{end}} of {{total}} entries",
  "PARAGRAPH": "Paragraph",
  "PARTNER_PROGRAMS": "Partner programs",
  "PASSWORDS_DO_NOT_MATCH": "Passwords do not match",
  "PASSWORD_CHANGED_SUCCESS": "Password changed!",
  "PASSWORD_CHANGED_SUCCESS_2": "Your password has been changed successfully.",
  "PASSWORD_CONFIRM_LABEL": "Confirm password",
  "PASSWORD_HINT": "Password must contain special character, number and capital letter",
  "PASSWORD_LABEL": "Password",
  "PASSWORD_RULE": "Please input your password",
  "PASSWORD_SHORT_RULE": "This password is too short. It must contain at least 8 characters.",
  "PAST_DATE_RULE": "Date can not be in past",
  "PAUSED": "Paused",
  "PAUSED_ASSIGNMENT_TOOLTIP": "Job is offline - assignment will resume when job is published",
  "PDF_DOC_ACCEPTED": "PDF, DOC, DOCX accepted",
  "PENDING": "(pending)",
  "PENDING_ASSIGNMENT_CHANGES": "Pending assignment changes",
  "PENDING_CHANGES": "pending changes",
  "PENDING_INVITATIONS": "Pending Invitations",
  "PENDING_QUESTIONS": "These questions require your input",
  "PEOPLE": "People",
  "PERCENTAGE": "%",
  "PERFORMANCE_OF_AGENCIES_VS_YOUR_PERFORMANCE": "Performance of Agencies",
  "PERMANENT": "Permanent",
  "PERMISSIONS": "Permissions",
  "PERMISSIONS_UPDATED_SUCCESSFULLY": "Permissions updated successfully",
  "PERSONAL_INFO_TITLE": "Personal info",
  "PERSONAL_MESSAGE_PLACEHOLDER": "Add a personal message...",
  "PER_MONTH": "per month",
  "PHONE": "Phone",
  "PICK_PASSWORD_TITLE": "Pick a new password",
  "PL-300": "PL-300",
  "PLACE": "Place",
  "PLACEHOLDER_EMAIL": "name@company.com",
  "PLACEHOLDER_ENTER_ADDRESS": "Enter address...",
  "PLACEHOLDER_ENTER_AMOUNT": "Enter amount...",
  "PLACEHOLDER_ENTER_ANSWER": "Enter your answer...",
  "PLACEHOLDER_ENTER_NUMBER": "Enter number...",
  "PLACEHOLDER_ENTER_PERCENTAGE": "Enter percentage...",
  "PLACEHOLDER_FIELD_NAME": "driver_license",
  "PLACEHOLDER_PHONE": "+31 6 12345678",
  "PLACEHOLDER_SCREENING_QUESTION_EXAMPLE": "e.g., Do you have a driver's license?",
  "PLACEHOLDER_SELECT_OPTION": "Select an option...",
  "PLACEHOLDER_TYPE_OPTION": "Type option and press Enter",
  "PLACEHOLDER_URL": "https://example.com",
  "PLACEMENT_FEE": "Placement fee",
  "PLAN_INTERVIEW": "Plan interview",
  "PLEASE_ENTER_A_COMPANY_NAME": "Please enter a company name",
  "PLEASE_PROVIDE_DETAILS": "Please provide details",
  "PLEASE_SAVE_THE_FORM": "Please save the form before go next",
  "PLEASE_SELECT_JOB": "Please select a job first.",
  "PLEASE_SELECT_REASON": "Please select a reason",
  "PLUGIN_ASSIGN_JOB_NOT_FOUND_EMBED": "We couldn't find your job straight away. If you've only just created it, please wait a few minutes as it can take some time to fully connect.",
  "PLUGIN_ASSIGN_JOB_WAITING_EMBED": "Just sit back and relax - this page will automatically update once we've initialized your job.",
  "POINTS_LEFT": "Points left",
  "PORTAL_SETTINGS": "Agency Portal settings",
  "PORTAL_SETTINGS_NO_SEARCH_RESULTS": "No settings match your search",
  "PORTAL_SETTINGS_SEARCH_PLACEHOLDER": "Search settings…",
  "POSITION": "Position",
  "POSITIVE": "Positive",
  "POSITIVE_DECISION": "We'd like to proceed to the next stage",
  "PREFERABLE": "Preferable hard skills",
  "PREFERABLE_LANGUAGE": "Preferable Language (optional)",
  "PREFERABLE_SKILLS": "Preferable skills",
  "PREFERENCES_LABEL": "My preferences are relevant for",
  "PREFERENCES_TITLE": "Preferences",
  "PREFERENCE_RELEVANCE_INTERVAL": "HirePort preference relevance interval has expired",
  "PRESS_ENTER_TO_SEND": "Press Enter to send",
  "PREVENTION_LEVEL": "Prevention Level",
  "PREVIEW_AUTO_UPDATES": "Auto-updates",
  "PREVIEW_NOT_READY": "Preview is loading.",
  "PREVIEW_NOT_READY_DESC": "The live preview will appear automatically as you edit the subject and content.",
  "PREVIEW_UNAVAILABLE": "Preview unavailable",
  "PREVIOUS": "Previous",
  "PREVIOUS_MONTH": "Previous month",
  "PREVIOUS_VERSIONS": "Previous Versions",
  "PRIVACY_POLICY": "Privacy policy",
  "PRIVACY_TEXT_1": "These are the general terms and conditions of HirePort registered with the Chamber of Commerce under file number 72909056 with its registered office in Amsterdam. This Privacy Policy explains how we collect, use, share and protect data in relation to our website and services. We collect this data when you use our services or accept the 'cookies' on the website. We process personal data in a manner that is in accordance with the General Data Protection Regulation (the \"GDPR\"), the GDPR-based implementing legislation and other currently applicable privacy legislation.",
  "PRIVACY_TEXT_10": "Privacy agreement",
  "PRIVACY_TEXT_1_1": "Our Privacy Policy applies to anyone who directly or indirectly uses our services, visits the website, or has contact with HirePort regarding the services. By using our services, you understand and agree to the collection and use of information in accordance with this privacy policy.",
  "PRIVACY_TEXT_1_2": "If you are younger than 16 years old, you cannot use our website or the services offered as described in the general terms and conditions.",
  "PRIVACY_TEXT_2": "We collect personal data from everyone who has (had) direct or indirect contact with HirePort, including website visitors, users, forwarded candidates and contacts of our (business) partners.\nWe receive the data directly from you when you visit our website, create an account and fill in data, or information and data that arise from contact with HirePort personnel about our service and services. In some cases, we receive your data from third parties provided you have given these parties permission to share data.",
  "PRIVACY_TEXT_3_1": "1. We give you the option to register with HirePort for more information or to create a user account. We need some information to perform our services properly and correctly. As a result, we collect your name, e-mail address, telephone number, login details such as username and password, any employer, and any payment details. In addition, users are given the opportunity to provide HirePort with information about their organisation and vacancy. The data is used for sending messages, notifications, and important information about the HirePort service and service. We also collect data such as usage history and activities. We keep all this data for as long as this is necessary to continue to offer the service as well as possible. If you have not been logged in for 5 years, we will automatically delete all your data.",
  "PRIVACY_TEXT_3_2": "2. We collect information resulting from conversations, email exchanges, or chats with HirePort personnel. We also store data that arise from interaction with HirePort, or employees of HirePort, through social media channels. Phone calls may be recorded for training and analysis purposes. We collect this data to provide users, contacts and visitors with the best possible service and services. We keep this data for as long as necessary. If there is no interaction with HirePort for 3 years, the data will be automatically deleted.",
  "PRIVACY_TEXT_3_3": "3. We do our best to always improve our service and services. As a result, we analyse activities of website visitors, users of our services, or market analyses of third parties. To do this properly, we store data such as IP address, browser type, activities or other data provided by third parties, provided you have given permission for this. We never keep this data longer than is necessary to perform analyses to improve our business operations, service and services.",
  "PRIVACY_TEXT_3_4": "4. We collect data for marketing activities such as sending promotions, newsletters, advertisements, notifications or showing our proposition. For this we collect supplied data such as e-mail address, telephone number, IP address, browser activities or any information that has arisen from contact with employees of HirePort. Visitors who have agreed to the cookies on our website may see digital advertisements from HirePort. These specific marketing activities are based on data that is up to 2 years old. If you prefer not to receive this information, you can delete your cookies at any time via your browser, unsubscribe from these notifications via admin@hireport.io, or request HirePort to delete account data.",
  "PRIVACY_TEXT_3_5": "5. We collect data that is necessary for a correction (financial) administration. In addition to necessary personal data, you can also think of payment details such as bank account, credit card, invoices, account holders and payments. Given the nature of our work, HirePort is obliged to comply with a number of laws and regulations, including the prevention of fraud and money laundering. As a result, we also collect identification data such as a Chamber of Commerce extract, company data and official identification such as a passport or driver's license. We keep this data for as long as this is mandatory or necessary for optimal service.",
  "PRIVACY_TEXT_4_1": "HirePort engages external service providers to help with various activities. You can think of service providers that support customer service, digital services, advertising or marketing campaigns, research, communication, or financial administration. Sometimes they need personal data for this. We only share data that is necessary for the assignment that the external service provider performs for HirePort. We emphatically do not sell your data to third parties.",
  "PRIVACY_TEXT_4_2": "HirePort also uses Mollie (www.Mollie.com) for payment processing and financial administration. HirePort is hereby obliged to share personal data and payment details. If you use HirePort, you also agree to Mollie's terms and conditions and privacy policy, which can be found on the website (www.Mollie.com/privacy).\nHirePort may be required to share data with government agencies, or if directed by a government agency.",
  "PRIVACY_TEXT_5": "As stated in the general terms and conditions, users may share personal data and a candidate's résumé with other users if the candidate has given specific permission for this. Personally identifiable candidate data is not shared with third parties and is only accessible to the users the candidate has authorized. Personally identifiable candidate data is not for HirePort's own use and is not used for commercial purposes. Personally identifiable candidate data will be automatically deleted by HirePort after 13 months. Candidates can have their data removed earlier by emailing admin@hireport.io.",
  "PRIVACY_TEXT_6_1": "We store your data within the European Economic Area (EEA). Certain information we collect may be transferred to or stored at a destination outside the EEA, for example because one of our third-party service providers is based there. In this situation, we select service providers who handle your data in a secure manner.",
  "PRIVACY_TEXT_6_2": "We take measures to protect your personal data. For example, our systems have strict access control. The data is also only accessible to employees for whom it is necessary that they work with it. In addition, HirePort also has the security checked by external experts. If we pass data on to others in accordance with this policy, we require that this organisation treats your data with the same care.",
  "PRIVACY_TEXT_7": "In accordance with the GDPR and other relevant legislation, HirePort does not store personal data for longer than is necessary for the realisation of the purposes for which they are collected or processed, whether or not described in this policy.",
  "PRIVACY_TEXT_8_1": "If you want to review personal data, change or delete your data, or transfer all or part of your personal data to yourself or a third party, you can contact HirePort by emailing admin@hireport.io or by sending a letter to HirePort, Grote Bickersstraat 74-78, 1013 KS, Amsterdam.",
  "PRIVACY_TEXT_8_2": "If you object to the way in which we handle your data, you can submit a complaint to the Personal Data Authority.",
  "PRIVACY_TEXT_9": "HirePort may change or update this Privacy Policy from time to time. You are therefore advised to consult this Privacy Policy regularly. Amendments to this Privacy Policy take effect the moment they are published on our website.",
  "PRIVACY_TITLE_1": "Privacy Policy HirePort",
  "PRIVACY_TITLE_10": "Contact information",
  "PRIVACY_TITLE_2": "From whom do we process personal data and how do we obtain this data?",
  "PRIVACY_TITLE_3": "Which data do we process from you, what do we use it for and how long is it stored?",
  "PRIVACY_TITLE_4": "What data is shared and with whom?",
  "PRIVACY_TITLE_5": "Which candidate data do we process, why, and for how long?",
  "PRIVACY_TITLE_6": "Where do we store data and how is it secured?",
  "PRIVACY_TITLE_7": "Retention period",
  "PRIVACY_TITLE_8": "Right of access, corrections, right to object or right to data portability",
  "PRIVACY_TITLE_9": "Amendments",
  "PRIVATE_INTRO_NOTE_VISIBLE_TO": "Who Can See This Note",
  "PRIVATE_INTRO_NOTE_VISIBLE_TO_DESC": "Select the specific users who can see the private salary & benefits note. If no users are selected, no one will be able to see it.",
  "PRIVATE_INTRO_NOTE_VISIBLE_TO_ROLES_DESC": "Select the roles whose members can see the private salary & benefits note. If no roles are selected, no one will be able to see it.",
  "PRIVATE_JOB_MARKETPLACE_ALERT_DESC": "This is a private SmartRecruiters job. Screening questions and candidate consent are not supported when agencies introduce candidates to private jobs.",
  "PRIVATE_JOB_MARKETPLACE_ALERT_TITLE": "Private job limitations",
  "PROCEED_TITLE": "Proceed",
  "PROCESSING": "Processing...",
  "PROCESSING_INVITATIONS": "Processing invitations...",
  "PRODUCT_TOUR_LINK_MISSING_WARNING": "Product tour link required",
  "PRODUCT_TOUR_LINK_MISSING_WARNING_DESC": "Add a \"View product tour\" link before saving by clicking the \"View product tour\" button in the toolbar.",
  "PROFILE_IMAGE": "Profile image",
  "PROFILE_IMAGE_FORMAT": "PNG or JPG",
  "PROFILE_SETTINGS": "Profile settings",
  "PROJECT": "Project",
  "PROJECTS": "Projects",
  "PROJECTS_PAGE_SUBTITLE": "Your agency companies and the clients each one works with",
  "PROJECT_FOR_CLIENT": "Project {{agencyCompany}} at {{client}}",
  "PROJECT_SETTINGS": "Project settings",
  "PROPOSED_DATES": "Scheduled dates",
  "PROPOSE_DATE": "Schedule date",
  "PROPOSE_DATE_COMMENT": "Video URL or other comments",
  "PROPOSE_DATE_COMMENT_SUBHEADER": "Please do not forget to copy and paste the URL to an online meeting.",
  "PUBLISHED": "Published",
  "PUBLISH_TITLE": "Publish",
  "QUARTERLY": "Quarterly",
  "QUESTION_ADDED": "Question added to this job successfully",
  "QUESTION_DELETED": "Question deleted",
  "QUESTION_HIDDEN": "Question hidden from this job",
  "QUESTION_PREFILLED_TEXT": "I have a question about {{job}} vacancy from {{company}}",
  "QUESTION_READDED": "Question re-added to this job",
  "QUESTION_REMOVED_FROM_JOB": "Question removed from this job",
  "QUESTION_TEXT": "Question",
  "QUESTION_TYPE": "Question Type",
  "QUESTION_TYPE_ADDRESS": "Address",
  "QUESTION_TYPE_BOOLEAN": "Yes/No",
  "QUESTION_TYPE_CURRENCY": "Currency Amount",
  "QUESTION_TYPE_DATE": "Date",
  "QUESTION_TYPE_DATE_OF_BIRTH": "Date of Birth",
  "QUESTION_TYPE_DATE_RANGE": "Date Range",
  "QUESTION_TYPE_EMAIL": "Email Address",
  "QUESTION_TYPE_FILE": "File Upload",
  "QUESTION_TYPE_GENDER": "Gender",
  "QUESTION_TYPE_INFORMATION": "Information Only",
  "QUESTION_TYPE_MULTI_SELECT": "Multiple Choice",
  "QUESTION_TYPE_NATIONALITY": "Nationality",
  "QUESTION_TYPE_NUMBER": "Number",
  "QUESTION_TYPE_PERCENTAGE": "Percentage",
  "QUESTION_TYPE_PHONE": "Phone Number",
  "QUESTION_TYPE_SINGLE_SELECT": "Single Choice",
  "QUESTION_TYPE_TEXT": "Short Text",
  "QUESTION_TYPE_TEXT_MULTILINE": "Long Text",
  "QUESTION_TYPE_URL": "Website URL",
  "RA": "RA",
  "RATE_FREQUENCY": "Rate Frequency",
  "RATING": "Rating",
  "RATING_RESPONSES_ANONYMOUS": "rating responses are anonymous",
  "REASON": "Reason",
  "REASON_FOR_DISPUTE": "Reason for Dispute",
  "RECEIVING_CANDIDATES": "Source candidates",
  "RECRUITER": "Agency Recruiter",
  "RECRUITERS_CAN_HIRE": "Allow Marking Candidates as Hired",
  "RECRUITERS_CAN_HIRE_DESC": "Let agency recruiters mark candidates as hired. When disabled, only your team can do this.",
  "RECRUITERS_CAN_REJECT": "Allow Withdrawing and Rejecting Candidates",
  "RECRUITERS_CAN_REJECT_DESC": "Let agency recruiters withdraw their own candidates. Withdrawn candidates move to the Rejected stage, so this stage should not be hidden in the default stage settings. When a candidate is withdrawn or deleted from HirePort, they will also be rejected in your connected ATS.",
  "RECRUITERS_CAN_REJECT_DESC_RECRUITEE": "Let agency recruiters withdraw their own candidates. When a candidate is withdrawn or deleted in HirePort, they're automatically moved to the Withdrawn stage in Recruitee (if configured) or to Rejected otherwise. A note with the withdrawal reason is added to the candidate profile.",
  "RECRUITERS_CAN_REJECT_DESC_SMARTRECRUITERS": "Let agency recruiters withdraw their own candidates. When a candidate is withdrawn in HirePort, they're automatically moved to the Withdrawn stage in SmartRecruiters. When a candidate is deleted from HirePort, they're moved to the Rejected stage. A note with the withdrawal reason is added to the candidate profile in both cases.",
  "RECRUITERS_INVITE_LEADIN": "To continue your partnership with {{ company }}, please review and accept these terms:",
  "RECRUITERS_INVITE_PARTNERSHIP_ITEM_1": "All future collaboration will be through HirePort Portal",
  "RECRUITERS_INVITE_PARTNERSHIP_ITEM_2": "Your existing contract with {{ company }} remains unchanged",
  "RECRUITERS_INVITE_PARTNERSHIP_ITEM_3": "Submit candidates and manage process exclusively via this portal",
  "RECRUITERS_INVITE_PARTNERSHIP_TITLE": "Partnership Terms",
  "RECRUITERS_INVITE_TERMS_IMPORTANT": "<b>Important:</b> If you decline these terms, you will no longer be able to collaborate with {{ company }}. Candidates submitted outside of HirePort will not be reviewed or considered.",
  "RECRUITERS_INVITE_TERMS_INSTRUCTIONS_VIDEO": "Curious how it will work? <a>Click here</a>",
  "RECRUITERS_INVITE_TERMS_LABEL": "I accept these terms",
  "RECRUITERS_INVITE_TERMS_TITLE": "By clicking 'Accept', you agree to these terms for all future placements with {{ company }}.",
  "RECRUITERS_INVITE_TITLE": "Ready to accelerate your collaboration with {{ company }}? 🚀",
  "RECRUITERS_LISTING_TITLE": "All recruiters",
  "RECRUITERS_SELECT_LABEL": "Select agency recruiter name",
  "RECRUITER_AGREEMENT_WITH_CLIENT": "Agreement with this client",
  "RECRUITER_BULK_UPLOAD_BUTTON": "Upload Multiple Files",
  "RECRUITER_BULK_UPLOAD_BUTTON_HINT": "or drag & drop anywhere on this screen",
  "RECRUITER_BULK_UPLOAD_CSV_TEMPLATES_LABEL": "Download CSV Templates:",
  "RECRUITER_BULK_UPLOAD_CSV_TEMPLATE_BASIC": "Basic template (required fields only)",
  "RECRUITER_BULK_UPLOAD_CSV_TEMPLATE_FULL": "Complete template (all available fields)",
  "RECRUITER_BULK_UPLOAD_DESCRIPTION": "Supported formats: PDF, DOCX, TXT, CSV. Max file size: 10MB",
  "RECRUITER_BULK_UPLOAD_ERROR": "Error uploading files",
  "RECRUITER_BULK_UPLOAD_ERROR_CANDIDATE_EMAIL_NOT_FOUND": "the candidate's email could not be determined from the document",
  "RECRUITER_BULK_UPLOAD_ERROR_CANDIDATE_NAME_NOT_FOUND": "the candidate's name could not be determined from the document",
  "RECRUITER_BULK_UPLOAD_ERROR_CREATE_CANDIDATE_ERROR": "Failed to create candidate",
  "RECRUITER_BULK_UPLOAD_ERROR_EXTRACTION_ERROR": "candidate details could not be extracted from the document",
  "RECRUITER_BULK_UPLOAD_ERROR_INVALID_FILE": "the uploaded file is not valid",
  "RECRUITER_BULK_UPLOAD_ERROR_PARSE_ERROR": "there was a problem processing the document format",
  "RECRUITER_BULK_UPLOAD_ERROR_UNKNOWN_ERROR": "an unexpected error occurred while processing the file",
  "RECRUITER_BULK_UPLOAD_ERROR_UNSUPPORTED_FILE_FORMAT": "this file format is not supported",
  "RECRUITER_BULK_UPLOAD_ERROR_UPLOAD_ERROR": "the file could not be uploaded",
  "RECRUITER_BULK_UPLOAD_OR_LABEL": "Or upload files directly:",
  "RECRUITER_BULK_UPLOAD_RECAP_DESCRIPTION": "We have received the following files, make sure that all of them have been processed successfully",
  "RECRUITER_BULK_UPLOAD_RECAP_TITLE": "Bulk upload summary",
  "RECRUITER_BULK_UPLOAD_REMINDER": "<b>Bulk Upload:</b> Upload CV files (PDF, DOCX, TXT) or CSV files to quickly create multiple candidates.",
  "RECRUITER_BULK_UPLOAD_SUCCESS": "All files uploaded successfully",
  "RECRUITER_BULK_UPLOAD_TITLE": "Drop files to upload CVs or CSV",
  "RECRUITER_COMMENT": "Recruiter comment",
  "RECRUITER_COMPANY_SETTINGS": "Company settings",
  "RECRUITER_FEEDBACK": "Waiting for agency feedback",
  "RECRUITER_FEE_INFORMATION": "Fee Information",
  "RECRUITER_FROM": "Agency from",
  "RECRUITER_JOB_DETAILS": "Agency information",
  "RECRUITER_MANAGEMENT": "Agency management",
  "RECRUITER_MANAGEMENT_HIDE_EXTENDED_FIELDS": "Hide advanced settings",
  "RECRUITER_MANAGEMENT_SHOW_EXTENDED_FIELDS": "Advanced settings",
  "RECRUITER_NAME": "Agency recruiter name",
  "RECRUITER_OFFER_STAGE_TITLE_1": "The company will propose offer within {{ numberOfHours }} hours",
  "RECRUITER_OFFER_STAGE_TITLE_1_OUTDATED": "The company will propose offer",
  "RECRUITER_OFFER_STAGE_TITLE_2": "You have to accept the offer for your candidate",
  "RECRUITER_PERMISSIONS": "Agency Recruiter Permissions",
  "RECRUITER_STAGE_TASK_TITLE-1_2": "The company will choose 1 timeslot within {{ numberOfHours }} hours",
  "RECRUITER_STAGE_TASK_TITLE-1_2_OUTDATED": "The company will choose 1 timeslot",
  "RECRUITER_STAGE_TASK_TITLE-3": "Your candidate will have their {{ currentStageName }} on {{ dateTime }}",
  "RECRUITER_STAGE_TASK_TITLE-3_ATS": "Your candidate will have “{{interviewTitle}}” on {{dateTime}}",
  "RECRUITER_STAGE_TASK_TITLE-3_DISABLED": "Your candidate will have their interview",
  "RECRUITER_STAGE_TASK_TITLE-4-SIMPLE": "The company will provide you with feedback",
  "RECRUITER_STAGE_TASK_TITLE-4_AFTER": "The company will provide you with feedback within {{ numberOfHours }} hours after the interview",
  "RECRUITER_STAGE_TASK_TITLE-4_OUTDATED": "The company should have provided feedback",
  "RECRUITER_STAGE_TASK_TITLE-5-SIMPLE": "You have to provide feedback",
  "RECRUITER_STAGE_TASK_TITLE-5_AFTER": "You have to provide feedback within {{ numberOfHours }} hours after the interview",
  "RECRUITER_STAGE_TASK_TITLE-5_OUTDATED": "You should have provided feedback",
  "RECRUITER_STAGE_TASK_TITLE-6": "When both side are positive, your candidate is ready for the next interview stage",
  "RECRUITER_TITLE": "Agency Recruiter",
  "RECRUITER_TYPE": "Agency Type",
  "REDIRECTING_TO": "Redirecting to",
  "REDO": "Redo",
  "REGIONS_LABEL": "Region",
  "REJECTED": "Rejected",
  "REJECTED_BY_RECRUITER": "Rejected by agency",
  "REJECTION_FEEDBACK": "Rejection feedback",
  "REJECT_ALL_AND_REMOVE": "Reject all & remove agencies",
  "REJECT_CANDIDATE": "Reject candidate",
  "REJECT_OFFER": "Reject offer",
  "RELATIONSHIP": "Relationship",
  "RELOAD_PAGE": "Reload page",
  "RELOCATION": "Relocation",
  "RELOCATION_PACKAGE": "Relocation package",
  "RELOCATION_REQUIREMENTS": "Relocation requirements",
  "REMIND_ME_IN_1_DAY": "Remind me in 1 day",
  "REMOTE_NOT_POSSIBLE_TEXT": "Remote working not possible",
  "REMOVE": "Remove",
  "REMOVE_ASSIGNMENT": "Remove Assignment",
  "REMOVE_ASSIGNMENT_CONFIRM_MESSAGE": "Are you sure you want to remove {{recruiter}} from \"{{job}}\"?",
  "REMOVE_COLLEAGUE_FROM_PROJECT": "Remove colleague from project?",
  "REMOVE_COLLEAGUE_FROM_PROJECT_DESC": "Remove {{name}} from this project? They will lose access granted through this project.",
  "REMOVE_DEMO_DATA": "Remove demo data",
  "REMOVE_FROM_LIST": "Remove from list",
  "REMOVE_MAPPING": "Remove mapping",
  "REMOVE_MEMBER_FAILED": "Failed to remove from list",
  "REMOVE_SCHEDULE": "Remove Schedule",
  "RENAME_LIST": "Rename list",
  "REQUEST_OFFER": "Request a new offer",
  "REQUIRED": "Required",
  "REQUIRED_COMPETENCIES": "Required competencies",
  "REQUIRED_FIELD": "This field is required",
  "REQUIRED_SENIORITY": "Required seniority",
  "RESCHEDULE_BUTTON_TEXT": "Reschedule",
  "RESCHEDULE_CONFIRM_TITLE": "Change this date?",
  "RESCHEDULE_POPUP_TEXT": "Please use the chatbox to discuss a new date with the client/agency first before changing the date here. All changes are permanent",
  "RESEND_INVITE": "Resend invite",
  "RESEND_INVITE_EMAIL": "Resend invite email",
  "RESEND_OFFER": "Resend offer",
  "RESET": "Reset",
  "RESET_INVITE_EMAIL_TEMPLATE": "Reset invite email template?",
  "RESET_INVITE_EMAIL_TEMPLATE_DESC": "This removes your custom invite email and switches future invites back to the default company-language template.",
  "RESET_LAYOUT": "Reset layout",
  "RESET_PASSWORD_SUCCESS_TEXT_1": "We sent a message to",
  "RESET_PASSWORD_SUCCESS_TEXT_2": "so you can pick a new password.",
  "RESET_PASSWORD_TEXT": "Enter the email address you used when you signed up. We'll send you a link to create a new password.",
  "RESET_PASSWORD_TITLE": "Reset password",
  "RESET_TO_DEFAULT": "Reset to default",
  "RESET_ZOOM": "Reset zoom",
  "RESPONDENT_DECISION": "Respondent's decisions",
  "RESTRICT_CHATS_TO_HIRING_TEAM": "Restrict agency inbox chats to the hiring team",
  "RESTRICT_CHATS_TO_HIRING_TEAM_DESC": "When enabled your users only see candidate chats and job chats when on the hiring team",
  "RESULTS": "results",
  "RETRY": "Retry",
  "REVIEW": "Review",
  "REVIEW_OFFER_TASK": "Review offer",
  "RM_ACCESS_SOURCES": "Access sources",
  "RM_ACCESS_SOURCE_DIRECT": "Direct assignment",
  "RM_ACCESS_SOURCE_LIST_COMPANY": "Via list {{name}} (agency company)",
  "RM_ACCESS_SOURCE_LIST_USER": "Via list {{name}}",
  "RM_ACCESS_SOURCE_WHOLE_COMPANY": "Via agency company {{name}}",
  "RM_ADD_AGENCY_COMPANY_CHOICE_DESC": "Create a client-owned agency company to group users",
  "RM_ADD_AGENCY_COMPANY_TO_LIST": "Add agency company to list",
  "RM_ADD_AGENCY_LIST_CHOICE_DESC": "Add multiple agency users from a curated list",
  "RM_ADD_AGENCY_USERS_CHOICE_DESC": "Invite one or more agency users and assign an agency company",
  "RM_AGENCY_COMPANIES_EMPTY": "No agency companies yet",
  "RM_AGENCY_COMPANIES_TAB": "Agency companies",
  "RM_AGENCY_COMPANY": "Agency company",
  "RM_AGENCY_COMPANY_ACCESS_WARNING": "New members added to an agency company by the agency automatically get access to every job this agency company is assigned to, directly or through a list.",
  "RM_AGENCY_COMPANY_ARCHIVED": "Agency company archived",
  "RM_AGENCY_COMPANY_CREATED": "Agency company created",
  "RM_AGENCY_COMPANY_NAME_HINT": "Agency users in this agency company can see this name.",
  "RM_AGENCY_COMPANY_NO_MEMBERS": "No members in this agency company",
  "RM_AGENCY_COMPANY_UPDATED": "Agency company updated",
  "RM_AGENCY_USERS_TAB": "Agency users",
  "RM_ALL_AGENCIES_DESC": "Browse and assign agencies individually.",
  "RM_APPLY_CONFIRM_AGENCIES_TO_ADD": "Agencies to be added",
  "RM_APPLY_CONFIRM_AGENCIES_TO_REMOVE": "Agencies to be removed",
  "RM_APPLY_CONFIRM_FUTURE_MEMBERS_NOTE": "Agencies added to these lists later will automatically gain access to this job.",
  "RM_APPLY_CONFIRM_LISTS_ASSIGN": "Lists to assign (auto-sync future members)",
  "RM_APPLY_CONFIRM_LISTS_REMOVE": "Lists to remove from job",
  "RM_APPLY_CONFIRM_MEMBER_COUNT": "{{count}} agencies",
  "RM_APPLY_CONFIRM_REMOVAL_AGENCIES": "{{count}} agency/agencies",
  "RM_APPLY_CONFIRM_REMOVAL_DESC": "{{summary}} will be unassigned and can no longer work on this job until reassigned.",
  "RM_APPLY_CONFIRM_REMOVAL_LISTS": "{{count}} list(s)",
  "RM_APPLY_CONFIRM_REMOVAL_TITLE": "Some agencies will lose access to this job",
  "RM_APPLY_CONFIRM_TITLE": "Confirm assignment changes",
  "RM_APPLY_CONFIRM_UNKNOWN_AGENCY": "Unknown agency",
  "RM_ARCHIVE_AGENCY_COMPANY": "Archive",
  "RM_ARCHIVE_AGENCY_COMPANY_DESC": "Archive {{name}}? This is only allowed when the company has no members.",
  "RM_ARCHIVE_AGENCY_COMPANY_TITLE": "Archive agency company?",
  "RM_ASSIGNMENT_HINT": "Select agencies or lists to give them access to this job. Deselect assigned agencies to remove access. Nothing changes until you click Apply changes, and removals require confirmation.",
  "RM_BROWSE_TAB_AGENCY_USERS_DESC": "Every agency contact in your network, with their own contract and list membership.",
  "RM_BROWSE_TAB_COMPANIES_DESC": "Agency companies group users from the same agency, and agencies see each one as a project. Members share the company's job access and contract terms. New members automatically get every job the company is assigned to, directly or through a list.",
  "RM_BROWSE_TAB_LISTS_DESC": "Lists are your private way to organise agencies. Agencies never see your lists, and each agency keeps its own contract. Assign a list to a job to give every agency in it access at once.",
  "RM_CREATE_AGENCY_COMPANY": "Create agency company",
  "RM_CREATE_AGENCY_COMPANY_NAMED": "Create agency company \"{{name}}\"",
  "RM_INDIVIDUAL_AGENCIES_TAB": "Individual contacts",
  "RM_LIST_AGENCY_COMPANIES": "Agency companies in this list",
  "RM_LIST_ASSIGNED_TO_JOB": "List assigned to job",
  "RM_LIST_PARTIAL_DESELECT_WARNING": "You are now assigning individual agencies instead of the whole list. Future list members will not be assigned automatically.",
  "RM_LIST_SELECTION_SUMMARY": "{{count}} agencies · {{selected}} selected",
  "RM_MANAGE_AGENCY_COMPANIES": "Manage agency companies",
  "RM_MARKED_AS_REVIEWED": "Marked as reviewed",
  "RM_MARK_AS_REVIEWED": "Mark as reviewed",
  "RM_MIXED_DOMAINS_WARNING": "Selected users have mixed email domains. Confirm to continue — members share candidates.",
  "RM_MOVED_TO_AGENCY_COMPANY": "Moved to agency company",
  "RM_MOVE_PREVIEW_BODY": "{{moved}} moved · {{jobsGained}} jobs gained · {{jobsLost}} jobs lost · {{resets}} acceptance resets",
  "RM_MOVE_PREVIEW_TITLE": "Preview of membership change",
  "RM_MOVE_TO_AGENCY_COMPANY": "Move to agency company",
  "RM_MOVE_TO_AGENCY_COMPANY_DESC": "Move {{count}} selected agency user(s) into an agency company.",
  "RM_PENDING_ASSIGNMENT": "Will assign",
  "RM_PENDING_REMOVAL": "Will remove",
  "RM_PREVIEW_MOVE": "Preview",
  "RM_REMOVED_AGENCY_COMPANY_FROM_LIST": "Agency company removed from list",
  "RM_REMOVE_AGENCY_COMPANY_FROM_LIST": "Remove agency company from list",
  "RM_RENAME_AGENCY_COMPANY": "Rename",
  "RM_SELECT_AGENCY_COMPANY": "Select agency company",
  "RM_SELECT_ALL_IN_LIST": "Select all in list ({{count}})",
  "RM_SELECT_ALL_IN_LIST_PARTIAL": "{{skipped}} could not be selected because they are still being invited. {{selected}} available agencies selected.",
  "RM_SELECT_OR_CREATE_AGENCY_COMPANY": "Select or create an agency company",
  "RM_SET_AGENCY_COMPANY_ALIAS": "Set display name",
  "RM_TERMS_MANAGED_BY_AGENCY_COMPANY": "Terms for this user are managed by their agency company and cannot be edited individually.",
  "RM_TOOLBAR_SCHEDULED": "Scheduled",
  "RM_TO_ASSIGN_COUNT": "{{count}} to assign",
  "RM_TO_REMOVE_COUNT": "{{count}} to remove",
  "RM_USER_CREATED": "User created",
  "ROLE": "Role",
  "ROLES": "Roles",
  "SALARY_FEE_BRACKETS": "Salary fee brackets",
  "SALARY_FEE_BRACKETS_BRACKET_INVALID": "Bracket {{index}} is invalid. Remove it and add it again.",
  "SALARY_FEE_BRACKETS_FEE_NON_NEGATIVE": "Fee percentage for bracket {{index}} cannot be negative.",
  "SALARY_FEE_BRACKETS_FEE_REQUIRED": "Enter a fee percentage for bracket {{index}}.",
  "SALARY_FEE_BRACKETS_FINAL_OPEN_ENDED": "The last salary bracket must have no upper limit.",
  "SALARY_FEE_BRACKETS_GAP": "Bracket {{index}} starts after the previous bracket ends. Remove the gap between the ranges.",
  "SALARY_FEE_BRACKETS_LIST_INVALID": "Enter the salary fee brackets in the expected format.",
  "SALARY_FEE_BRACKETS_MAX_GREATER_THAN_MIN": "Salary to for bracket {{index}} must be greater than salary from.",
  "SALARY_FEE_BRACKETS_MAX_INVALID": "Enter a valid salary to value for bracket {{index}}, or leave it empty.",
  "SALARY_FEE_BRACKETS_MIN_NON_NEGATIVE": "Salary from for bracket {{index}} cannot be negative.",
  "SALARY_FEE_BRACKETS_MIN_REQUIRED": "Enter a salary from value for bracket {{index}}.",
  "SALARY_FEE_BRACKETS_ONLY_LAST_OPEN_ENDED": "Only the last salary bracket can have no upper limit.",
  "SALARY_FEE_BRACKETS_OVERLAP": "Bracket {{index}} overlaps the previous bracket. Adjust the ranges so they do not overlap.",
  "SALARY_FEE_BRACKETS_START_AT_ZERO": "The first salary bracket must start at 0.",
  "SALARY_FROM_PLACEHOLDER": "From",
  "SALARY_RANGE_LABEL": "Salary range",
  "SALARY_RATE": "Salary / Rate",
  "SALARY_TITLE": "Salary",
  "SALARY_TO_PLACEHOLDER": "To",
  "SAP-EAM": "SAP-EAM",
  "SAVE": "Save",
  "SAVED_SUCCESSFULLY": "Saved successfully",
  "SAVE_AND_NOTIFY": "Yes, Notify Companies",
  "SAVE_AND_PREVIEW_DRAFT_TITLE": "Save and preview",
  "SAVE_TEMPLATE": "Save Template",
  "SAVE_TITLE": "Save Changes",
  "SAVE_WITHOUT_NOTIFY": "No, Don't Notify",
  "SCHEDULE": "Schedule",
  "SCHEDULED_ACCESS": "Scheduled access",
  "SCHEDULE_ACCESS": "Schedule Access",
  "SCHEDULE_ACCESS_DESC": "Set a date when this job will become visible to the agency.",
  "SCHEDULE_NEW_ASSIGNMENTS": "Schedule New Assignments",
  "SCHEDULE_REQUIRES_NEW_ASSIGNS": "Select agencies that are not yet assigned to set access dates. To schedule a whole list, use Assign list to job in List view.",
  "SCHEDULE_UPDATED": "Schedule updated",
  "SCHEDULE_UPDATE_FAILED": "Failed to update schedule",
  "SCREENING_ANSWERS": "Screening answers",
  "SCREENING_BRANCH_SUMMARY": "Shown when \"{{parent}}\" is {{answers}}",
  "SCREENING_QUESTIONS": "Screening Questions",
  "SCREENING_QUESTIONS_DESCRIPTION": "Define additional screening questions (not imported from your ATS) that will be automatically applied to all new jobs. These can be customized per job if needed. Adding a question here will show this to the agency to fill in, so not to your direct candidates in the ATS.",
  "SCREENING_QUESTIONS_INTRO_HINT": "Please answer the following questions.",
  "SCREENING_QUESTION_CREATED": "Screening question created successfully",
  "SCREENING_QUESTION_DELETED": "Screening question deleted successfully",
  "SCREENING_QUESTION_ORDER_SAVED": "The screening questions order was saved successfully",
  "SCREENING_QUESTION_UPDATED": "Question updated successfully",
  "SCROLL_TO_QUESTIONS": "Go to questions",
  "SDN": " SDN",
  "SEARCH_AGENCIES_PLACEHOLDER": "Search by name, email or company name",
  "SEARCH_ASSIGNMENTS": "Search agencies, jobs...",
  "SEARCH_CONVERSATIONS": "Search by job name, company name, etc...",
  "SEARCH_CONVERSATIONS_BY_JOB_AND_AGENCY": "Search by job name, agency name, etc...",
  "SEARCH_JOBS": "Search jobs…",
  "SEARCH_PLACEHOLDER": "Search...",
  "SECONDMENT": "Secondment",
  "SEE_LESS": "See less",
  "SEE_MORE": "See more",
  "SELECTION_COUNT": "{{count}} selected",
  "SELECTION_NONE": "None",
  "SELECTION_SELECT_ALL": "Select all",
  "SELECT_AGENCIES_FIRST": "Select agencies first",
  "SELECT_ATS_STAGES": "Select ATS stages...",
  "SELECT_AT_LEAST_ONE_PROJECT": "Select at least one project",
  "SELECT_CLIENT_PROFILE_PLACEHOLDER": "Select a client profile",
  "SELECT_CONVERSATION": "Select a conversation to view messages",
  "SELECT_DATE": "Select date",
  "SELECT_DECISION": "Select",
  "SELECT_GENDER": "Select gender",
  "SELECT_JOB_FOR_DEMO": "Select the job you want demo candidates for:",
  "SELECT_NATIONALITY": "Select nationality",
  "SELECT_OR_ADD_PLACEHOLDER": "Select or type to add",
  "SELECT_OR_CREATE_LIST": "Select a list or type to create one",
  "SELECT_PROFILE_MESSAGE": "You have access to multiple client profiles. Please select one to continue.",
  "SELECT_PROFILE_TITLE": "Select Profile",
  "SELECT_PROJECTS": "Select projects",
  "SELECT_REASON": "Select a reason",
  "SELECT_RECRUITER_COMPANY": "Select agency",
  "SELECT_ROLE": "Select role",
  "SELECT_STAGES_TO_MAP": "Select stages to map",
  "SELECT_STATUSES": "Select statuses...",
  "SELECT_SYSTEM_ROLE": "Select system role",
  "SELECT_USERS": "Select Users",
  "SELECT_USER_ROLES": "Select User Roles",
  "SELECT_WORKSPACE_SETTINGS_HINT": "Choose a workspace in the header to view and manage these settings.",
  "SELECT_WORKSPACE_TO_CONTINUE": "Select a workspace to continue",
  "SELECT_WORKSPACE_TO_CREATE_CANDIDATE": "Select a workspace before creating a candidate",
  "SEND": "Send",
  "SEND_INVITATION": "Send Invitation",
  "SEND_INVITE": "Send invite",
  "SEND_INVITE_EMAIL": "Send invite email",
  "SEND_MESSAGE": "Send Message",
  "SEND_OFFER": "Send offer",
  "SEND_PRIVATE_EMPLOYMENT_DETAILS_NOTE": "Create Salary & Benefits Note on Introduction",
  "SEND_PRIVATE_EMPLOYMENT_DETAILS_NOTE_DESC": "When agencies introduce candidates, automatically create a note with salary and benefits information.",
  "SEND_PRIVATE_EMPLOYMENT_DETAILS_NOTE_SR_DESC": "When agencies introduce candidates, automatically create a note with salary and benefits information. Note: this note will be visible to all ATS users who have access to the candidate profile.",
  "SEND_REASON": "Confirm rejection",
  "SENIORITY_LABEL": "Seniority",
  "SENIORITY_PLACEHOLDER": "Select seniority",
  "SETTINGS_SAVED": "Settings were successfully saved",
  "SETTINGS_TITLE": "Settings",
  "SETTINGS_UPDATED_SUCCESSFULLY": "Settings updated successfully",
  "SET_JOB_ONLINE": "Set online",
  "SET_NEW_DATE_TITLE": "Set new date",
  "SET_STATUS": "Set status",
  "SHOWN_IN_FORM": "question shown in introduction form",
  "SHOW_COLLEAGUE_INTERVIEWS": "Show colleagues' interviews",
  "SHOW_LESS": "Show less",
  "SHOW_MORE": "Show more",
  "SHOW_MORE_MEMBERS": "+{{count}} more",
  "SHOW_ONLY_COMPANY_NAMES_IN_CHAT": "Hide Individual Agency Recruiter Names",
  "SHOW_ONLY_COMPANY_NAMES_IN_CHAT_DESC": "Show only agency names in chat instead of individual agency recruiter names. Your team won't see who specifically is working on the candidate.",
  "SHOW_QUESTION_ONLY_WHEN": "Show this question only when...",
  "SHOW_TOP_10_ONLY": "Show top 10 only",
  "SIGN_UP_PRIVACY_ACCEPT": "I accept the terms and <a>privacy policy</a>.",
  "SIGN_UP_TITLE": "Sign Up",
  "SIMILAR_JOBS": "Similar jobs",
  "SINCE": "since",
  "SINGLE_SELECT_OPTIONS_DESCRIPTION": "Define the options candidates can choose from (one option only).",
  "SKILLS": "Skills",
  "SKILL_LABEL": "Skill Search",
  "SKILL_PLACEHOLDER": "e.g. Scala OR Maven",
  "SKIP_TO_MAIN_CONTENT": "Skip to main content",
  "SOFT_SKILLS": "Preferable soft skills",
  "SORT_BY_PLACEMENTS": "Placements",
  "SORT_BY_RELEVANCE": "Relevance",
  "SOURCED": "Sourced",
  "SPECIALIZATIONS_LABEL": "Specialisations",
  "SPECIALIZATIONS_PLACEHOLDER": "Select specialization",
  "SPECIFY_ANSWER": "Specify the answer",
  "SPOKEN_LANGUAGES": "Spoken languages",
  "SPOTS_AVAILABLE": "Spots available",
  "STAGE_1ST_INTERVIEW": "1st interview",
  "STAGE_2ND_PLUS_INTERVIEW": "2nd+ interview",
  "STAGE_COMPANY_FEEDBACK_IS_DONE": "The company has given feedback",
  "STAGE_HELP": "Introduced: shown in the introduction form. All other stages: asked via chat when the interview reaches that stage.",
  "STAGE_RECRUITER_FEEDBACK_IS_DONE": "The agency has given feedback",
  "STAGE_TASK_INTERVIEW_DONE": "Your candidate had their interview on the {{ dateTime }}",
  "STAGE_TASK_INTERVIEW_DONE_CLIENT": "The candidate had their interview on the {{ dateTime }}",
  "STAGE_TASK_OFFER_ACCEPTED": "The offer has been accepted",
  "STAGE_TASK_OFFER_WAS_MADE": "An offer was made to the candidate",
  "STAGE_TASK_TITLE-2_DONE": "The interview date has been set",
  "STAGE_TASK_TITLE-5_PRE": "You will have to provide feedback within 24h after the interview",
  "START_DATE_LABEL": "Start date",
  "STATUS": "Status",
  "STATUS_CHANGED_DATE": "Status changed date",
  "SUBJECT": "Subject",
  "SUBMIT_ANSWERS": "Submit Answers",
  "SUBMIT_DISPUTE": "Submit Dispute",
  "SUBSCRIBED_TO_JOB_SUCCESS": "You've been added to the hiring team",
  "SUBSCRIBE_TO_JOB": "Subscribe to job updates",
  "SUBSCRIPTION_ERROR": "An error occurred",
  "SUGGESTED": "Suggested",
  "SUPPLIER_JOB": "Agency Job",
  "SUPPORTING_DOCUMENT": "Supporting Document (Optional)",
  "SWITCH_OFF_ALL": "Switch off all notifications",
  "SWITCH_PROJECT": "Switch project",
  "SWITCH_ROLE": "Switch role",
  "SWITCH_STAGE": "Switch stage",
  "SWITCH_USER": "Switch user",
  "SYMBOL_RULE": "This password must contain at least 1 special symbol.",
  "SYNC_ERROR": "Sync Error",
  "SYSTEM_ROLE_DESC": "Select a system role from your ATS to configure the permissions below.",
  "SYSTEM_TYPE": "System type",
  "T-SQL": "T-SQL",
  "TABLE_COLUMN_AGENCY_NAME": "Agency Name",
  "TABLE_COLUMN_AVG_DAYS_TO_HIRE": "Avg Days to Hire",
  "TABLE_COLUMN_AVG_FEE": "Avg Fee",
  "TABLE_COLUMN_AVG_SALARY": "Avg Salary",
  "TABLE_COLUMN_CREATED_DATE": "Created Date",
  "TABLE_COLUMN_DATE": "Date",
  "TABLE_COLUMN_FIRST_NAME": "First Name",
  "TABLE_COLUMN_FIRST_PUBLICATION_DATE": "First Publication Date",
  "TABLE_COLUMN_INTERVIEWS_PER_HIRE": "Interviews Per Hire",
  "TABLE_COLUMN_JOB_CODE": "Job Code",
  "TABLE_COLUMN_JOB_CREATED_DATE": "Job Created Date",
  "TABLE_COLUMN_LAST_NAME": "Last Name",
  "TABLE_COLUMN_TOTAL_FEES": "Total Fees",
  "TABLE_COLUMN_TOTAL_HIRED": "Total Hired",
  "TABLE_SETTINGS": "Table settings",
  "TABLE_SETTINGS_DESCRIPTION": "Choose which information is visible.",
  "TAGS": "Tags",
  "TAG_EXPLANATION": "Tags are visible to agencies and help communicate priority or urgency, e.g. \"Top Priority\" or \"Urgent\".",
  "TALENT_SUPPLIERS_ASSIGNED": "Agencies assigned!",
  "TARGET": "Target",
  "TARGET_TYPE_LABEL": "Target Type",
  "TARGET_TYPE_PLACEHOLDER": "Select type",
  "TARGET_TYPE_REQUIRED": "Type is required",
  "TASKS": "Tasks",
  "TEAM": "The team",
  "TEAM_BANNER_DESC_GROW": "Your agency has {{count}} members. Invite more colleagues to expand your team.",
  "TEAM_BANNER_DESC_INVITED": "You've been invited by {{client}}. Start building your team by inviting colleagues to {{company}}.",
  "TEAM_BANNER_DESC_SOLO": "You are currently the only member of your agency. Invite colleagues to share candidates.",
  "TEAM_BANNER_TITLE_SOLO": "Build Your Team",
  "TEAM_FEATURE_ADMIN_CONTROLS": "Admin Controls",
  "TEAM_FEATURE_ADMIN_CONTROLS_DESC": "Choose who can invite others to your agency",
  "TEAM_FEATURE_SHARE_CANDIDATES": "Share Candidates",
  "TEAM_FEATURE_SHARE_CANDIDATES_DESC": "Team members can see and manage the same candidates",
  "TEAM_INFO_TITLE": "Team info",
  "TEAM_LABEL": "Match with team",
  "TEAM_MEMBERS": "Team Members",
  "TEAM_MEMBERS_AMOUNT": "Number of team members",
  "TEAM_POPUP_DESC": "You can now invite colleagues to join your agency on HirePort. Share candidates and communicate via chat more efficiently as a team.",
  "TEAM_POPUP_TITLE": "Grow Your Team",
  "TEAM_SIZE": "Team Size",
  "TECH_USED": "Match with tech (used in team)",
  "TECH_USED_IN_COMPANY": "Tech used in company",
  "TEMPORARY": "Temporary",
  "TERMS": "Terms",
  "TERMS_ACCEPTED": "Terms accepted",
  "TERMS_DECLINED": "Terms declined",
  "TERMS_PENDING": "Pending terms",
  "TERMS_STATUS": "Terms status",
  "THANKS_FEEDBACK_TEXT": "Thanks for your feedback",
  "THANK_YOU_FOR_RATING": "Thank you for your rating",
  "THE_EMPLOYMENT_TYPE_OF_THIS_JOB_IS": "The employment type of this job is",
  "THIS_PAGE": "this page",
  "THUMB_DOWN_TOOLTIP": "Let us know if this part of the job posting isn't interesting enough. We'll actively use this information to improve postings on the platform.",
  "THUMB_UP_TOOLTIP": "Let us know if this part of the job posting is interesting for your candidates. We'll actively use this information to improve postings on the platform.",
  "TIERED_FEES": "Tiered fees",
  "TIMELINE": "Timeline",
  "TIMELINE_TOOLTIP": "You can now move your candidate to the following stage. Please be aware that changes are definitive and can not be undone. Companies will receive a message about this.",
  "TIMEZONE_LOCAL_ONLY_ADMIN": "Timezone preference updated locally only (admin cannot change another user's timezone while using \"login as\")",
  "TIMEZONE_UPDATED": "Timezone updated successfully",
  "TIMEZONE_UPDATE_FAILED": "Failed to update timezone",
  "TITLE": "Title",
  "TITLE_TEXT": "Job title",
  "TODAY": "Today",
  "TOMORROW": "Tomorrow",
  "TOOLS_USED": "Tools used",
  "TOTAL": "total",
  "TOTAL_AGENCIES": "agencies",
  "TOTAL_AMOUNT_OF_RATINGS": "Total amount of ratings",
  "TOTAL_DURATION_LABEL": "Total duration of the interview process, days",
  "TOTAL_PER_WEEK": "Total per week",
  "TO_SETUP_CONNECTION": "to set up a connection.",
  "TRY_AGAIN": "Try again",
  "TYPE": "Type",
  "TYPE_OF_EMPLOYMENT": "Type of employment",
  "UNABLE_TO_LOAD_ANALYTICS": "Unable to load analytics",
  "UNDO": "Undo",
  "UNKNOWN": "Unknown",
  "UNMAPPED_STAGES": "Unmapped stages",
  "UNPUBLISHED": "Unpublished",
  "UNPUBLISH_JOB_REASON": "specify reason",
  "UNPUBLISH_JOB_TITLE": "Unpublish job",
  "UNPUBLISH_TITLE": "Unpublish",
  "UNREAD": "Unread",
  "UNSAVED_CHANGES_TITLE": "Discard unsaved changes?",
  "UNSUBSCRIBED_FROM_JOB_SUCCESS": "You've been removed from the hiring team",
  "UNSUBSCRIBE_FROM_JOB": "Unsubscribe",
  "UPDATE": "Update",
  "UPDATE_DATE_TEXT": "Update date",
  "UPDATE_ERROR": "Oops something went wrong, please try again",
  "UPDATE_JOB": "Update Job",
  "UPDATING_PREVIEW": "Updating preview...",
  "UPLOAD_ADDITIONAL_FILES": "Upload additional files",
  "UPLOAD_ADDITIONAL_FILES_NOTE": "Max 10 files, 10MB each. PDF, DOC, DOCX, TXT, PNG, JPG.",
  "UPLOAD_AGENCY_CSV": "Upload CSV",
  "UPLOAD_AGENCY_CSV_HINT": "Upload a spreadsheet to invite multiple agency contacts at once.",
  "UPLOAD_AGENCY_CSV_PROMPT": "Drop a CSV here or click to upload",
  "UPLOAD_CV": "Upload CV",
  "UPLOAD_MAX_SIZE_NOTE": "Max file size: 2MB",
  "UPLOAD_OFFER": "Upload offer",
  "UPPERCASE_RULE": "This password must contain at least 1 upper case character.",
  "USERS": "Users",
  "USE_BROWSER_TIMEZONE": "Browser timezone",
  "USE_SALARY_BASED_FEE_BRACKETS": "Use salary-based fee brackets",
  "UX": "UX",
  "V": "V",
  "VACATION_DAYS": "vacation days",
  "VALIDATION_ADDRESS_REQUIRED": "Address is required",
  "VALIDATION_CORPORATE_EMAIL": "Please use a corporate email address",
  "VALIDATION_DATE_MAX": "Date must be on or before {{date}}",
  "VALIDATION_DATE_MIN": "Date must be on or after {{date}}",
  "VALIDATION_FILE_SIZE": "File size must be under {{size}}MB",
  "VALIDATION_INVALID_CURRENCY": "Invalid currency format",
  "VALIDATION_INVALID_DATE": "Invalid date",
  "VALIDATION_INVALID_EMAIL": "Invalid email address",
  "VALIDATION_INVALID_FORMAT": "Invalid format",
  "VALIDATION_INVALID_NUMBER": "Must be a valid number",
  "VALIDATION_INVALID_PHONE": "Invalid phone number format",
  "VALIDATION_INVALID_URL": "Invalid URL format",
  "VALIDATION_MAX_LENGTH": "Maximum {{max}} characters allowed",
  "VALIDATION_MAX_VALUE": "Maximum value is {{max}}",
  "VALIDATION_MIN_LENGTH": "Minimum {{min}} characters required",
  "VALIDATION_MIN_VALUE": "Minimum value is {{min}}",
  "VALIDATION_SELECT_AT_LEAST_ONE": "Please select at least one option",
  "VALIDATION_SELECT_OPTION": "Please select an option",
  "VERSION_PENDING_ACTION": "Pending - Action Required",
  "VIEW": "View",
  "VIEWING_SNAPSHOT": "Viewing Historical Snapshot",
  "VIEWS": "Views",
  "VIEW_ATTACHMENTS": "View attachments",
  "VIEW_CLIENT_FEEDBACK": "View company feedback",
  "VIEW_CONTRACT_TITLE": "View contract",
  "VIEW_DETAILS": "View Details",
  "VIEW_DISPUTE": "View Dispute",
  "VIEW_FEEDBACK": "View feedback",
  "VIEW_INVOICE": "View Fee Approval",
  "VIEW_JOB": "View Job",
  "VIEW_JOB_ACTIVITY": "View job activity",
  "VIEW_ONLY": "View Only",
  "VIEW_OPTIONS": "View options",
  "VIEW_PDF": "View PDF",
  "VIEW_PRODUCT_TOUR": "View product tour",
  "VIEW_RECRUITER_FEEDBACK": "View agency feedback",
  "VISA_SPONSORSHIP": "Visa sponsorship",
  "VISA_SPONSORSHIP_AVAILABLE": "We can provide visa sponsorship",
  "VISA_TITLE": "Visa sponsorship possible",
  "VISIBLE_TO_SPECIFIC_USERS": "Choose Who Can See Notes (Recruitee Only)",
  "VISIBLE_TO_SPECIFIC_USERS_DESC": "Select which people in your team can see the notes. Everyone else will not see them. Only works with Recruitee. If no one is selected, notes won't be visible to anyone.",
  "VISIBLE_TO_SPECIFIC_USERS_ROLES_DESC": "Select which roles in your team can see the notes. Everyone else will not see them. Only works with Recruitee. If no role is selected, notes won't be visible to anyone.",
  "VISIT_HELP_CENTER": "Visit Help Center",
  "WAITING_CLIENT": "Waiting for company confirmation",
  "WAITING_CLIENT_OFFER": "Awaiting company offer",
  "WAITING_CLIENT_OFFER_2": "waiting for company offer",
  "WAITING_DECISION": "Awaiting company decision",
  "WAITING_RECRUITER": "Waiting for agency confirmation",
  "WARNING": "WARNING",
  "WEEKLY": "Weekly",
  "WHAT_IS_OFFERED": "What is offered",
  "WHAT_WILL_BE_DOING": "Weekly activities",
  "WHEN_TO_ASK": "When to ask this question",
  "WITHDRAW_CANDIDATE": "Withdraw candidate",
  "WORKED_WITH_BEFORE": "Previously collaborated",
  "WORKED_WITH_INFO": "Agencies that have introduced at least one candidate for your company",
  "WORKING_CONDITIONS": "Working conditions",
  "WORKING_TYPE": "Working Type",
  "WORKING_TYPE_FULLY_REMOTE_HOMECOUNTRY": "Fully remote in home country",
  "WORKING_TYPE_FULLY_REMOTE_TIMEZONE": "Fully remote within same timezone",
  "WORKING_TYPE_FULLY_REMOTE_WORLDWIDE": "Fully remote worldwide",
  "WORKING_TYPE_FULL_OFFICE": "Full office/project location",
  "WORKING_TYPE_HYBRID": "Hybrid",
  "WORKING_TYPE_HYBRID_VERBOSE": "Hybrid working possible",
  "WRITE_A_MESSAGE": "Write a message...",
  "YEARLY": "Yearly",
  "YES": "Yes",
  "YESTERDAY": "Yesterday",
  "YOU": "You",
  "YOUR_COMPANY": "your agency",
  "YOUR_EMAIL": "Your Email",
  "YOUR_NAME": "Your Name",
  "YOUR_PERFORMANCE_IN_EYES_OF_AGENCIES": "Agency Ratings",
  "YOUR_RATINGS_BY_AGENCY": "Your ratings by agency",
  "YOUR_RATINGS_BY_CATEGORY": "Your ratings by category",
  "YOUR_RATINGS_OF_AGENCIES": "Your ratings of agencies",
  "YOUR_SPECIALIZATIONS": "Tell companies your specialisations",
  "YOU_HAVE_UNANSWERED_QUESTIONS": "This job has unanswered questions that need your attention.",
  "YOU_NEED_TO_BE_PART_OF_A_COMPANY_TO_SET_TYPE_TO_AGENCY": "You need to be part of a company to set type to Agency",
  "Z": "Z",
  "ats": {
    "AI_CONFIDENCE_HIGH": "high",
    "AI_CONFIDENCE_LOW": "low",
    "AI_CONFIDENCE_MEDIUM": "medium",
    "AI_SUGGESTION": "AI Suggestion",
    "AI_SUGGESTIONS_APPLIED_MESSAGE": "{{mapped}} stage(s) mapped, {{hidden}} hidden for agencies. Review and save the changes.",
    "AI_SUGGESTIONS_APPLIED_TITLE": "AI suggestions applied successfully!",
    "AI_SUGGESTIONS_NONE": "No new AI suggestions for the remaining stages.",
    "AI_SUGGESTIONS_UNAVAILABLE": "AI suggestions are not available right now. Try again later or map the stages manually.",
    "ALL_STAGES_MAPPED": "All stages have been configured",
    "ALWAYS": "Always",
    "ALWAYS_UNMAP": "Hide for Agencies",
    "ALWAYS_UNMAP_TOOLTIP": "Toggle ON to always hide this stage from agencies. It will not be visible in job-specific views.",
    "APPLY_MAPPINGS_ERROR": "Failed to apply mappings to existing jobs. Please try again.",
    "APPLY_MAPPINGS_MESSAGE": "These default stage mappings will be saved and automatically applied to all existing jobs in your system.",
    "APPLY_MAPPINGS_SUCCESS": "Successfully updated {count} jobs",
    "APPLY_MAPPINGS_WARNING": "Any existing job-specific stage mappings will be replaced with these new default mappings.",
    "APPLY_TO_SELECTED": "Apply to selected",
    "ATS_CONNECTION": "ATS connection",
    "ATS_JOBS": "Jobs in ATS*",
    "ATS_SETTINGS_SEARCH": "Search for jobs",
    "ATS_SETTINGS_TITLE": "ATS settings",
    "ATS_STAGE": "ATS Stage",
    "ATS_STAGES_COLUMN": "ATS Stages",
    "AWAITING_SYNC_EXPLAINER": [
      "We've started the process of connecting your ATS and it should complete within a few minutes.",
      "Once the connection process has been completed you will be able to start connecting your HirePort jobs to your ATS."
    ],
    "AWAITING_SYNC_SUBTITLE": "We are setting up your connection",
    "BACK_TO_ATS_SETTINGS": "Back to jobs",
    "BULK_APPLY_DEFAULT_MAPPINGS": "Apply Default Stage Mappings to All Jobs",
    "BULK_APPLY_MAPPINGS_ERROR": "Failed to apply default stage mappings to all jobs. Please try again.",
    "BULK_APPLY_MAPPINGS_SUCCESS": "Successfully applied default stage mappings to {count} jobs",
    "CANDIDATE_NAME": "Candidate",
    "CANNOT_UPDATE_STAGE_MAPPINGS": "Cannot Update Stage Mappings",
    "CLEAR_SELECTION": "Clear Selection",
    "CLICK_BELOW_TO_START": "Click below to start the process.",
    "CONFIGURE": "Configure",
    "CONNECT": "Connect",
    "CONNECT_EXPLAINER": "Connecting your ATS to HirePort allows you to automatically synchronize candidate interview status and agency activities.",
    "CONNECT_LINK_ERROR": "Could not start the ATS connection. Please try again.",
    "CONNECTED_JOBS_FILTER_TITLE": "Connected jobs",
    "CURRENT_STAGE": "Current Stage",
    "DEFAULT_MAPPINGS_CONFIRM_TITLE": "Confirm Changes",
    "DEFAULT_MAPPINGS_DESCRIPTION": "Configure the default stage settings that control how hiring process stages are displayed to agencies. Each stage can be assigned to a standard stage type, hidden from the agency view entirely, or you can choose to auto-map stages with AI.",
    "DEFAULT_MAPPINGS_TITLE": "Default Stage Mappings",
    "DISCONNECT_ATS": "Disconnect ATS",
    "DISCONNECT_ATS_CONFIRM_OK": "Disconnect ATS",
    "DISCONNECT_ATS_CONFIRM_TEXT": [
      "Disconnecting your HirePort account from your ATS will permanently delete some information in HirePort relating to your ATS:",
      "All of the information about which HirePort jobs you have connected to your ATS.",
      "For each connected job, all of the stage mappings you have created.",
      "For each connected job, records of which candidates have been synchronised to the ATS. (the candidate records themselves in both your ATS and in HirePort will remain intact, but the connection between them will be severed.)",
      "Disconnecting your ATS will also prevent activities and information from automatically being synchronised between HirePort and your ATS."
    ],
    "DISCONNECT_ATS_CONFIRM_TEXT_SHORT": "Disconnecting your HirePort account from your ATS will permanently delete information about which jobs are connected, including remote stage mappings as well as information about which candidates you have synchronized with the ATS to date.",
    "DISCONNECT_ATS_CONFIRM_TITLE": "Disconnect your ATS?",
    "DISCONNECT_JOB": "Yes, disconnect",
    "DISCONNECT_JOB_CONFIRM_OK": "Disconnect job",
    "DISCONNECT_JOB_CONFIRM_TEXT": [
      "Disconnecting this job from your ATS will mean that any changes that occur on your ATS will no longer be automatically synchronised to your HirePort, and any changes that occur on HirePort will no longer be automatically synchronised to your ATS.",
      "It will also mean that notes and activities from agencies will no longer appear automatically in your ATS."
    ],
    "DISCONNECT_JOB_CONFIRM_TEXT_SHORT": "Disconnecting this job from your ATS prevents activities and notes from being transferred from HirePort to your ATS, and from your ATS to HirePort, for this job.",
    "DISCONNECT_JOB_CONFIRM_TITLE": "Disconnect this job from your ATS?",
    "DRAG_TO_MAP": "Drag to map this stage",
    "DRAG_TO_MAP_AS": "Drag here to mark as",
    "DRAG_TO_REORDER": "Drag to change the interview stage order",
    "EDIT_STAGE_BUTTON": "Configure",
    "GENERATING_AI_SUGGESTION": "Generating AI suggestion...",
    "HIREPORT_STAGE_TYPE": "HirePort Stage Type",
    "HIREPORT_STAGE_TYPES_COLUMN": "HirePort Stage Types",
    "INTRODUCED_SECTION_WARNING": "⚠️ Please note: a Job's first mapped interview stage in this section will determine where the agency candidate is created in your ATS.",
    "JOB_CONNECTIONS": "Job connections",
    "JOB_TITLE": "Job",
    "LOAD_STAGES_ERROR_DESC": "There was an error loading the stage data.",
    "LOAD_STAGES_ERROR_TITLE": "Error",
    "MAP_AS": "Map as {type}",
    "MAP_AS_TOOLTIP": "Map selected stages to a specific type",
    "MOVE_IN_ATS_BUTTON": "Yes, move in ATS",
    "MOVE_IN_ATS_TEXT": "This candidate is in a different stage in your ATS than in HirePort. Do you want to tell your ATS to move the candidate so that the stages in HirePort and your ATS match?",
    "MOVE_IN_ATS_TITLE": "Move candidate in ATS?",
    "MOVE_STAGE_TO": "Move stage to",
    "NAVIGATION_PROMPT": "You have not finished configuring this job connection. Really leave?",
    "NO_ATS_CONNECTED": "No ATS connected",
    "NO_SEARCH_RESULTS": "No stages match your search criteria",
    "NO_STAGE_MAPPINGS": "No recruitment stages found",
    "NO_STAGES_FOUND": "No stages found. Connect jobs in your ATS to see stages here.",
    "NOT_MAPPED": "Not mapped yet",
    "NOT_MAPPED_TOOLTIP": "Stages here use automatic mapping based on name for new jobs. Override this by dragging to a specific type or marking as 'Hide for Agencies'.",
    "OFF_SYNC_BADGE": "OFF-SYNC",
    "OFF_SYNC_TOOLTIP_CLIENT": "Click to move candidate in your ATS",
    "OFF_SYNC_TOOLTIP_ERROR_DUPLICATE_CANDIDATE": "This candidate could not be connected to the ATS because a candidate with the same details already exists there - changes will not sync.",
    "OFF_SYNC_TOOLTIP_ERROR_UNKNOWN_ERROR": "This candidate could not be connected to the ATS - changes will not sync.",
    "ORDER": "Order",
    "REFRESH_DATA_BTN": "Refresh ATS data",
    "REFRESH_DATA_TEXT_FMT": [
      "*Data from <b>{{ tool }}</b> was last read at <b>{{- time}} on {{- date}}<b/>.",
      "If you have changed anything in <b>{{ tool }}</b> more recently and need to update this screen, click the button to pull more recent data from <b>{{ tool }}</b>."
    ],
    "REFRESH_THIS_PAGE": "Refresh this page",
    "REFRESHING_DATA_BTN": "Refreshing ATS data",
    "RESET": "Reset",
    "SAVE_DEFAULT_STAGE_MAPPINGS": "Save Default Stage Mappings",
    "SAVE_MAPPINGS": "Save Mappings",
    "SAVE_MAPPINGS_ERROR_DESC": "There was an error saving the stage mappings.",
    "SAVE_MAPPINGS_ERROR_TITLE": "Error",
    "SAVE_MAPPINGS_SUCCESS_DESC": "Default stage mappings were successfully saved.",
    "SAVE_MAPPINGS_SUCCESS_TITLE": "Success",
    "SEARCH_STAGES": "Search stages by name",
    "SELECT_ALL": "Select all",
    "SELECT_LOCAL_JOB": "- Not connected to HirePort -",
    "SELECT_TYPE": "Select a type",
    "selected": "selected",
    "stage": "stage",
    "STAGE_EDIT_CONFIRM_OK": "Update settings",
    "STAGE_EDIT_CONFIRM_TITLE": "Update stage settings?",
    "STAGE_EDIT_WARNING_TEXT": "Changing these settings acts as guardrails for how stages appear to agencies for all future jobs. Existing jobs retain their current settings unless manually updated.",
    "STAGE_HAS_CHANGES": "This stage has unsaved changes",
    "UNSAVED_STAGE_MAPPING_CHANGES": "You have unsaved stage mapping changes. Save to apply them.",
    "STAGE_MAPPING_EXPLAINER": "Set default rules for your ATS stages. Decide if a stage should always map to a specific type (like Interview) or always be hidden from agencies (e.g., internal stages). This ensures consistent visibility for agencies.",
    "STAGE_MAPPING_INSTRUCTION": "You can configure stage mappings in Agency Portal Settings → Default Stage Mappings.",
    "STAGE_MAPPING_LEGEND": "Recruitment Stages",
    "STAGE_MAPPING_VALIDATION": "Please configure: 1) Which stage represents candidate introduction, 2) At least one interview stage, and 3) Final outcome stages",
    "STAGE_MAPPING_WARNING_MESSAGE": "New interview stages have been detected in your ATS that need to be configured.",
    "STAGE_MAPPING_WARNING_TITLE": "New Interview Stages Detected",
    "STAGE_MAPPINGS": "Update stage settings",
    "STAGE_NOT_MAPPED": "-- Hidden from Agencies --",
    "STAGE_TYPE_HIDDEN": "Hidden for Agencies",
    "STAGE_TYPE_HIRED": "Hired",
    "STAGE_TYPE_INTERVIEW": "Interview",
    "STAGE_TYPE_INTRODUCED": "Introduced",
    "STAGE_TYPE_OFFERED": "Offered",
    "STAGE_TYPE_ON_HOLD": "On Hold",
    "STAGE_TYPE_REJECTED": "Rejected",
    "STAGE_TYPE_UNMAPPED": "Unmapped",
    "STAGE_TYPE_WITHDRAWN": "Withdrawn",
    "STAGE_UPDATE_FAILED": "Could not update that stage. Please refresh the page and try again.",
    "stage_unmapped": "stage unmapped",
    "stages": "stages",
    "STAGES_SELECTED": "{count} stage(s) selected",
    "stages_unmapped": "stages unmapped",
    "START_CONNECTING": "Start connecting",
    "SUGGEST_STAGE_MAPPINGS_AI": "Auto-map stages",
    "SYNC_STAGES_BTN": "Sync stages from ATS",
    "SYNC_STAGES_NEW_FOUND": "{{count}} new stage(s) found from your ATS",
    "SYNC_STAGES_UP_TO_DATE": "Stage list is up to date — no new stages found",
    "UNMAP": "Unmap",
    "UNMAPPED": "Leave Unmapped",
    "UNMAPPED_GROUP_LABEL": "Default / Hidden Stages",
    "UNSAFE_UPDATE_PRIMARY_MESSAGE": "The following candidates are currently in interview stages that you are trying to remove:",
    "UNSAFE_UPDATE_SECONDARY_MESSAGE": "Please move them to other stages in your ATS, or keep these stages mapped to proceed.",
    "DRY_RUN_ADDED": "Added",
    "DRY_RUN_AFFECTED_CANDIDATES": "Affected Candidates (Action Required)",
    "DRY_RUN_AFFECTED_COMPANIES": "Affected Companies & Subcompanies",
    "DRY_RUN_APPLY_CHANGES": "Apply Changes",
    "DRY_RUN_CANDIDATES": "Candidates to Re-evaluate",
    "DRY_RUN_CANDIDATES_TO_MOVE": "Candidates That Will Be Moved",
    "DRY_RUN_CANDIDATES_TO_MOVE_DESC": "These candidates will automatically move to their new stages when you apply the changes:",
    "DRY_RUN_CANDIDATES_WARNING": "These candidates are in stages that would be removed. Move them first or keep these stages mapped.",
    "DRY_RUN_CHANGE_TYPE": "Change",
    "DRY_RUN_COMPANIES": "Companies Affected",
    "DRY_RUN_COMPANIES_DESC": "These companies will inherit the stage mapping changes:",
    "DRY_RUN_COMPANY": "Company",
    "DRY_RUN_CURRENT_STAGE_FULL": "Current Stage",
    "DRY_RUN_ERROR_DESC": "Could not preview changes. Please try again.",
    "DRY_RUN_ERROR_TITLE": "Dry Run Failed",
    "DRY_RUN_FALLBACK_CANDIDATES": "Candidates Moved From Hidden Stages",
    "DRY_RUN_FALLBACK_CANDIDATES_DESC": "These candidates are in stages being hidden and will be moved to the previous mapped interview stage.",
    "DRY_RUN_FALLBACK_DESC": "Candidates in stages being hidden will be moved to the previous mapped interview stage.",
    "DRY_RUN_FALLBACK_TITLE": "Candidates in hidden stages",
    "DRY_RUN_HIDDEN_ALWAYS_UNMAPPED": "Hidden (Always Unmapped)",
    "DRY_RUN_LEFT_UNMAPPED": "Unmapped (needs mapping)",
    "DRY_RUN_JOBS_AFFECTED": "Jobs Affected",
    "DRY_RUN_NEW_STAGE_FULL": "New Stage",
    "DRY_RUN_NEW_VALUE": "New",
    "DRY_RUN_NO_CHANGES": "No changes detected in your stage mappings.",
    "DRY_RUN_OLD_VALUE": "Current",
    "DRY_RUN_PREVIEW_CHANGES": "Preview Changes - Dry Run",
    "DRY_RUN_PRIMARY_MESSAGE": "Review the impact of your stage mapping changes before applying them:",
    "DRY_RUN_REORDERED": "Reordered",
    "DRY_RUN_REMOVED": "Removed",
    "DRY_RUN_STAGE_NAME": "Stage Name",
    "DRY_RUN_SUPER_COMPANY": "Parent",
    "DRY_RUN_TOTAL_CHANGES": "Total Changes",
    "DRY_RUN_TYPE_CHANGED": "Type Changed",
    "DRY_RUN_UNMAPPED": "Hidden",
    "DRY_RUN_UNSAFE_WARNING": "Warning: Unsafe Changes",
    "YOUR_ACCOUNT_IS_CONNECTED_TO_FMT": "Your HirePort account is connected to <b>{{ tool }}</b>."
  },
  "catalog": {
    "fees": {
      "FEE_TYPE_CUSTOM": "Custom",
      "FEE_TYPE_FIXED": "Fixed",
      "FEE_TYPE_PERCENTAGE": "Percentage"
    },
    "other": {
      "3": "3",
      "-": "-",
      "- Infor": "- Infor",
      ",engineer": ",engineer",
      "...": "...",
      ".NET": ".NET",
      ".NET / React beheer": ".NET / React administration",
      ".NET Core": ".NET Core",
      ".NET Developers": ".NET Developers",
      "(power)queries": "(power)queries",
      "+ 30% perm conversion fee": "+ 30% perm conversion fee",
      "+1 year experience": "+1 year experience",
      "+1 year experience with .NET and/or Python": "+1 year experience with .NET and/or Python",
      "+5 year experience with PHP and PHP frameworks": "+5 year experience with PHP and PHP frameworks",
      "+5 years of proven experience as a financial controller": "+5 years of proven experience as a financial controller",
      "1 Niet van toepassing": "1 Not applicable",
      "1+ year am experience": "1+ year am experience",
      "1+ year experience agency-side": "1+ year experience agency-side",
      "1+ year experience in commercial writing": "1+ year experience in commercial writing",
      "1+ year of professional experience": "1+ year of professional experience",
      "1+ year on": "1+ year on",
      "1+ year on agency side": "1+ year on agency side",
      "10 years construction manager": "10 years construction manager",
      "10+ years of experience": "10+ years of experience",
      "10+year seasoned Engineer": "10+year seasoned Engineer",
      "100% Email": "100% Email",
      "1st Interview": "1st Interview",
      "2 year experience": "2 year experience",
      "2 years relevant experience": "2 years relevant experience",
      "2-3+ years in manager role": "2-3+ years in manager role",
      "2+ years defining architecture": "2+ years defining architecture",
      "2+ years exp. incl. consultancy": "2+ years exp. incl. consultancy",
      "2+ years experience": "2+ years experience",
      "2+ years experience in java": "2+ years experience in java",
      "2+ years of work experience in the field IT support activities": "2+ years of work experience in the field IT support activities",
      "2nd+ Interview": "2nd+ Interview",
      "3 jaar consultancy ervaring": "3 years of consultancy experience",
      "3 jaar werkervaring": "3 years of work experience",
      "3 years aws": "3 years aws",
      "3 years exp mro, capex or energy": "3 years exp mro, capex or energy",
      "3 years mro": "3 years mro",
      "3 years mro/capex or energy": "3 years mro/capex or energy",
      "3 years of aws": "3 years of aws",
      "3-": "3-",
      "3-5 years experience": "3-5 years experience",
      "3-7 years experience": "3-7 years experience",
      "3-8 jaar consultancy ervaring": "3–8 years of consultancy experience",
      "3+ year experience in commercial writing": "3+ year experience in commercial writing",
      "3+ years experience .net": "3+ years experience .net",
      "3+ years of backend development": "3+ years of backend development",
      "3+ years of commercial experience": "3+ years of commercial experience",
      "3+ years of experience": "3+ years of experience",
      "3+ years of experience as a Backend Developer": "3+ years of experience as a Backend Developer",
      "3+ years of experience as a CSM": "3+ years of experience as a CSM",
      "3+ years of experience as a Frontend Developer": "3+ years of experience as a Frontend Developer",
      "3+ years of professional experience": "3+ years of professional experience",
      "3+ years of work experience as Technical Application Manager": "3+ years of work experience as Technical Application Manager",
      "3+ years of work experience in Software Security": "3+ years of work experience in Software Security",
      "3d": "3d",
      "3D CAD": "3D CAD",
      "3D Daglichtsimulaties": "3D Daylight Simulations",
      "3D modelleren": "3D modeling",
      "3D ontwerp": "3D design",
      "3nf": "3nf",
      "4 years of consultative workexperience": "4 years of consultative workexperience",
      "4-weekly": "4-weekly",
      "5 years leadership": "5 years leadership",
      "5 years of typescript": "5 years of typescript",
      "5 years rel": "5 years rel",
      "5 years relevant experience": "5 years relevant experience",
      "5 years typescript": "5 years typescript",
      "5-axis machining centers": "5-axis machining centers",
      "5+ years experience in java": "5+ years experience in java",
      "5+ years of experience": "5+ years of experience",
      "5+ years of professional experience": "5+ years of professional experience",
      "6% of hourly rate": "6% of hourly rate",
      "6+ years of consultative experience": "6+ years of consultative experience",
      "7 years experience in purchasing": "7 years experience in purchasing",
      "7+ jaar werkervaring": "7+ years of work experience",
      "7+ years of experience": "7+ years of experience",
      "A/b testen": "A/B testing",
      "Aa diploma": "Aa diploma",
      "Aanbestedingen": "Tenders",
      "Aanbestedingen en rfp’s": "Tenders and rfp's",
      "Aanpakkersmentaliteit": "Go-getter mentality",
      "Aansturen onderaannemers": "Managing subcontractors",
      "Aansturen van leveranciers": "Managing suppliers",
      "Aas": "Aas",
      "Ability to convert business wishes into IT designs": "Ability to convert business wishes into IT designs",
      "Accessible Design": "Accessible Design",
      "Account": "Account",
      "Account Executive": "Account Executive",
      "Account Management": "Account Management",
      "Account Manager": "Account Manager",
      "Accountancy": "Accountancy",
      "Accounting": "Accounting",
      "Accounting Knowledge": "Accounting Knowledge",
      "Accounting Software": "Accounting Software",
      "Accounting software user and administration skills": "Accounting software user and administration skills",
      "Accounting/auditing": "Accounting/auditing",
      "Accountview": "Accountview",
      "Accuraat": "Accurate",
      "Accuracy": "Accuracy",
      "Accurate": "Accurate",
      "Accuratesse": "Accuracy",
      "ACTIONS:": "ACTIONS:",
      "ActionScript": "ActionScript",
      "Active": "Active",
      "Active Directory": "Active Directory",
      "Active network": "Active network",
      "ActiveMQ": "ActiveMQ",
      "Activity & Status": "Activity & Status",
      "Add User": "Add User",
      "Adform": "Adform",
      "Adfs": "Adfs",
      "Administratie": "Administration",
      "Administratief medewerker": "Administrative assistant",
      "administratief sterk": "administratively strong",
      "Administrative": "Administrative",
      "Adobe Creative Suite": "Adobe Creative Suite",
      "Advertising": "Advertising",
      "Advies": "Advice",
      "Adviseren": "Advising",
      "Adviseur": "Advisor",
      "Afas": "Afas",
      "Affinity with it": "Affinity with it",
      "Agency Lists": "Agency Lists",
      "Agendabeheer": "Calendar management",
      "Agil": "Agile",
      "Agile": "Agile",
      "Agile Coach": "Agile Coach",
      "Agile Coaching": "Agile Coaching",
      "Agile Methodologies": "Agile Methodologies",
      "Agile Project Management": "Agile Project Management",
      "Agile Scrum": "Agile Scrum",
      "Agile/Scrum": "Agile/Scrum",
      "Agile/Scrum Methodology": "Agile/Scrum Methodology",
      "Agrarische Bedrijfskunde": "Agricultural Business Management",
      "Agriculture": "Agriculture",
      "Ai": "Ai",
      "AI ANALYSIS (BETA):": "AI ANALYSIS (BETA):",
      "AI Fundamentals (AI-900)": "AI Fundamentals (AI-900)",
      "AI Specialist": "AI Specialist",
      "Ai/ml": "Ai/ml",
      "Airbyte": "Airbyte",
      "Algoritmes": "Algorithms",
      "Allen Bradley": "Allen Bradley",
      "Amazon Web Services (AWS)": "Amazon Web Services (AWS)",
      "Ambitieus": "Ambitious",
      "amount": "amount",
      "Anallytic & reporting solutions": "Analytics & reporting solutions",
      "Analyse": "Analysis",
      "Analyses": "Analyses",
      "Analysis": "Analysis",
      "Analysis and Design": "Analysis and Design",
      "Analyst": "Analyst",
      "Analytic solutions": "Analytic solutions",
      "Analytical": "Analytical",
      "Analytical Skills": "Analytical Skills",
      "Analytical Thinking": "Analytical Thinking",
      "Analytisch": "Analytical",
      "Analytisch denken": "Analytical thinking",
      "Analytisch vermogen": "Analytical ability",
      "Analytische vaardigheden": "Analytical skills",
      "Anaplan": "Anaplan",
      "AndMore": "AndMore",
      "Android": "Android",
      "Android enterprise": "Android enterprise",
      "Android studio": "Android studio",
      "Android UI design principles and patterns (Play Store certification process)": "Android UI design principles and patterns (Play Store certification process)",
      "Angular": "Angular",
      "Angular.js": "Angular.js",
      "Angyl": "Angyl",
      "Animator": "Animator",
      "Annual bonus": "Annual bonus",
      "Ansi": "Ansi",
      "ANSI C": "ANSI C",
      "ANSI/ISA-95": "ANSI/ISA-95",
      "Ansible": "Ansible",
      "Ansys": "Ansys",
      "Apache": "Apache",
      "Apache Kafka": "Apache Kafka",
      "Apache Maven": "Apache Maven",
      "Apache Spark": "Apache Spark",
      "Apex": "Apex",
      "API Development": "API Development",
      "API Testing": "API Testing",
      "Apigee": "Apigee",
      "AppEngine": "AppEngine",
      "Appian Technologies": "Appian Technologies",
      "Appium": "Appium",
      "Application Management": "Application Management",
      "Application Manager": "Application Manager",
      "Application Support Analyst": "Application Support Analyst",
      "Applocker": "Applocker",
      "Arabic": "Arabic",
      "Arc-Flash": "Arc-Flash",
      "ArcGIS": "ArcGIS",
      "Archimate": "Archimate",
      "Architects": "Architects",
      "Architectural_services": "Architectural_services",
      "Architecture": "Architecture",
      "Architekturberatung": "Architecture consulting",
      "Areas to Explore:": "Areas to Explore:",
      "ARM templates": "ARM templates",
      "Art/creative": "Art/creative",
      "Artificial Intelligence": "Artificial Intelligence",
      "Asana": "Asana",
      "ASP.NET": "ASP.NET",
      "ASP.NET MVC": "ASP.NET MVC",
      "Assembler ARM": "Assembler ARM",
      "Assertiviteit": "Assertiveness",
      "Assessment": "Assessment",
      "Asset Management": "Asset Management",
      "Asset Manager": "Asset Manager",
      "Ataccama": "Ataccama",
      "Atex": "Atex",
      "Athina": "Athina",
      "Attached file": "Attached file",
      "Attention to detail": "Attention to detail",
      "ATV/ADV days (optional)": "Collective Labor Agreements days (optional)",
      "Audit": "Audit",
      "Auditing": "Auditing",
      "Audits": "Audits",
      "Augmented Reality": "Augmented Reality",
      "AutoCAD": "AutoCAD",
      "Autodesk Inventor": "Autodesk Inventor",
      "Automated Testing": "Automated Testing",
      "Automation": "Automation",
      "Automatisering": "Automation",
      "Automotive": "Automotive",
      "Automotive Battery Pack Engineering": "Automotive Battery Pack Engineering",
      "Automotive Communications Protocols": "Automotive Communications Protocols",
      "Automotive Components": "Automotive Components",
      "Automotive ervaring": "Automotive experience",
      "Automotive EV drivetrains": "Automotive EV drivetrains",
      "Automotive industry": "Automotive industry",
      "Automotive Protocols": "Automotive Protocols",
      "Autorisatiebeheer": "Authorization management",
      "Autosys": "Autosys",
      "Aviation Engineering": "Aviation Engineering",
      "AVP Middenspanning": "AVP Medium Voltage",
      "Aware of latest security standards": "Aware of latest security standards",
      "Aws": "Aws",
      "AWS Certified Advanced Networking": "AWS Certified Advanced Networking",
      "AWS Certified Cloud Practitioner": "AWS Certified Cloud Practitioner",
      "AWS Certified Data Analytics": "AWS Certified Data Analytics",
      "AWS Certified Database": "AWS Certified Database",
      "AWS Certified Developer": "AWS Certified Developer",
      "AWS Certified DevOps Engineer": "AWS Certified DevOps Engineer",
      "AWS Certified Machine Learning": "AWS Certified Machine Learning",
      "AWS Certified Security": "AWS Certified Security",
      "AWS Certified Solutions Architect": "AWS Certified Solutions Architect",
      "AWS Certified SysOps Administrator": "AWS Certified SysOps Administrator",
      "Aws high": "Aws high",
      "Az": "Az",
      "AZ 104": "AZ 104",
      "AZ 140": "AZ 140",
      "AZ 300": "AZ 300",
      "AZ 301": "AZ 301",
      "AZ 303": "AZ 303",
      "AZ 304": "AZ 304",
      "AZ 305": "AZ 305",
      "AZ 500": "AZ 500",
      "AZ 900": "AZ 900",
      "Azure": "Azure",
      "Azure b2c": "Azure b2c",
      "Azure cloud": "Azure cloud",
      "Azure Cloud administratie": "Azure Cloud administration",
      "Azure cloud services": "Azure cloud services",
      "Azure Data Engineer Associate": "Azure Data Engineer Associate",
      "Azure data factory": "Azure data factory",
      "Azure DevOps": "Azure DevOps",
      "Azure en microsoft-technologieën": "Azure and Microsoft technologies",
      "Azure Governance": "Azure Governance",
      "Azure public cloud": "Azure public cloud",
      "B1 dutch": "B1 dutch",
      "B2b": "B2b",
      "B2b financiële ervaring": "B2B financial experience",
      "B2B marketing": "B2B marketing",
      "B2B/IT": "B2B/IT",
      "Bachelor": "Bachelor",
      "Bachelor Accounting": "Bachelor Accounting",
      "Bachelor Computer Science (BSc)": "Bachelor Computer Science (BSc)",
      "Bachelor Data Science (BSc)": "Bachelor Data Science (BSc)",
      "Bachelor degree": "Bachelor degree",
      "Bachelor Electrical Engineering": "Bachelor Electrical Engineering",
      "Bachelor in hr": "Bachelor in hr",
      "Bachelor Informatica": "Bachelor's in Computer Science",
      "Bachelor Mechanical Engineering": "Bachelor Mechanical Engineering",
      "Bachelor of Business Administration (BBA)": "Bachelor of Business Administration (BBA)",
      "Bachelor's Degree": "Bachelor's Degree",
      "Back-End Developers": "Back-End Developers",
      "Back-End Development": "Back-End Development",
      "Back-End Engineering": "Back-End Engineering",
      "Backend Development": "Backend Development",
      "Bamboo": "Bamboo",
      "Banking": "Banking",
      "Bankzaken": "Banking",
      "Basecone": "Basecone",
      "Bash": "Bash",
      "Bash/Shell Scripting": "Bash/Shell Scripting",
      "Bedrijfseconomie": "Business Economics",
      "Bedrijfsopvolging": "Business succession",
      "Bedrijfsvoering": "Business operations",
      "Behavior-Driven Development (BDD)": "Behavior-Driven Development (BDD)",
      "BEI aanwijzing AVP Middenspanning / AVP LS.": "BEI designation AVP Medium Voltage / AVP LS.",
      "BEI aanwijzing VP LS Meterkast": "BEI designation VP LS Meter Cabinet",
      "Belastingaangifte": "Tax return",
      "Belastingwetgeving": "Tax legislation",
      "BENG-berekeningen": "BENG calculations",
      "Besluitvaardig": "Decisive",
      "Best regards,": "Best regards,",
      "Betonrenovatie": "Concrete renovation",
      "Betonreparatie": "Concrete repair",
      "Betrouwbaar": "Reliable",
      "Beveiliging": "Security",
      "Bevlogen": "Passionate",
      "Bgp": "Bgp",
      "Bi": "Bi",
      "BI Frontend Developer": "BI Frontend Developer",
      "Bi tool": "Bi tool",
      "Bi-tooling": "Bi-tooling",
      "bi-weekly": "bi-weekly",
      "Bicep": "Bicep",
      "Bicep Templates": "Bicep Templates",
      "Bidwriter": "Bidwriter",
      "Big": "Big",
      "Big Data": "Big Data",
      "Big Data Technologies": "Big Data Technologies",
      "Biomedical Engineering": "Biomedical Engineering",
      "Biotech_pharma": "Biotech_pharma",
      "BiSL": "BiSL",
      "Bisl or itil or tmap next": "Bisl or itil or tmap next",
      "BitBucket": "BitBucket",
      "BizTalk": "BizTalk",
      "Blackberry Enterprise Server": "Blackberry Enterprise Server",
      "Blazor": "Blazor",
      "Blockchain": "Blockchain",
      "Blockchain Development": "Blockchain Development",
      "Blue Prism": "Blue Prism",
      "Bluecoat": "Bluecoat",
      "Bluetooth": "Bluetooth",
      "Board": "Board",
      "Bodemenergie b": "Ground source heat pump B",
      "Bodemenergie e": "Ground source heat pump E",
      "Boekhouding": "Bookkeeping",
      "Bootstrap": "Bootstrap",
      "Bouw": "Construction",
      "Bouwkunde": "Architecture",
      "Bouwkundig Advies": "Architectural advice",
      "Bpmn": "Bpmn",
      "Brand Ambassador": "Brand Ambassador",
      "Brand Engagement": "Brand Engagement",
      "Brand Identity": "Brand Identity",
      "Brand Marketing": "Brand Marketing",
      "Branded Content": "Branded Content",
      "Brandveiligheid": "Fire safety",
      "Brl11000 guidelines": "Brl11000 guidelines",
      "Brl11000-richtlijnen": "Brl11000 guidelines",
      "Broad technical knowledge": "Broad technical knowledge",
      "Bsc": "Bsc",
      "Budget bewaking": "Budget monitoring",
      "Budget Management": "Budget Management",
      "Budgete": "Budget",
      "Budgeting": "Budgeting",
      "Budgetteren": "Budgeting",
      "Bug Tracking": "Bug Tracking",
      "Bulgarian": "Bulgarian",
      "Business Administration": "Business Administration",
      "Business Analysts": "Business Analysts",
      "Business Analytics": "Business Analytics",
      "Business Case Monitoring": "Business Case Monitoring",
      "Business Central": "Business Central",
      "Business Consultant": "Business Consultant",
      "Business Consulting": "Business Consulting",
      "Business controll": "Business control",
      "Business Controller": "Business Controller",
      "Business Development": "Business Development",
      "Business Development Manager": "Business Development Manager",
      "Business Development Representative": "Business Development Representative",
      "Business Intelligence": "Business Intelligence",
      "Business Intelligence Analyst": "Business Intelligence Analyst",
      "Business Process Analyst": "Business Process Analyst",
      "Business processes": "Business processes",
      "Business roles": "Business roles",
      "Business Strategy": "Business Strategy",
      "Business Support Manager": "Business Support Manager",
      "Business Systems Analyst": "Business Systems Analyst",
      "Business Unit Manager": "Business Unit Manager",
      "C (Programming Language)": "C (Programming Language)",
      "C-Level": "C-Level",
      "C-suite": "C-suite",
      "C/AL": "C/AL",
      "C/C++": "C/C++",
      "C#": "C#",
      "C#.NET": "C#.NET",
      "C++": "C++",
      "CakePHP": "CakePHP",
      "Calculatie in productie": "Calculation in production",
      "Calculatievaardig": "Calculation-savvy",
      "Calcule": "Calculation",
      "Calypso": "Calypso",
      "Camera knowledge": "Camera knowledge",
      "Camera/vision systems": "Camera/vision systems",
      "Cameratoezicht": "Video surveillance",
      "Campagne-ontwikkeling": "Campaign development",
      "Campaign Performance Manager": "Campaign Performance Manager",
      "Can do attitude": "Can do attitude",
      "Cancel": "Cancel",
      "CANDIDATE DETAILS:": "CANDIDATE DETAILS:",
      "Candidate Summary:": "Candidate Summary:",
      "Candidate:": "Candidate:",
      "Caneco": "Caneco",
      "CAO/CLA - link and details": "Collective Labor Agreements - link and details",
      "Capex controlling": "Capex controlling",
      "Capital": "Capital",
      "Care Planning": "Care Planning",
      "Cascading Style Sheets (CSS)": "Cascading Style Sheets (CSS)",
      "Casf": "Casf",
      "Cash Management": "Cash Management",
      "Cassandra": "Cassandra",
      "Categorie Management": "Category Management",
      "Catering": "Catering",
      "CEH (Certified Ethical Hacker)": "CEH (Certified Ethical Hacker)",
      "Celery": "Celery",
      "Celonis": "Celonis",
      "CentOS": "CentOS",
      "Certificate": "Certificate",
      "Certification pl900": "Certification pl900",
      "Change Management": "Change Management",
      "Channel Sales": "Channel Sales",
      "Chauffeur-Livreur": "Driver / Delivery Person",
      "Check in your ATS that your jobs have the correct settings to use this feature.": "Check in your ATS that your jobs have the correct settings to use this feature.",
      "Check specific expertise": "Check specific expertise",
      "Checking your URL": "Checking your URL",
      "Chef": "Chef",
      "Chemical Engineering": "Chemical Engineering",
      "Chemische Technologie": "Chemical Technology",
      "Chinese": "Chinese",
      "Ci/c": "Ci/c",
      "CI/CD": "CI/CD",
      "CI/CD on Azure DevOps": "CI/CD on Azure DevOps",
      "CI/CD Pipelines": "CI/CD Pipelines",
      "Cicd": "Cicd",
      "Cijfermatig inzicht": "Numerical insight",
      "Cilvil works": "Civil works",
      "Cisco": "Cisco",
      "Cisco aci": "Cisco aci",
      "Cisco Certified Architect (CCAr)": "Cisco Certified Architect (CCAr)",
      "Cisco Certified Design Associate (CCDA)": "Cisco Certified Design Associate (CCDA)",
      "Cisco Certified Design Expert (CCDE)": "Cisco Certified Design Expert (CCDE)",
      "Cisco Certified Design Professional (CCDP)": "Cisco Certified Design Professional (CCDP)",
      "Cisco Certified Entry Networking Technician (CCENT)": "Cisco Certified Entry Networking Technician (CCENT)",
      "Cisco Certified Internetwork Expert (CCIE)": "Cisco Certified Internetwork Expert (CCIE)",
      "Cisco Certified Network Associate (CCNA)": "Cisco Certified Network Associate (CCNA)",
      "Cisco Certified Network Professional (CCNP)": "Cisco Certified Network Professional (CCNP)",
      "Cisco Certified Technician (CCT)": "Cisco Certified Technician (CCT)",
      "Cisco Networking": "Cisco Networking",
      "Cisco Routing & Switching": "Cisco Routing & Switching",
      "Cisco Security": "Cisco Security",
      "Cisco Systems Products": "Cisco Systems Products",
      "Cisco Wireless": "Cisco Wireless",
      "Cism": "Cism",
      "Citizen / national": "Citizen / national",
      "Citrix": "Citrix",
      "Citrix Engineers": "Citrix Engineers",
      "Civil Engineering": "Civil Engineering",
      "Civil works": "Civil works",
      "Clean architecture/clean code": "Clean architecture/clean code",
      "Clean Code": "Clean Code",
      "Cleaning": "Cleaning",
      "ClickHouse": "ClickHouse",
      "Client Management": "Client Management",
      "Client-side development": "Client-side development",
      "Clojure": "Clojure",
      "Cloud": "Cloud",
      "Cloud (aws)": "Cloud (aws)",
      "Cloud Architect": "Cloud Architect",
      "Cloud Architecture": "Cloud Architecture",
      "Cloud Architectures": "Cloud Architectures",
      "Cloud Computing": "Cloud Computing",
      "Cloud Development": "Cloud Development",
      "Cloud Engineers": "Cloud Engineers",
      "Cloud environments": "Cloud environments",
      "Cloud Formation": "Cloud Formation",
      "Cloud Governance": "Cloud Governance",
      "Cloud migration": "Cloud migration",
      "Cloud Platforms": "Cloud Platforms",
      "Cloud Run": "Cloud Run",
      "Cloud Security": "Cloud Security",
      "Cloud Services": "Cloud Services",
      "Cloud Systems": "Cloud Systems",
      "Cloud technologies": "Cloud technologies",
      "Cloudbeveiliging": "Cloud security",
      "Cloudnetwerken": "Cloud networking",
      "Cloudoplossingen": "Cloud solutions",
      "Cloverleaf": "Cloverleaf",
      "Cluster": "Cluster",
      "Cncf": "Cncf",
      "Coaching": "Coaching",
      "COAX Netwerk Ontwerp": "COAX Network Design",
      "Cobit": "Cobit",
      "Cobol": "Cobol",
      "Cocon": "Cocon",
      "Code Maintenance": "Code Maintenance",
      "Code Reviews": "Code Reviews",
      "Cognos": "Cognos",
      "Cold acquisition": "Cold acquisition",
      "Collaborate": "Collaborate",
      "Collaborative Skills": "Collaborative Skills",
      "Collibra": "Collibra",
      "Commercial Knoweldge": "Commercial knowledge",
      "Commercial mindset": "Commercial mindset",
      "Commercieel": "Commercial",
      "Commercieel Ingesteld": "Commercially minded",
      "Commercieel Inzicht": "Commercial insight",
      "Commerciële drive": "Commercial drive",
      "Commerciële ervaring": "Commercial experience",
      "Commerciële vaardigheden": "Commercial skills",
      "Communicatie": "Communication",
      "Communicatief": "Communicative",
      "Communicatief sterk": "Communicatively strong",
      "Communicatief vaardig": "Communicatively skilled",
      "Communicatieve Vaardigheden": "Communication skills",
      "Communication": "Communication",
      "Communication Skills": "Communication Skills",
      "Communicative Skills": "Communicative Skills",
      "Community Management": "Community Management",
      "Company name": "Company name",
      "Company:": "Company:",
      "Compassion": "Compassion",
      "Compensation&benefits": "Compensation&benefits",
      "Compétences Organisationnelles": "Organizational skills",
      "Competitive": "Competitive",
      "Compliance": "Compliance",
      "Compliancy": "Compliancy",
      "Compute": "Compute",
      "Computer": "Computer",
      "Computer Assembly": "Computer Assembly",
      "Computer Science Masters": "Computer Science Masters",
      "Computer Vision Expert": "Computer Vision Expert",
      "Computerkennis": "Computer knowledge",
      "Conceptual thinking": "Conceptual thinking",
      "Conduite": "Driving",
      "Configuratiemanagement": "Configuration management",
      "Confirmed rtw": "Confirmed rtw",
      "Confluence": "Confluence",
      "Confluent/Kafka": "Confluent/Kafka",
      "Connectivity": "Connectivity",
      "Construction": "Construction",
      "Construction management": "Construction management",
      "Construction Manager": "Construction Manager",
      "Consultancy": "Consultancy",
      "Consultancy sales experience": "Consultancy sales experience",
      "Consultant": "Consultant",
      "Consultants": "Consultants",
      "Consultative Selling": "Consultative Selling",
      "Consulting": "Consulting",
      "Consulting skills": "Consulting skills",
      "Consumer Insights": "Consumer Insights",
      "Contacting ATS": "Contacting ATS",
      "Container technologies": "Container technologies",
      "Containerization": "Containerization",
      "Containers and Orchestrators": "Containers and Orchestrators",
      "Content Design": "Content Design",
      "Content Marketing": "Content Marketing",
      "Content Marketing Manager": "Content Marketing Manager",
      "Content Strategy": "Content Strategy",
      "Content Writer": "Content Writer",
      "Content Writing": "Content Writing",
      "Continuous": "Continuous",
      "Continuous Deployment": "Continuous Deployment",
      "Continuous Integration": "Continuous Integration",
      "Continuous Integration & Delivery (CI/CD)": "Continuous Integration & Delivery (CI/CD)",
      "Continuous security assurance": "Continuous security assurance",
      "Contract Management": "Contract Management",
      "Contract negotiations": "Contract negotiations",
      "Contract rate": "Contract rate",
      "Contract type/hours (optional)": "Contract type/hours (optional)",
      "contract-to-perm": "Contract-to-perm",
      "Contractbeheer": "Contract management",
      "Contractenrecht": "Contract law",
      "Control Engineer": "Control Engineer",
      "Controlling": "Controlling",
      "Cooking": "Cooking",
      "Coördinatie": "Coordination",
      "Coordinating experience": "Coordinating experience",
      "Copa": "Copa",
      "Copywriter": "Copywriter",
      "Copywriting": "Copywriting",
      "Corporate": "Corporate",
      "Corporate Finance": "Corporate Finance",
      "Corporate training exp.": "Corporate training exp.",
      "Cqrs": "CQRS",
      "Creatief denken": "Creative thinking",
      "Creatieve oplossingen": "Creative solutions",
      "Creating job in HirePort": "Creating job in HirePort",
      "Creative Design": "Creative Design",
      "Creativity": "Creativity",
      "Credit management": "Credit management",
      "Credit risk": "Credit risk",
      "Crm & sales navigator": "CRM & Sales Navigator",
      "Crm solutions": "CRM solutions",
      "CRM Specialist": "CRM Specialist",
      "Cro": "CRO",
      "Croatian": "Croatian",
      "Crystal Reports": "Crystal Reports",
      "Csadf": "CSADF",
      "Csrd": "CSRD",
      "Css": "CSS",
      "ctp": "Contract-to-perm",
      "Cucumber": "Cucumber",
      "Currently inheriting: {{currency}}": "Currently inheriting: {{currency}}",
      "Customer": "Customer",
      "Customer Experience": "Customer Experience",
      "Customer Experience Manager": "Customer Experience Manager",
      "Customer Marketing": "Customer Marketing",
      "Customer Relations": "Customer Relations",
      "Customer Service": "Customer Service",
      "Customer Service Representative": "Customer Service Representative",
      "Customer Success": "Customer Success",
      "Customer Success Manager": "Customer Success Manager",
      "Customer Support": "Customer Support",
      "Customer_service": "Customer service",
      "Cv-installaties": "HVAC installations",
      "CyberArk": "CyberArk",
      "Cybersecurity": "Cybersecurity",
      "Cybersecurity Analyst": "Cybersecurity Analyst",
      "Cybersecurity Information Technology": "Cybersecurity Information Technology",
      "Cypress": "Cypress",
      "Czech": "Czech",
      "daily": "daily",
      "Danish": "Danish",
      "Dashboard not available for this section": "Dashboard not available for this section",
      "dassdaasd": "dassdaasd",
      "Data": "Data",
      "Data (main)": "Data (main)",
      "Data Analyse": "Data analysis",
      "Data Analysis": "Data Analysis",
      "Data Analyst": "Data Analyst",
      "Data Analytics": "Data Analytics",
      "Data architectuur": "Data architecture",
      "Data consultants": "Data consultants",
      "Data e": "Data engineering",
      "Data Engineering": "Data Engineering",
      "Data Engineering on Microsoft Azure (DP-203)": "Data Engineering on Microsoft Azure (DP-203)",
      "Data Engineers": "Data Engineers",
      "Data Entry Clerk": "Data Entry Clerk",
      "Data Exploration": "Data Exploration",
      "Data governance": "Data governance",
      "Data governance and performance": "Data governance and performance",
      "Data Ingestion": "Data Ingestion",
      "Data Integration": "Data Integration",
      "Data Management": "Data Management",
      "Data management frameworks": "Data management frameworks",
      "Data mart": "Data mart",
      "Data Migration": "Data Migration",
      "Data Mining": "Data Mining",
      "Data Modeling": "Data Modeling",
      "Data Modelling": "Data Modelling",
      "Data orchestration tools": "Data orchestration tools",
      "Data persistency": "Data persistency",
      "Data Protection": "Data Protection",
      "Data Protection Impact Assessments": "Data Protection Impact Assessments",
      "Data Quality Support": "Data Quality Support",
      "Data Science": "Data Science",
      "Data Scientists": "Data Scientists",
      "Data Storytelling": "Data Storytelling",
      "Data strategie": "Data strategy",
      "Data vault": "Data vault",
      "Data Visualization": "Data Visualization",
      "Data Warehousing": "Data Warehousing",
      "Data-analyse": "Data analysis",
      "Database": "Database",
      "Database Administration": "Database Administration",
      "Database Design": "Database Design",
      "Database Development": "Database Development",
      "Database management": "Database management",
      "Database Specialists": "Database Specialists",
      "Databases": "Databases",
      "Databricks": "Databricks",
      "Datadog": "Datadog",
      "Datafactory": "Data Factory",
      "Datagovernance": "Data governance",
      "Datakwaliteit": "Data quality",
      "Datalake": "Data lake",
      "Datalakes": "Data lakes",
      "Datalekbeheer": "Data leak management",
      "Datamanagement,": "Data management",
      "Dataservices": "Data services",
      "Dataverse": "Dataverse",
      "Datawarehouse": "Data warehouse",
      "Dates:": "Dates:",
      "Dax": "DAX",
      "days": "days",
      "days per year": "days per year",
      "Db2": "DB2",
      "dbSchema": "dbSchema",
      "Dbt": "dbt",
      "Deactivate": "Deactivate",
      "Debian/Ubuntu": "Debian/Ubuntu",
      "Decision:": "Decision:",
      "Dedicated": "Dedicated",
      "Deep Learning": "Deep Learning",
      "Defender": "Defender",
      "Delivery": "Delivery",
      "Delivery Driver": "Delivery Driver",
      "Delivery Drivers": "Delivery Drivers",
      "Design": "Design",
      "Design & Construct": "Design & Construct",
      "Detail-oriented": "Detail-oriented",
      "Details": "Details",
      "DevOps": "DevOps",
      "DevOps Engineering": "DevOps Engineering",
      "DevOps Engineers": "DevOps Engineers",
      "DevOps Manager": "DevOps Manager",
      "Dfgdfgd": "Dfgdfgd",
      "DigiD account": "DigiD account",
      "Digidalisering": "Digitalization",
      "Digital Advertising Specialist": "Digital Advertising Specialist",
      "Digital Commerce": "Digital Commerce",
      "Digital Forensics": "Digital Forensics",
      "Digital hz": "Digital hz",
      "Digital Marketing": "Digital Marketing",
      "Digital Marketing Specialist": "Digital Marketing Specialist",
      "Digital Sales": "Digital Sales",
      "Digital Strategist": "Digital Strategist",
      "Digital twin": "Digital twin",
      "Digitale customer journeys": "Digital customer journeys",
      "Digitale marketing": "Digital marketing",
      "Digitale Ontwikkeling": "Digital development",
      "Digitale Ontwikkelingen": "Digital developments",
      "Digitale systemen": "Digital systems",
      "Digitale transformatie": "Digital transformation",
      "Digitale vaardigheden": "Digital skills",
      "Digitale verkoop": "Digital sales",
      "Digitali": "Digital",
      "Digitalisering": "Digitalization",
      "Direct colleague hiring/promotion experience": "Direct colleague hiring/promotion experience",
      "Direct Marketing": "Direct Marketing",
      "Display": "Display",
      "Distribution": "Distribution",
      "Diversity, Equity and Inclusion": "Diversity, Equity and Inclusion",
      "Django": "Django",
      "Dns": "DNS",
      "Docke": "Docker",
      "Docker": "Docker",
      "Doctor of Philisophy (PhD)": "Doctor of Philosophy (PhD)",
      "Documentatiebeheer": "Documentation management",
      "Documentation": "Documentation",
      "Doelgericht": "Goal-oriented",
      "Domain": "Domain",
      "Domain-Driven Design": "Domain-Driven Design",
      "Domain-Driven Design (DDD)": "Domain-Driven Design (DDD)",
      "Domain:": "Domain:",
      "Doorzettingsvermogen": "Perseverance",
      "DotNetNuke": "DotNetNuke",
      "DP 203": "DP 203",
      "DP 900": "DP 900",
      "Dr.": "Dr.",
      "Drawing up annual accounts": "Drawing up annual accounts",
      "Driver's license": "Driver's license",
      "Driving": "Driving",
      "Drs.": "Drs.",
      "Drupal": "Drupal",
      "Duitse taalvaardigheden": "German language skills",
      "Dutch": "Dutch",
      "Dutch gaap": "Dutch GAAP",
      "Duurzaamheid": "Sustainability",
      "Duurzaamheid Innovatie": "Sustainability innovation",
      "Duurzame Technologieën": "Sustainable technologies",
      "Dv": "DV",
      "Dv360": "DV360",
      "Dwp": "DWP",
      "Dynamics 365": "Dynamics 365",
      "Dynamics ERP": "Dynamics ERP",
      "Dynamics365": "Dynamics 365",
      "Dynatrace": "Dynatrace",
      "E-commerce": "E-commerce",
      "E-commerce ervaring": "E-commerce experience",
      "E-commerce Manager": "E-commerce Manager",
      "E-Plan": "E-Plan",
      "Earn:": "Earn:",
      "Eba": "EBA",
      "ECE R10 (Automotive EMC)": "ECE R10 (Automotive EMC)",
      "ECE R100": "ECE R100",
      "Edi processes": "EDI processes",
      "Edr": "EDR",
      "Educated": "Educated",
      "Education": "Education",
      "Education & Instruction": "Education & Instruction",
      "Efficiënt werken": "Working efficiently",
      "Eigenaarschap": "Ownership",
      "Eigrp": "EIGRP",
      "Eimantas": "test-Eimantas",
      "Elastic Search": "Elastic Search",
      "ElasticSearch": "Elasticsearch",
      "Elasticsearch (ELK stack)": "Elasticsearch (ELK stack)",
      "Electrical Architect - Automotive": "Electrical Architect - Automotive",
      "Electrical Architect - Batteries": "Electrical Architect - Batteries",
      "Electrical Architect - Connection": "Electrical Architect - Connection",
      "Electrical Architect - Embedded": "Electrical Architect - Embedded",
      "Electrical Architect - High Voltage": "Electrical Architect - High Voltage",
      "Electrical Architect - Low Voltage": "Electrical Architect - Low Voltage",
      "Electrical Battery Systems": "Electrical Battery Systems",
      "Electrical Engineering": "Electrical Engineering",
      "Electrical schematics": "Electrical schematics",
      "Electronics": "Electronics",
      "Electrotechniek": "Electrical engineering",
      "Elektrotechniek": "Electrical engineering",
      "Elektrotechniek of werktuigbouw": "Electrical engineering or mechanical engineering",
      "Elixir": "Elixir",
      "Email Marketing": "Email Marketing",
      "Embedded Software": "Embedded Software",
      "Embedded Software Engineer": "Embedded Software Engineer",
      "Embedded Systems": "Embedded Systems",
      "Embedded Systems Development": "Embedded Systems Development",
      "Ember.js": "Ember.js",
      "EMI principles (EMC)": "EMI principles (EMC)",
      "Employee Relations": "Employee Relations",
      "Employer Branding": "Employer Branding",
      "Employment": "Employment",
      "Employment Law and Compliance": "Employment Law and Compliance",
      "Encryption": "Encryption",
      "End Date (optional)": "End Date (optional)",
      "Endpoint Manager": "Endpoint Manager",
      "Energiesystemen": "Energy systems",
      "Energietechniek": "Energy technology",
      "Energy": "Energy",
      "Energy Policy": "Energy Policy",
      "Engels": "English",
      "Engelse taal": "English language",
      "Engineer": "Engineer",
      "Engineer,": "Engineer",
      "Engineering": "Engineering",
      "Engineering (main)": "Engineering (main)",
      "Engineering Manager": "Engineering Manager",
      "Engineers & Reviseurs": "Engineers & Auditors",
      "English": "English",
      "Enter city": "Enter city",
      "Enter email address": "Enter email address",
      "Enter full name": "Enter full name",
      "Enter job details": "Enter job details",
      "Enter phone number (optional)": "Enter phone number (optional)",
      "Enterprise Application Manager": "Enterprise Application Manager",
      "Enterprise Architect": "Enterprise Architect",
      "Enterprise Architecture": "Enterprise Architecture",
      "Enterprise Architectuur": "Enterprise Architecture",
      "Enterprise Environment Compliance": "Enterprise Environment Compliance",
      "Enterprise/process architecture": "Enterprise/process architecture",
      "Enthousiast": "Enthusiastic",
      "Entity Framework": "Entity Framework",
      "Entity Framework Core": "Entity Framework Core",
      "EntityFramework": "Entity Framework",
      "Entrepeneurial mindset": "Entrepreneurial mindset",
      "Entrepreneurship": "Entrepreneurship",
      "Environmental Consulting": "Environmental Consulting",
      "Environmental Education": "Environmental Education",
      "Epm": "EPM",
      "Equity Funding": "Equity Funding",
      "ER/Studio": "ER/Studio",
      "Erp": "ERP",
      "ERP Consultant": "ERP Consultant",
      "ERP System": "ERP System",
      "Ervaring": "Experience",
      "Ervaring (5+ jaar)": "Experience (5+ years)",
      "Ervaring automotive branche": "Experience in the automotive industry",
      "Ervaring in event branche": "Experience in the event industry",
      "Ervaring in financiële dienstverlening": "Experience in financial services",
      "Ervaring in golfkartonbranche": "Experience in the corrugated cardboard industry",
      "Ervaring in technische omgeving": "Experience in a technical environment",
      "Ervaring in veiligheid": "Experience in safety",
      "Ervaring met contractmanagement": "Experience with contract management",
      "Ervaring met qsp": "Experience with QSP",
      "ErWIN": "ErWIN",
      "Estate Planning": "Estate Planning",
      "Estimator": "Estimator",
      "Estonian": "Estonian",
      "Ethical Hacking": "Ethical Hacking",
      "ETL/ELT": "ETL/ELT",
      "Eu citizen": "EU citizen",
      "Evenementenbranche": "Event industry",
      "Event Coordinator": "Event Coordinator",
      "Event management": "Event management",
      "Event Marketing": "Event Marketing",
      "Event Planner": "Event Planner",
      "Event Sourcing": "Event Sourcing",
      "EVP Development": "EVP Development",
      "Exact": "Exact",
      "Exact Online": "Exact Online",
      "Exact Synergy": "Exact Synergy",
      "Excel": "Excel",
      "Exchange": "Exchange",
      "Exchange online": "Exchange Online",
      "Executive Search": "Executive Search",
      "Exp. in tracking, reporting on performance metrics": "Exp. in tracking, reporting on performance metrics",
      "Exp. managing change processes": "Exp. managing change processes",
      "Exp. w/ hr & c-level corporates": "Experience with HR & C-level corporates",
      "Expected hours per week (optional)": "Expected hours per week (optional)",
      "Experience": "Experience",
      "Experience in (heavy) industry or high voltage": "Experience in (heavy) industry or high voltage",
      "Experience in a Principal role at another company": "Experience in a Principal role at another company",
      "Experience in a Technical Environment": "Experience in a Technical Environment",
      "Experience in infra industry": "Experience in infra industry",
      "Experience in it environment": "Experience in an IT environment",
      "Experience in project management": "Experience in project management",
      "Experience in safety/quality": "Experience in safety/quality",
      "Experience in the automotive": "Experience in the automotive",
      "Experience in yacht building": "Experience in yacht building",
      "Experience with case management": "Experience with case management",
      "Experience with general ledger functions and the month-end/year-end closing process": "Experience with general ledger functions and the month-end/year-end closing process",
      "Experience with implementing distributed systems": "Experience with implementing distributed systems",
      "Experience with large IT landscapes": "Experience with large IT landscapes",
      "Experience with motion control": "Experience with motion control",
      "Experience with pen testing and code reviews": "Experience with pen testing and code reviews",
      "Experience working with C-level": "Experience working with C-level",
      "Exploits Development": "Exploits Development",
      "Express": "Express",
      "External auditing": "External auditing",
      "External auditors": "External auditors",
      "Extravert": "Extrovert",
      "Fabrication": "Fabrication",
      "Facility applications": "Facility applications",
      "factor": "factor",
      "Factor/Rate": "Factor/Rate",
      "Facturatiecoördinatie": "Invoicing coordination",
      "Failed to add user to your company": "Failed to add user to your company",
      "Failed to load company users": "Failed to load company users",
      "FastAPI": "FastAPI",
      "Fastlane": "Fastlane",
      "Feature Manipulation Engine (FME)": "Feature Manipulation Engine (FME)",
      "Fico": "FICO",
      "Figma": "Figma",
      "Finance": "Finance",
      "Finance (main)": "Finance (main)",
      "Finance Associate": "Finance Associate",
      "Finance Management": "Finance Management",
      "Financial accounting processes": "Financial accounting processes",
      "Financial Analysis": "Financial Analysis",
      "Financial Analyst": "Financial Analyst",
      "Financial Controller": "Financial Controller",
      "Financial Instruments Knowledge": "Financial Instruments Knowledge",
      "Financial knowledge": "Financial knowledge",
      "Financial knowledge of": "Financial knowledge of",
      "Financial knowledge of sme's": "Financial knowledge of SMEs",
      "Financial knowledge of smes": "Financial knowledge of SMEs",
      "Financial modeling": "Financial modeling",
      "Financial Operations": "Financial Operations",
      "Financial Planning and Analysis": "Financial Planning and Analysis",
      "Financial Product Knowledge": "Financial Product Knowledge",
      "Financial Reporting": "Financial Reporting",
      "Financial Statements": "Financial Statements",
      "Financial Systems": "Financial Systems",
      "Financieel analist": "Financial analyst",
      "Financieel en analytisch inzicht": "Financial and analytical insight",
      "Financieel inzicht": "Financial insight",
      "Financiële administratie": "Financial administration",
      "Financiële Analyse": "Financial analysis",
      "Financiële analyses": "Financial analyses",
      "Financiële Dienstverlening": "Financial services",
      "Financiële kennis": "Financial knowledge",
      "Financiering": "Financing",
      "Finnish": "Finnish",
      "FinTech": "FinTech",
      "Firebase": "Firebase",
      "Firewalling": "Firewalling",
      "Firewalls": "Firewalls",
      "Firmware": "Firmware",
      "Fiscaal Advies": "Tax advice",
      "Fiscaal Recht": "Tax law",
      "Fiscale advisering": "Tax advisory",
      "Fiscale Controle": "Tax audit",
      "Fiscale Economie": "Tax economics",
      "Fiscale kennis": "Tax knowledge",
      "Fivetran": "Fivetran",
      "Fixed and mobile telephony": "Fixed and mobile telephony",
      "Flexibel": "Flexible",
      "Flexibiliteit": "Flexibility",
      "Flexibiliteit in noodsituaties": "Flexibility in emergency situations",
      "Flexibility": "Flexibility",
      "Flexible": "Flexible",
      "Flink": "Flink",
      "Fluence": "Fluence",
      "Fluent dutch": "Fluent Dutch",
      "Fluent french": "Fluent French",
      "Flutter": "Flutter",
      "FluX-Fullstack.net": "FluX-Fullstack.net",
      "Focus on code quality (readability, reusability, documentation, linting, testing, etc)": "Focus on code quality (readability, reusability, documentation, linting, testing, etc)",
      "Foreman": "Foreman",
      "Fortinet": "Fortinet",
      "Fortran": "Fortran",
      "freelance": "Freelance",
      "French": "French",
      "From:": "From:",
      "Front-End": "Front-End",
      "Front-End Developers": "Front-End Developers",
      "Front-end Development": "Front-end Development",
      "Frontend Development": "Frontend Development",
      "Frontend Experience": "Frontend Experience",
      "Führung": "Leadership",
      "Full Stack Development": "Full Stack Development",
      "Full-stack": "Full-stack",
      "Fullstack Developers": "Fullstack Developers",
      "Functional Manager": "Functional Manager",
      "Functional Programming": "Functional Programming",
      "Fundraising": "Fundraising",
      "Game Development": "Game Development",
      "Gap": "Gap",
      "Gastvrij": "Hospitable",
      "Gbs, gebouw beheer systemen": "BMS, building management systems",
      "Geautomatiseerde processen": "Automated processes",
      "Gedisciplineerd": "Disciplined",
      "Geinter": "Interested",
      "Geïnteresseerd": "Interested",
      "Geinteresserd": "Interested",
      "General Business": "General Business",
      "General Data Protection Regulation (GDPR)": "General Data Protection Regulation (GDPR)",
      "General HR": "General HR",
      "Generating HirePort job data": "Generating HirePort job data",
      "Generating job data": "Generating job data",
      "Generative ai": "Generative AI",
      "Geo-kennis": "GIS knowledge",
      "Geographic Information Systems (GIS)": "Geographic Information Systems (GIS)",
      "Geothermal energy b": "Geothermal energy b",
      "Geothermal energy e": "Geothermal energy e",
      "German": "German",
      "Gestion Administrative": "Administrative management",
      "Gestion Des Ressources Humaines": "Human resources management",
      "Gestructureerd Werken": "Structured working",
      "Gis": "GIS",
      "Git": "Git",
      "GitHub": "GitHub",
      "GitHub profile": "GitHub profile",
      "GitLab": "GitLab",
      "GitOps": "GitOps",
      "Give feedback": "Give feedback",
      "Glasvezel Netwerk Ontwerp": "Fiber-optic network design",
      "Glue (AWS)": "Glue (AWS)",
      "Go": "Go",
      "Go (Programming Language)": "Go (Programming Language)",
      "Goed inlevingsvermogen": "Good empathy",
      "Goede gesprekstechnieken": "Strong conversation techniques",
      "Goede kennis nederlands": "Good knowledge of Dutch",
      "Golang": "Golang",
      "Google Ads": "Google Ads",
      "Google ads editor": "Google Ads Editor",
      "Google Analytics": "Google Analytics",
      "Google big query": "Google BigQuery",
      "Google Cloud": "Google Cloud",
      "Google Cloud Platform (GCP)": "Google Cloud Platform (GCP)",
      "Google workspace": "Google Workspace",
      "Governance": "Governance",
      "Government_nonprofit": "Government / nonprofit",
      "Gradle": "Gradle",
      "Grafana": "Grafana",
      "Graphene": "Graphene",
      "Graphic Design": "Graphic Design",
      "Graphic Designer": "Graphic Designer",
      "GraphQL": "GraphQL",
      "Greek": "Greek",
      "Green Technology": "Green Technology",
      "Greencard": "Green card",
      "Group policy's": "Group policies",
      "Growth Hacker": "Growth Hacker",
      "Growth Hacking": "Growth Hacking",
      "Growth Marketing": "Growth Marketing",
      "Grpc": "gRPC",
      "H:mm": "H:mm",
      "Hadoop": "Hadoop",
      "Handmatig herstellen": "Manual recovery",
      "Hands-on": "Hands-on",
      "Hardware Engineer": "Hardware Engineer",
      "Hazardous substances": "Hazardous substances",
      "Hbo-denkniveau": "Bachelor's-level thinking",
      "Hbo-level": "Bachelor's level",
      "Hbo/wo working & thinking level": "Bachelor's/Master's working & thinking level",
      "Hbo/wo workinh & thinking": "Bachelor's/Master's working & thinking",
      "Head of Legal": "Head of Legal",
      "Health Care Provider": "Health Care Provider",
      "Healthcare": "Healthcare",
      "Healthcare Management": "Healthcare Management",
      "Hebrew": "Hebrew",
      "Hendenhain operating system": "Heidenhain operating system",
      "Herstructurering": "Restructuring",
      "Hibernate": "Hibernate",
      "Hibernate or jpa": "Hibernate or JPA",
      "High voltage (automotive, <1000V)": "High voltage (automotive, <1000V)",
      "High-energy": "High-energy",
      "High-energy level": "High-energy level",
      "High-load events per second": "High-load events per second",
      "High-tech/manufacturing": "High-tech/manufacturing",
      "High-throughput event handling": "High-throughput event handling",
      "Hipaa": "HIPAA",
      "hired": "Hired",
      "Holiday allowance": "Holiday allowance",
      "Holidays": "Holidays",
      "Horticulture sector": "Horticulture sector",
      "Hospitality": "Hospitality",
      "hourly": "hourly",
      "Hours per week": "Hours per week",
      "How did you enjoy working with the client?": "How did you enjoy working with the client?",
      "How did you enjoy working with the recruiter?": "How was your experience working with the recruiter?",
      "How is the communication with the company so far?": "How is the communication with the company so far?",
      "How is the communication with the recruiter so far?": "How is communication with the recruiter so far?",
      "How quick was the company in reviewing the profile?": "How quick was the company in reviewing the profile?",
      "How quickly did the recruiter respond so far?": "How quickly has the recruiter responded so far?",
      "How well did the company provide reasons for rejecting the candidate?": "How well did the company provide reasons for rejecting the candidate?",
      "How well did the recruiter make the introduction?": "How well did the recruiter make the introduction?",
      "Hr": "HR",
      "Hr & c-suite in": "HR & C-suite in",
      "HR Advisors": "HR Advisors",
      "Hr experience": "HR experience",
      "Hr knowledge": "HR knowledge",
      "HR Manager": "HR Manager",
      "HR Technology": "HR Technology",
      "HR Training & Development": "HR Training & Development",
      "HR-administratie": "HR administration",
      "Hse": "HSE",
      "Hse certification": "HSE certification",
      "Html": "HTML",
      "Html/css": "HTML/CSS",
      "HubSpot": "HubSpot",
      "Huggin face": "Hugging Face",
      "Human Resources": "Human Resources",
      "Human Resources Business Partner": "Human Resources Business Partner",
      "Hungarian": "Hungarian",
      "Hyper-V": "Hyper-V",
      "Hyperledger": "Hyperledger",
      "Hypotheekacceptatie": "Mortgage acceptance",
      "Hypotheekbemiddeling": "Mortgage intermediation",
      "IaaS": "IaaS",
      "Ibm": "IBM",
      "IBM ACE/MQ": "IBM ACE/MQ",
      "IBM AIX": "IBM AIX",
      "IBM Cloud": "IBM Cloud",
      "IBM MDM Advanced Edition": "IBM MDM Advanced Edition",
      "IBM MDM CE": "IBM MDM CE",
      "ICND 1/2/NRS1/2 (voorheen CCNA 1/2)": "ICND 1/2/NRS1/2 (formerly CCNA 1/2)",
      "Ict": "ICT",
      "Ict knowledge": "ICT knowledge",
      "ICT Vaardigheden": "ICT skills",
      "Ict-bekwaam": "ICT-proficient",
      "ICT-infrastructuur oplossingen": "ICT infrastructure solutions",
      "ICT-vaardigheden": "ICT skills",
      "Identity & Access Management (IAM)": "Identity & Access Management (IAM)",
      "Identity and Access Management": "Identity and Access Management",
      "Ids": "IDS",
      "IEC 61851 (electric vehicle conductive charging systems)": "IEC 61851 (electric vehicle conductive charging systems)",
      "Iec27001": "IEC 27001",
      "Illustrator": "Illustrator",
      "Image Processing": "Image Processing",
      "Implementation and improvement management": "Implementation and improvement management",
      "Implementation standards": "Implementation standards",
      "Implementing new business models": "Implementing new business models",
      "Improving (financial) processes": "Improving (financial) processes",
      "In europe/us/uk": "In Europe/US/UK",
      "In process": "In Process",
      "Incremental project approach": "Incremental project approach",
      "Indefinite leave": "Indefinite leave",
      "Independence": "Independence",
      "Independent work": "Independent work",
      "Independent work attitude": "Independent work attitude",
      "Indesign": "InDesign",
      "Industrial Installations Knowledge": "Industrial Installations Knowledge",
      "Industry": "Industry",
      "Influencer Marketing": "Influencer Marketing",
      "Informatica": "Informatica",
      "Informatie Analist": "Information Analyst",
      "Information Security Analyst": "Information Security Analyst",
      "Information Security Officer (ISO)": "Information Security Officer (ISO)",
      "Information Technology": "Information Technology",
      "Information_technology": "Information Technology",
      "InfoSphere": "InfoSphere",
      "Infra": "Infrastructure",
      "Infrastructure": "Infrastructure",
      "Infrastructure as code (IaC)": "Infrastructure as code (IaC)",
      "Infrastructure security": "Infrastructure security",
      "Infrastructure security,": "Infrastructure Security",
      "Inhouse": "In-house",
      "Initiatief": "Initiative",
      "Initiatief tonen": "Showing Initiative",
      "Initiatiefrijk": "Proactive",
      "Initiative": "Initiative",
      "Inlevingsvermogen": "Empathy",
      "Innovatie": "Innovation",
      "Innovatief": "Innovative",
      "Innovatiegericht": "Innovation-Oriented",
      "Innovation Management": "Innovation Management",
      "Innovationsförderung": "Innovation Promotion",
      "Inside Sales": "Inside Sales",
      "Inside Sales Manager": "Inside Sales Manager",
      "Inside Sales Representative": "Inside Sales Representative",
      "Installatietechniek": "Installation Technology",
      "Installation": "Installation",
      "Instructional Design": "Instructional Design",
      "Insurance": "Insurance",
      "Insurance Industry Knowledge": "Insurance Industry Knowledge",
      "Insurance Management": "Insurance Management",
      "Integrated it solutions": "Integrated IT Solutions",
      "Integration": "Integration",
      "Integration Architecture": "Integration Architecture",
      "Integration Specialists": "Integration Specialists",
      "Intelec": "Intelec",
      "Intelligent Networks": "Intelligent Networks",
      "Intern": "Intern",
      "Internal Audit": "Internal Audit",
      "International Markets": "International Markets",
      "International Project Management Association (IPMA)": "International Project Management Association (IPMA)",
      "International Standard for Assurance Engagements (ISAE)": "International Standard for Assurance Engagements (ISAE)",
      "Internet": "Internet",
      "Internet of Things (IoT)": "Internet of Things (IoT)",
      "Internet Protocol Suite (TCP/IP)": "Internet Protocol Suite (TCP/IP)",
      "Interpersonal skills": "Interpersonal skills",
      "Interval": "Interval",
      "Interview date:": "Interview date:",
      "Interview dates are proposed": "Interview Dates Proposed",
      "Interview stage 1": "Interview Stage 1",
      "Interview stage 10": "Interview Stage 10",
      "Interview stage 100": "Interview stage 100",
      "Interview stage 101": "Interview stage 101",
      "Interview stage 102": "Interview stage 102",
      "Interview stage 103": "Interview stage 103",
      "Interview stage 104": "Interview stage 104",
      "Interview stage 105": "Interview stage 105",
      "Interview stage 106": "Interview stage 106",
      "Interview stage 107": "Interview stage 107",
      "Interview stage 108": "Interview stage 108",
      "Interview stage 109": "Interview stage 109",
      "Interview stage 11": "Interview Stage 11",
      "Interview stage 110": "Interview stage 110",
      "Interview stage 111": "Interview stage 111",
      "Interview stage 112": "Interview stage 112",
      "Interview stage 113": "Interview stage 113",
      "Interview stage 114": "Interview stage 114",
      "Interview stage 115": "Interview stage 115",
      "Interview stage 116": "Interview stage 116",
      "Interview stage 117": "Interview stage 117",
      "Interview stage 118": "Interview stage 118",
      "Interview stage 119": "Interview stage 119",
      "Interview stage 12": "Interview Stage 12",
      "Interview stage 120": "Interview stage 120",
      "Interview stage 121": "Interview stage 121",
      "Interview stage 13": "Interview Stage 13",
      "Interview stage 14": "Interview Stage 14",
      "Interview stage 15": "Interview Stage 15",
      "Interview stage 16": "Interview Stage 16",
      "Interview stage 17": "Interview Stage 17",
      "Interview stage 18": "Interview Stage 18",
      "Interview stage 19": "Interview Stage 19",
      "Interview stage 2": "Interview Stage 2",
      "Interview stage 20": "Interview Stage 20",
      "Interview stage 21": "Interview Stage 21",
      "Interview stage 22": "Interview Stage 22",
      "Interview stage 23": "Interview Stage 23",
      "Interview stage 24": "Interview Stage 24",
      "Interview stage 25": "Interview Stage 25",
      "Interview stage 26": "Interview Stage 26",
      "Interview stage 27": "Interview Stage 27",
      "Interview stage 28": "Interview Stage 28",
      "Interview stage 29": "Interview Stage 29",
      "Interview stage 3": "Interview Stage 3",
      "Interview stage 30": "Interview Stage 30",
      "Interview stage 31": "Interview Stage 31",
      "Interview stage 32": "Interview Stage 32",
      "Interview stage 33": "Interview Stage 33",
      "Interview stage 34": "Interview Stage 34",
      "Interview stage 35": "Interview Stage 35",
      "Interview stage 36": "Interview Stage 36",
      "Interview stage 37": "Interview Stage 37",
      "Interview stage 38": "Interview Stage 38",
      "Interview stage 39": "Interview Stage 39",
      "Interview stage 4": "Interview Stage 4",
      "Interview stage 40": "Interview Stage 40",
      "Interview stage 41": "Interview Stage 41",
      "Interview stage 42": "Interview Stage 42",
      "Interview stage 43": "Interview Stage 43",
      "Interview stage 44": "Interview Stage 44",
      "Interview stage 45": "Interview Stage 45",
      "Interview stage 46": "Interview Stage 46",
      "Interview stage 47": "Interview Stage 47",
      "Interview stage 48": "Interview Stage 48",
      "Interview stage 49": "Interview Stage 49",
      "Interview stage 5": "Interview Stage 5",
      "Interview stage 50": "Interview Stage 50",
      "Interview stage 51": "Interview Stage 51",
      "Interview stage 52": "Interview Stage 52",
      "Interview stage 53": "Interview Stage 53",
      "Interview stage 54": "Interview Stage 54",
      "Interview stage 55": "Interview Stage 55",
      "Interview stage 56": "Interview Stage 56",
      "Interview stage 57": "Interview Stage 57",
      "Interview stage 58": "Interview Stage 58",
      "Interview stage 59": "Interview Stage 59",
      "Interview stage 6": "Interview Stage 6",
      "Interview stage 60": "Interview Stage 60",
      "Interview stage 61": "Interview Stage 61",
      "Interview stage 62": "Interview stage 62",
      "Interview stage 63": "Interview stage 63",
      "Interview stage 64": "Interview stage 64",
      "Interview stage 65": "Interview stage 65",
      "Interview stage 66": "Interview stage 66",
      "Interview stage 67": "Interview stage 67",
      "Interview stage 68": "Interview stage 68",
      "Interview stage 69": "Interview stage 69",
      "Interview stage 7": "Interview Stage 7",
      "Interview stage 70": "Interview stage 70",
      "Interview stage 71": "Interview stage 71",
      "Interview stage 72": "Interview stage 72",
      "Interview stage 73": "Interview stage 73",
      "Interview stage 74": "Interview stage 74",
      "Interview stage 75": "Interview stage 75",
      "Interview stage 76": "Interview stage 76",
      "Interview stage 77": "Interview stage 77",
      "Interview stage 78": "Interview stage 78",
      "Interview stage 79": "Interview stage 79",
      "Interview stage 8": "Interview Stage 8",
      "Interview stage 80": "Interview stage 80",
      "Interview stage 81": "Interview stage 81",
      "Interview stage 82": "Interview stage 82",
      "Interview stage 83": "Interview stage 83",
      "Interview stage 84": "Interview stage 84",
      "Interview stage 85": "Interview stage 85",
      "Interview stage 86": "Interview stage 86",
      "Interview stage 87": "Interview stage 87",
      "Interview stage 88": "Interview stage 88",
      "Interview stage 89": "Interview stage 89",
      "Interview stage 9": "Interview Stage 9",
      "Interview stage 90": "Interview stage 90",
      "Interview stage 91": "Interview stage 91",
      "Interview stage 92": "Interview stage 92",
      "Interview stage 93": "Interview stage 93",
      "Interview stage 94": "Interview stage 94",
      "Interview stage 95": "Interview stage 95",
      "Interview stage 96": "Interview stage 96",
      "Interview stage 97": "Interview stage 97",
      "Interview stage 98": "Interview stage 98",
      "Interview stage 99": "Interview stage 99",
      "Interview stage:": "Interview stage:",
      "IntraOffice Digital Signing": "IntraOffice Digital Signing",
      "introduced": "Introduced",
      "Intune": "Intune",
      "Inventory Management": "Inventory Management",
      "Investment Banking": "Investment Banking",
      "Investor Relations": "Investor Relations",
      "Invite talent supplier": "Invite Agency",
      "Ionic Framework": "Ionic Framework",
      "iOS": "iOS",
      "IOS developer": "iOS Developer",
      "Iot": "IoT",
      "IoT Development": "IoT Development",
      "iPhone Application Development": "iPhone Application Development",
      "Ips": "IPS",
      "IPv6": "IPv6",
      "Irrbb": "IRRBB",
      "IS Management": "IS Management",
      "Is the rejection reason in line with the job description?": "Is the rejection reason in line with the job description?",
      "ISA/IEC 62443": "ISA/IEC 62443",
      "ISAE 3402": "ISAE 3402",
      "ISO 26262 (Road vehicles – Functional safety)": "ISO 26262 (Road vehicles – Functional safety)",
      "ISO 27001": "ISO 27001",
      "Iso 45001": "ISO 45001",
      "ISO 6469": "ISO 6469",
      "Iso 9001": "ISO 9001",
      "Iso55001": "ISO 55001",
      "It": "IT",
      "IT Advisory": "IT Advisory",
      "IT Affinity": "IT Affinity",
      "IT Auditor": "IT Auditor",
      "IT Background": "IT Background",
      "IT Consultant": "IT Consultant",
      "IT Operations Manager": "IT Operations Manager",
      "IT Project Management": "IT Project Management",
      "IT Project Manager": "IT Project Manager",
      "IT Recruitment": "IT Recruitment",
      "It risk and process management": "IT Risk and Process Management",
      "IT Security Specialist": "IT Security Specialist",
      "It software geimplementeerd": "IT Software Implemented",
      "It systems": "IT Systems",
      "Italian": "Italian",
      "Iterative process": "Iterative process",
      "ITIL Foundation V3": "ITIL Foundation V3",
      "ITIL-processen": "ITIL Processes",
      "J2ee": "J2EE",
      "Jamf": "Jamf",
      "Japanese": "Japanese",
      "Java": "Java",
      "Java (ee)": "Java (EE)",
      "Java script": "JavaScript",
      "Java, angular, spring,": "Java, Angular, Spring",
      "JavaScript": "JavaScript",
      "JBoss": "JBoss",
      "Jelly": "Jelly",
      "Jenkins": "Jenkins",
      "Jest": "Jest",
      "Jetpack compose": "Jetpack Compose",
      "Jetpack compose/ xml-based ui": "Jetpack Compose/XML-Based UI",
      "Jetpack libraries": "Jetpack libraries",
      "Jira": "Jira",
      "Jms": "JMS",
      "Job:": "Job:",
      "Joomla": "Joomla",
      "jQuery": "jQuery",
      "Jsp": "JSP",
      "Julia": "Julia",
      "Junior": "Junior",
      "Juniper": "Juniper",
      "JUnit": "JUnit",
      "Jupiter": "Jupiter",
      "Juridische affiniteit": "Legal Affinity",
      "Juridische Kennis": "Legal Knowledge",
      "Juridische opleiding": "Legal Education",
      "Kafka": "Kafka",
      "Kenneth Smit - Sales training": "Kenneth Smit - Sales training",
      "Kennis van ERP-software AFAS-Profit": "Knowledge of ERP Software AFAS-Profit",
      "Kennis van parkeerprocessen": "Knowledge of Parking Processes",
      "Kennis van RAW": "Knowledge of RAW",
      "Kennis van wet- en regelgeving": "Knowledge of Laws and Regulations",
      "Keras": "Keras",
      "Kibana": "Kibana",
      "Kimball": "Kimball",
      "Kinesis": "Kinesis",
      "King Finance": "King Finance",
      "Kla": "KLA",
      "Klant omgevingen": "Client Environments",
      "Klant systemen": "Client Systems",
      "Klantcommunicatie": "Customer Communication",
      "Klantcontact": "Customer Contact",
      "Klantenservice": "Customer Service",
      "Klantgericht": "Customer-Focused",
      "Klantgerichte instelling": "Customer-Oriented Attitude",
      "Klantgerichtheid": "Customer Focus",
      "Klantomgevingen": "Client Environments",
      "Klantrelaties": "Client Relationships",
      "klantvriendelijk": "Customer-Friendly",
      "Klip and imkl": "KLIP and IMKL",
      "Knowledge of Accounting, Procurement, or Supply Chain processes": "Knowledge of Accounting, Procurement, or Supply Chain processes",
      "Knowledge of azure": "Knowledge of Azure",
      "Knowledge of data- and software security": "Knowledge of Data and Software Security",
      "Knowledge of Dutch employment law": "Knowledge of Dutch employment law",
      "Knowledge of general architecting principles and software design patterns": "Knowledge of general architecting principles and software design patterns",
      "Knowledge of HR Social Security System": "Knowledge of HR Social Security System",
      "Knowledge of oo&uml": "Knowledge of OO & UML",
      "Knowledge of software testing": "Knowledge of software testing",
      "Knowledge of ticketing industry": "Knowledge of ticketing industry",
      "Knowledge of ultimo": "Knowledge of Ultimo",
      "Knowlegde of ci/cd": "Knowledge of ci/cd",
      "Kofax": "Kofax",
      "Koin": "Koin",
      "Korean": "Korean",
      "Kostencalculaties": "Cost Calculations",
      "Kotlin": "Kotlin",
      "Koude": "Cold",
      "Koude acquisitie": "Cold Calling",
      "KPI Tracking": "KPI Tracking",
      "Kuber": "Kuber",
      "Kubernetes": "Kubernetes",
      "Kunstmatige Intelligentie": "Artificial Intelligence",
      "L&d network": "L&D Network",
      "L&d/hr network": "L&D/HR Network",
      "Laboratory Management": "Laboratory Management",
      "Labourlaw": "Labor Law",
      "labview": "LabVIEW",
      "Lake Formation": "Lake Formation",
      "Laravel": "Laravel",
      "Latvian": "Latvian",
      "Layer 2 protocols (hsrp, vrrp)": "Layer 2 Protocols (HSRP, VRRP)",
      "Layer 3 protocol": "Layer 3 protocol",
      "Lead": "Lead",
      "Lead developer": "Lead developer",
      "Lead experience": "Lead experience",
      "Lead Generation": "Lead Generation",
      "Leadership": "Leadership",
      "Leadgeneratie": "Lead Generation",
      "Lean": "Lean",
      "Lean manufacturing": "Lean manufacturing",
      "Lean Six Sigma": "Lean Six Sigma",
      "Learning & Development": "Learning & Development",
      "Learning and Development Specialist": "Learning and Development Specialist",
      "Learning Management": "Learning Management",
      "Lease car budget": "Lease car budget",
      "Leergierig": "Eagerness to Learn",
      "Leergierigheid": "Eagerness to Learn",
      "Legal": "Legal",
      "Legal Data Analist": "Legal Data Analyst",
      "Legal Technology": "Legal Technology",
      "Legal_services": "Legal Services",
      "Leiderschap": "Leadership",
      "Leidinggeven": "Management",
      "Leidinggevende vaardigheden": "Management Skills",
      "Leisure": "Leisure",
      "LensorHardWareMechatronics": "Lens or Hardware Mechatronics",
      "Less HirePort platform fee": "Less HirePort platform fee",
      "Level 3 support": "Level 3 support",
      "Lichtreclame Kennis": "Illuminated Signage Knowledge",
      "Life sciences": "Life sciences",
      "LightYear - Engineering": "LightYear - Engineering",
      "LinkedIn Profile:": "LinkedIn Profile:",
      "LinkedIn Recruiter": "LinkedIn Recruiter",
      "Linkedin recruter": "LinkedIn Recruiter",
      "Linux": "Linux",
      "Linux Engineers": "Linux Engineers",
      "Linux OS": "Linux OS",
      "Linux/unix environment.": "Linux/Unix environment.",
      "Lithuanian": "Lithuanian",
      "Llm engineering": "LLM Engineering",
      "Load balancers": "Load balancers",
      "Loading…": "Loading…",
      "Localization": "Localization",
      "Location:": "Location:",
      "LogicGate": "LogicGate",
      "Logistics": "Logistics",
      "Logistiek ervaring": "Logistics Experience",
      "Logstash": "Logstash",
      "LOGZ.IO": "LOGZ.IO",
      "Lokaal Ondernemerschap": "Local Entrepreneurship",
      "Looker": "Looker",
      "Low-code Developers": "Low-code Developers",
      "Lt": "Lt",
      "LTSpice": "LTSpice",
      "Luchtvaarttechniek": "Aeronautical Engineering",
      "Lucidchart": "Lucidchart",
      "Machine directives": "Machine directives",
      "Machine Learning": "Machine Learning",
      "Machine Learning Engineers": "Machine Learning Engineers",
      "Machine Operation": "Machine Operation",
      "Machine Vision": "Machine Vision",
      "Machine vision systems": "Machine vision systems",
      "Machine-etikettering": "Machine Labeling",
      "MacOS": "MacOS",
      "Magazijnmedewerker": "Warehouse Worker",
      "Magento 2": "Magento 2",
      "Mainframe": "Mainframe",
      "Maintenance & reliability": "Maintenance & reliability",
      "Malware Analysis": "Malware Analysis",
      "Managed Services": "Managed Services",
      "Management ervaring": "Management Experience",
      "Management experience": "Management experience",
      "Management tools": "Management tools",
      "Manager": "Manager",
      "Manager title (or equivilant)": "Manager Title (or Equivalent)",
      "Manual Testing": "Manual Testing",
      "Manufacturing": "Manufacturing",
      "Manufacturing Engineer": "Manufacturing Engineer",
      "Manufacturing Engineering": "Manufacturing Engineering",
      "MariaDB databases": "MariaDB databases",
      "Market Research": "Market Research",
      "Market Research Analyst": "Market Research Analyst",
      "Marketing": "Marketing",
      "Marketing (main)": "Marketing (main)",
      "Marketing & Communication": "Marketing & Communication",
      "Marketing Analyst": "Marketing Analyst",
      "Marketing Coordinator": "Marketing Coordinator",
      "Marketing expertise": "Marketing expertise",
      "Marketing Manager": "Marketing Manager",
      "Marketing Support": "Marketing Support",
      "Marketo": "Marketo",
      "Markttrend Analyse": "Market Trend Analysis",
      "Master Civil Engineering": "Master Civil Engineering",
      "Master Computer Science (MSc)": "Master Computer Science (MSc)",
      "Master Data Management": "Master Data Management",
      "Master degree": "Master degree",
      "Master in Electrical Engineering": "Master in Electrical Engineering",
      "Master of Business Administration (MBA)": "Master of Business Administration (MBA)",
      "Master Systems and Control": "Master Systems and Control",
      "Master's Degree": "Master's Degree",
      "Materials Engineering": "Materials Engineering",
      "Matillion": "Matillion",
      "Matlab": "Matlab",
      "Maven": "Maven",
      "Max rate": "Max rate",
      "Max salary": "Max salary",
      "Max Salary (optional)": "Max Salary (optional)",
      "Maximum hours per week (optional)": "Maximum hours per week (optional)",
      "Mbo": "Vocational Education",
      "MBO Eerste Monteur Middenspanningsdistributie": "Vocational First Technician, Medium Voltage Distribution",
      "MBO Technicus": "Vocational Technician",
      "Mbo-4": "Vocational Level 4",
      "Mbo-4 education": "Vocational Level 4 Education",
      "Mbo-opleiding": "Vocational Education",
      "MBO4+": "MBO4+",
      "McAfee": "McAfee",
      "MD-100: Windows 10": "MD-100: Windows 10",
      "MD-101: Managing Modern Desktops": "MD-101: Managing Modern Desktops",
      "Measurement & control technology": "Measurement & control technology",
      "Mech": "Mechanical",
      "Mechanical Engineer": "Mechanical Engineer",
      "Mechanical Engineering": "Mechanical Engineering",
      "Mechanical Knowledge": "Mechanical Knowledge",
      "Mechanics": "Mechanics",
      "Mechatronica": "Mechatronics",
      "Mechatronics": "Mechatronics",
      "Media Planner": "Media Planner",
      "Media technical expertise": "Media technical expertise",
      "Medior": "Mid-level",
      "Meetinrichtingen": "Measuring Equipment",
      "Mendip": "Mendip",
      "Mendix": "Mendix",
      "Mentoring": "Mentoring",
      "Mentorship": "Mentorship",
      "Mergers and Acquisitions": "Mergers and Acquisitions",
      "Metaal": "Metal",
      "Metaalbewerking": "Metal Working",
      "Microcontrollers": "Microcontrollers",
      "Microservices": "Microservices",
      "Microservices Architecture": "Microservices Architecture",
      "Microsoft": "Microsoft",
      "Microsoft .NET": "Microsoft .NET",
      "Microsoft .NET C#": "Microsoft .NET C#",
      "Microsoft 365": "Microsoft 365",
      "Microsoft 365 Certified: Developer Associate": "Microsoft 365 Certified: Developer Associate",
      "Microsoft 365 Certified: Enterprise Administrator Expert": "Microsoft 365 Certified: Enterprise Administrator Expert",
      "Microsoft 365 Certified: Fundamentals": "Microsoft 365 Certified: Fundamentals",
      "Microsoft 365 Certified: Messaging Administrator Associate": "Microsoft 365 Certified: Messaging Administrator Associate",
      "Microsoft 365 Certified: Modern Desktop Administrator Associate": "Microsoft 365 Certified: Modern Desktop Administrator Associate",
      "Microsoft 365 Certified: Security Administrator Associate": "Microsoft 365 Certified: Security Administrator Associate",
      "Microsoft 365 Certified: Teams Administrator Associate": "Microsoft 365 Certified: Teams Administrator Associate",
      "Microsoft 365 Certified: Teamwork Administrator Associate": "Microsoft 365 Certified: Teamwork Administrator Associate",
      "Microsoft 365 Integration": "Microsoft 365 Integration",
      "Microsoft Azure": "Microsoft Azure",
      "Microsoft Azure Active Directory": "Microsoft Azure Active Directory",
      "Microsoft Azure IaaS": "Microsoft Azure IaaS",
      "Microsoft Certifications": "Microsoft Certifications",
      "Microsoft Certified Educator (MCE)": "Microsoft Certified Educator (MCE)",
      "Microsoft Certified Solutions Associate (MCSA)": "Microsoft Certified Solutions Associate (MCSA)",
      "Microsoft Certified Solutions Developer (MCSD)": "Microsoft Certified Solutions Developer (MCSD)",
      "Microsoft Certified Solutions Expert (MCSE)": "Microsoft Certified Solutions Expert (MCSE)",
      "Microsoft defender stack": "Microsoft Defender Stack",
      "Microsoft Dynamics": "Microsoft Dynamics",
      "Microsoft Dynamics Marketing": "Microsoft Dynamics Marketing",
      "Microsoft Excel": "Microsoft Excel",
      "Microsoft Exchange": "Microsoft Exchange",
      "Microsoft Office 365": "Microsoft Office 365",
      "Microsoft Office Specialist (MOS)": "Microsoft Office Specialist (MOS)",
      "Microsoft Power Apps": "Microsoft Power Apps",
      "Microsoft Power Automate": "Microsoft Power Automate",
      "Microsoft power bi": "Microsoft Power BI",
      "Microsoft Power BI Data Analyst (PL-300)": "Microsoft Power BI Data Analyst (PL-300)",
      "Microsoft PowerBI": "Microsoft PowerBI",
      "Microsoft Projects": "Microsoft Projects",
      "Microsoft SharePoint": "Microsoft SharePoint",
      "Microsoft Teams": "Microsoft Teams",
      "Microsoft Technology Associate (MTA)": "Microsoft Technology Associate (MTA)",
      "Middenspanningstechniek": "Medium Voltage Technology",
      "Middleware": "Middleware",
      "Middleware Engineers": "Middleware Engineers",
      "Milling": "Milling",
      "Minimum hours per week": "Minimum hours per week",
      "Minimum hours per week (optional)": "Minimum hours per week (optional)",
      "Miro Boards": "Miro Boards",
      "Mission Critical Engineer": "Mission Critical Engineer",
      "MLOps": "MLOps",
      "MMM D, H:mm": "MMM D, H:mm",
      "MMM D, y": "MMM D, y",
      "MMMM D, YYYY": "MMMM D, YYYY",
      "Mobile": "Mobile",
      "Mobile App Developer": "Mobile App Developer",
      "Mobile Developers": "Mobile Developers",
      "Mobile Development": "Mobile Development",
      "Mobile device management": "Mobile device management",
      "Mobility budget": "Mobility budget",
      "Mobility Solutions": "Mobility Solutions",
      "Model View-View Model (MVVM)": "Model View-View Model (MVVM)",
      "Modeling": "Modeling",
      "MongoDB": "MongoDB",
      "Monolith": "Monolith",
      "Monteur": "Technician",
      "Monteur Ervaring": "Technician Experience",
      "month": "month",
      "monthly": "monthly",
      "Monthly bonus": "Monthly bonus",
      "months": "months",
      "Moq": "Moq",
      "Motion Graphics": "Motion Graphics",
      "Motion/vision/recipe control": "Motion/vision/recipe control",
      "Mounting Methods": "Mounting Methods",
      "Move to the next stage": "Move to the next stage",
      "MS Excel": "MS Excel",
      "MS Intune": "MS Intune",
      "MS Office": "MS Office",
      "Ms project": "Ms project",
      "MS SCCM": "MS SCCM",
      "MS-100: Microsoft 365 Identity and Services": "MS-100: Microsoft 365 Identity and Services",
      "MS-101: Microsoft 365 Mobility and Security": "MS-101: Microsoft 365 Mobility and Security",
      "MS-203: Microsoft 365 Messaging": "MS-203: Microsoft 365 Messaging",
      "MS-300: Deploying Microsoft 365 Teamwork": "MS-300: Deploying Microsoft 365 Teamwork",
      "MS-301: Deploying SharePoint Server Hybrid": "MS-301: Deploying SharePoint Server Hybrid",
      "MS-500: Microsoft 365 Security Administration": "MS-500: Microsoft 365 Security Administration",
      "MS-600: Building Applications and Solutions with Microsoft 365 Core Services": "MS-600: Building Applications and Solutions with Microsoft 365 Core Services",
      "MS-700: Managing Microsoft Teams": "MS-700: Managing Microsoft Teams",
      "MS-900: Microsoft 365 Fundamentals": "MS-900: Microsoft 365 Fundamentals",
      "Msc": "Msc",
      "Mulesoft": "MuleSoft",
      "Multi dmu-verkoop van projecten": "Multi dmu-verkoop van projecten",
      "Multi-Disciplinary Project Experience": "Multi-Disciplinary Project Experience",
      "Multi-factor authenticator": "Multi-Factor Authenticator",
      "Multidisciplinaire samenwerking": "Multidisciplinary Collaboration",
      "Multidisciplinaire teams": "Multidisciplinary Teams",
      "Multidisciplinary Team Management": "Multidisciplinary Team Management",
      "Multiple contacts": "Multiple Contacts",
      "Multiple projectmanagen": "Multiple Project Management",
      "Municipal Networking": "Municipal Networking",
      "MVC/Razor Pages": "MVC/Razor Pages",
      "MySQL": "MySQL",
      "N/A": "N/A",
      "Name:": "Name:",
      "nanoFramework": "nanoFramework",
      "Native franstalig": "Native French Speaker",
      "Natural Language Processing": "Natural Language Processing",
      "Nauwkeurig": "Accurate",
      "Nauwkeurigheid": "Accuracy",
      "Navision": "Navision",
      "Ncpdp": "Ncpdp",
      "Nederlands": "Dutch",
      "Nederlandse taal": "Dutch Language",
      "Negociation": "Negotiation",
      "Negoti": "Negotiation",
      "Negotiation": "Negotiation",
      "Neo4j": "Neo4j",
      "Nest.JS": "Nest.JS",
      "Netscaler": "NetScaler",
      "Netsuite": "NetSuite",
      "Netwerken": "Networking",
      "Network": "Network",
      "Network Administrator": "Network Administrator",
      "Network architecture": "Network Architecture",
      "Network Engineering": "Network Engineering",
      "Network Engineers": "Network Engineers",
      "Network in defense": "Network in Defense",
      "Network in defense/security": "Network in Defense/Security",
      "Network in government": "Network in Government",
      "Network in municipality": "Network in Municipality",
      "Network in public transport": "Network in Public Transport",
      "Network in transport": "Network in Transport",
      "Network in transport/mainports": "Network in Transport/Mainports",
      "Network in utilities": "Network in Utilities",
      "Network Security": "Network Security",
      "Network Security Engineer": "Network Security Engineer",
      "Network solutions": "Network Solutions",
      "Networking": "Networking",
      "Networking knowledge": "Networking Knowledge",
      "Nevi": "Nevi",
      "New business development": "New Business Development",
      "New business models": "New Business Models",
      "New feedback is received": "Here's my feedback about the interview",
      "New feedback is required": "Please give feedback after the interview",
      "New Relic": "New Relic",
      "New skill": "New Skill",
      "New stage:": "New Stage:",
      "NextJS": "NextJS",
      "Nginx": "Nginx",
      "NHibernate": "NHibernate",
      "NOB-opleiding": "NOB Training",
      "NOC operator": "NOC Operator",
      "Node.js": "Node.js",
      "NodeJS": "NodeJS",
      "None": "None",
      "Nonprofit projects": " Nonprofit projects",
      "Norwegian": "Norwegian",
      "NoSQL": "NoSQL",
      "Notice period": "Notice Period",
      "Notion": "Notion",
      "Numerical skills": "Numerical Skills",
      "NUnit": "NUnit",
      "Nupas Cadmatic": "Nupas Cadmatic",
      "Nuxt": "Nuxt",
      "NVIDIA/CUDA": "NVIDIA/CUDA",
      "Object-Oriented Programming (OOP)": "Object-Oriented Programming (OOP)",
      "Objective-C": "Objective-C",
      "Observability": "Observability",
      "Octopus Deploy": "Octopus Deploy",
      "offered": "Offered",
      "Offertes schrijven": "Writing Proposals",
      "Office 365": "Office 365",
      "Office Suite": "Office Suite",
      "Office365": "Office365",
      "Office365 Engineers": "Office365 Engineers",
      "Omron": "Omron",
      "on hold": "On Hold",
      "On hold reason:": "On Hold Reason:",
      "Onderhandelen": "Negotiating",
      "Onderhandeling": "Negotiation",
      "Onderhandelingsvaardigheden": "Negotiation Skills",
      "Onderhoudsbeheersystemen": "Maintenance Management Systems",
      "Onderhoudswerkzaamheden": "Maintenance Activities",
      "Ondernemend": "Entrepreneurial",
      "Ondernemersschap": "Entrepreneurship",
      "Ondersteuning verwerkingen": "Processing Support",
      "Onedrive": "OneDrive",
      "Onestream": "OneStream",
      "Online Communities": "Online Communities",
      "Online Community Manager": "Online Community Manager",
      "Online Marketeer": "Online Marketer",
      "Online marketing": "Online Marketing",
      "Online omgevingen & apps": "Online Environments & Apps",
      "Online recruitment campaigns": "Online Recruitment Campaigns",
      "Ontwerp": "Design",
      "Oo": "Object-Oriented",
      "Oog voor Detail": "Attention to Detail",
      "Open mindset": "Open Mindset",
      "Open Source Software": "Open Source Software",
      "Openbare Verlichting": "Public Lighting",
      "OpenEdge": "OpenEdge",
      "OpenERP": "OpenERP",
      "OpenGL": "OpenGL",
      "OpenShift": "OpenShift",
      "Openstack": "OpenStack",
      "OpenTofu": "OpenTofu",
      "OpenVMS": "OpenVMS",
      "Operational Staff": "Operational Staff",
      "Operations": "Operations",
      "Operations Coordinator": "Operations Coordinator",
      "Operations Management": "Operations Management",
      "Operations Manager": "Operations Manager",
      "Oplossingsgericht": "Solution-Oriented",
      "Optimalisatie Platformen": "Platform Optimization",
      "Oracle": "Oracle",
      "Oracle 12": "Oracle 12",
      "Oracle Application Server": "Oracle Application Server",
      "Oracle Cloud": "Oracle Cloud",
      "Oracle Database": "Oracle Database",
      "Ords": "Ords",
      "Organisatie": "Organization",
      "Organisatietalent": "Organizational Talent",
      "Organisational talent": "Organizational Talent",
      "Organizational Skills": "Organizational Skills",
      "ORM tooling": "ORM Tooling",
      "OSCP (Offensive Security Certified Professional)": "OSCP (Offensive Security Certified Professional)",
      "Ospf": "Ospf",
      "Other": "Other",
      "Other Details": "Other Details",
      "Outside Sales": "Outside Sales",
      "OutSystems": "OutSystems",
      "Overall": "Overall",
      "Overheidsregelgeving": "Government Regulations",
      "PaaS": "PaaS",
      "Pair Programming": "Pair Programming",
      "Pandas": "Pandas",
      "Parkeerregelgeving": "Parking Regulations",
      "Passie voor energietransitie": "Passion for Energy Transition",
      "Patience": "Patience",
      "Patient Advocacy": "Patient Advocacy",
      "Payroll": "Payroll",
      "Pdl diploma": "Pdl diploma",
      "Ped/wbda": "Ped/wbda",
      "Pegasystems PRPC": "Pegasystems PRPC",
      "Penetration Testing": "Penetration Testing",
      "Pentest+": "PenTest+",
      "People m": "People Management",
      "People management": "People Management",
      "per": "per",
      "per hour": "per hour",
      "per year": "per year",
      "Percentage": "Percentage",
      "Performance management solution": "Performance Management Solution",
      "Performance Marketing Manager": "Performance Marketing Manager",
      "Perl": "Perl",
      "Perm annual bonus": "Permanent Annual Bonus",
      "Perm holiday allowance": "Permanent Holiday Allowance",
      "Perm holidays": "Permanent Holidays",
      "Perm monthly bonus": "Permanent Monthly Bonus",
      "Perm notice period": "Permanent Notice Period",
      "Perm salary": "Permanent Salary",
      "Perm salary max": "Permanent Salary Maximum",
      "permanent": "Permanent",
      "Permanent Employment": "Permanent Employment",
      "Permanent resident": "Permanent Resident",
      "Persistence": "Persistence",
      "Persuasive communication": "Persuasive Communication",
      "Pharmacy": "Pharmacy",
      "PhD": "PhD",
      "Photography": "Photography",
      "Photoshop": "Photoshop",
      "Pigment": "Pigment",
      "PIM/DAM-systems": "PIM/DAM Systems",
      "PL-100: Microsoft Power Platform App Maker": "PL-100: Microsoft Power Platform App Maker",
      "PL-200: Microsoft Power Platform Functional Consultant": "PL-200: Microsoft Power Platform Functional Consultant",
      "PL-400: Microsoft Power Platform Developer": "PL-400: Microsoft Power Platform Developer",
      "PL-600: Microsoft Power Platform Solution Architect": "PL-600: Microsoft Power Platform Solution Architect",
      "PL-900: Microsoft Power Platform Fundamentals": "PL-900: Microsoft Power Platform Fundamentals",
      "Pl/sql": "Pl/sql",
      "Plan interview": "Schedule Interview",
      "Planification D'Événements": "Event Planning",
      "Plannen": "Planning",
      "Plannen En Organiseren": "Planning and Organizing",
      "Planners": "Planners",
      "Planning": "Planning",
      "Planning Software": "Planning Software",
      "Planningssoftware": "Planning Software",
      "Planuitvoering": "Plan Execution",
      "Platform Engineering": "Platform Engineering",
      "PLC/SCADA systems": "PLC/SCADA Systems",
      "Please select an ATS job": "Please select an ATS job",
      "Polish": "Polish",
      "Portuguese": "Portuguese",
      "Position:": "Position:",
      "Positive": "Positive",
      "Post-Master Accountancy": "Post-Master Accountancy",
      "PostgreSQL": "PostgreSQL",
      "Postman": "Postman",
      "Postman API": "Postman API",
      "Power BI": "Power BI",
      "Power Electronics": "Power Electronics",
      "Power Platform": "Power Platform",
      "Power Quality": "Power Quality",
      "Power to execute": "Power to Execute",
      "PowerBI": "PowerBI",
      "PowerCenter": "PowerCenter",
      "Powerfuse": "PowerFuse",
      "Powerpoint": "PowerPoint",
      "PowerShell": "PowerShell",
      "PowerShell scripting": "PowerShell Scripting",
      "Poweshelll": "PowerShell",
      "Pragmatic": "Pragmatic",
      "Präsentation": "Presentation",
      "Predictive Maintenance": "Predictive Maintenance",
      "Presentation skills": "Presentation Skills",
      "Preventative Maintenance": "Preventative Maintenance",
      "Primary cell lines experience": "Primary Cell Lines Experience",
      "Primavera": "Primavera",
      "PRINCE II foundation": "PRINCE2 Foundation",
      "Prince2": "Prince2",
      "Prioriteiten stellen": "Setting Priorities",
      "Prioriteren en plannen": "Prioritizing and Planning",
      "Privacy": "Privacy",
      "Privacy Wetgeving": "Privacy Legislation",
      "Privacywetgeving": "Privacy Legislation",
      "Private Cloud": " Private Cloud",
      "Private Cloud Management": "Private Cloud Management",
      "Pro actief": "Proactive",
      "Proactief": "Proactive",
      "Proactive": "Proactive",
      "Proactive Approach": "Proactive Approach",
      "Proactive, innovative": "Proactive, Innovative",
      "Proactivity": "Proactivity",
      "Probleemanalyse": "Problem Analysis",
      "Probleemoplossend": "Problem-Solving",
      "Probleemoplossend Vermogen": "Problem-Solving Ability",
      "Probleemoplossing": "Problem-Solving",
      "Problem Solving": "Problem Solving",
      "Problem-Solving": "Problem-Solving",
      "Proces Engineering": "Process Engineering",
      "Proces focus": "Process Focus",
      "Procesmanagement": "Process Management",
      "Procesoptimalisatie": "Process Optimization",
      "Process calculations": "Process Calculations",
      "Process Improvement Specialist": "Process Improvement Specialist",
      "Process modeling & analysis": "Process Modeling & Analysis",
      "Process Optimization": "Process Optimization",
      "Processing text": "Processing Text",
      "Procurement": "Procurement",
      "Procurement Manager": "Procurement Manager",
      "Product Analytics Data": "Product Analytics Data",
      "Product data management (PDM)": "Product Data Management (PDM)",
      "Product Development": "Product Development",
      "Product Management": "Product Management",
      "Product Manager": "Product Manager",
      "Product Marketing": "Product Marketing",
      "Product Marketing Manager": "Product Marketing Manager",
      "Product Owner": "Product Owner",
      "Product owner ervaring": "Product Owner Experience",
      "Productiebeheer": "Production Management",
      "Productiekennis": "Production Knowledge",
      "Production": "Production",
      "Production environment": "Production Environment",
      "Production Planning": "Production Planning",
      "Productivity Management": "Productivity Management",
      "Productontwikkeling": "Product Development",
      "professional product owner 1 (PSPO 1)": "professional product owner 1 (PSPO 1)",
      "professional product owner 2 (PSPO 2)": "professional product owner 2 (PSPO 2)",
      "Profisee": "Profisee",
      "Program Management": "Program Management",
      "Programmatic": "Programmatic",
      "Programming": " Programming",
      "Project Controller": "Project Controller",
      "Project Controlling": "Project Controlling",
      "Project Coordinator": "Project Coordinator",
      "Project Financing": "Project Financing",
      "Project Management": "Project Management",
      "Project Manager": "Project Manager",
      "Projectbegeleiding": "Project Guidance",
      "Projectbeheer": "Project Management",
      "Projectbewaking": "Project Monitoring",
      "projectcoördinatie": "projectcoördinatie",
      "Projectleider": "Project Leader",
      "Projectmanagement": "Project Management",
      "Projektleitung": "Project Management",
      "Prometheus": "Prometheus",
      "Promoting process improvement": "Promoting Process Improvement",
      "Prompt engineering": "Prompt Engineering",
      "Property": "Property",
      "Proposal Manager": "Proposal Manager",
      "Proposal Writing": "Proposal Writing",
      "Prototyping": "Prototyping",
      "Protractor": "Protractor",
      "Public Cloud": "Public Cloud",
      "Public Relations": "Public Relations",
      "Public Relations Manager": "Public Relations Manager",
      "Pubquiz Talent": "Pub Quiz Talent",
      "Pulumi": "Pulumi",
      "Puppet": "Puppet",
      "Pur": "Pur",
      "Purchasing": "Purchasing",
      "Purview": "Purview",
      "PySpark": "PySpark",
      "Python": "Python",
      "Python 3.x": "Python 3.x",
      "Python or java or scala": "Python, Java, or Scala",
      "PyTorch": "PyTorch",
      "QA QC Manager": "QA QC Manager",
      "Qlik Sense": "Qlik Sense",
      "QlikView": "QlikView",
      "Qt": "Qt",
      "Quality": "Quality",
      "Quality Assurance": "Quality Assurance",
      "Quality Assurance (QA)": "Quality Assurance (QA)",
      "Quality Assurance Analyst": "Quality Assurance Analyst",
      "Quality Assurance Manager": "Quality Assurance Manager",
      "Quality Control": "Quality Control",
      "Quality Control Inspector": "Quality Control Inspector",
      "Quick Learning": "Quick Learning",
      "R (Programming language)": "R (Programming Language)",
      "R&D Collaboration": "R&D Collaboration",
      "RabbitMQ": "RabbitMQ",
      "Rag": "Rag",
      "Rail": "Rail",
      "Rapportage": "Reporting",
      "Rate": "Rate",
      "rating responses are anonymous": "rating responses are anonymous",
      "RCM Methodiek": "RCM Methodology",
      "React": "React",
      "React.js": "React.js",
      "Reactivate": "Reactivate",
      "Reactive Programming": "Reactive Programming",
      "Reading text input": "Reading Text Input",
      "Reading the job data": "Reading the Job Data",
      "Reason:": "Reason:",
      "Receptioniste": "Receptionist",
      "Recommended recruiters": "Recommended Recruiters",
      "Recruitee": "Recruitee",
      "Recruiter:": "Agency Recruiter:",
      "Recruitment": "Recruitment",
      "Recruitment Process": "Recruitment Process",
      "Recruitment Specialist": "Recruitment Specialist",
      "Recruitment_hr": "Recruitment_hr",
      "Red Hat": "Red Hat",
      "Red Teaming": "Red Teaming",
      "Redis": "Redis",
      "Redux": "Redux",
      "Regelgeving": "Regulations",
      "Regulations Compliance": "Regulations Compliance",
      "Regulatory Compliance": "Regulatory Compliance",
      "Regulatory frameworks in europe": "Regulatory Frameworks in Europe",
      "rejected": "Rejected",
      "Relatiebeheer": "Relationship Management",
      "Relationship builder": "Relationship Builder",
      "Relocate:": "Relocate:",
      "Remote": "Remote",
      "remote to AT": "remote to AT",
      "remote to BE": "remote to BE",
      "remote to CH": "remote to CH",
      "remote to CZ": "remote to CZ",
      "remote to DE": "remote to DE",
      "remote to DK": "remote to DK",
      "remote to ES": "remote to ES",
      "remote to FI": "remote to FI",
      "remote to FR": "remote to FR",
      "remote to IT": "remote to IT",
      "remote to NL": "remote to NL",
      "remote to NO": "remote to NO",
      "remote to PL": "remote to PL",
      "remote to PT": "remote to PT",
      "remote to SE": "remote to SE",
      "remote to UK": "remote to UK",
      "Remote:": "Remote:",
      "REMOVING…": "Removing…",
      "Renewable energy": "Renewable Energy",
      "Reporting & drawing up reports": "Reporting & Drawing Up Reports",
      "Representative": "Representative",
      "Research": "Research",
      "Researcher": "Researcher",
      "Resource Planning": "Resource Planning",
      "Resourcefulness": "Resourcefulness",
      "Rest": "Rest",
      "REST API's": "REST API's",
      "Restauratiearchitectuur": "Restoration Architecture",
      "RESTful APIs": "RESTful APIs",
      "RESTful services": "RESTful Services",
      "Result driven": "Result-Driven",
      "Resultaatgericht": "Result-Oriented",
      "Retail": "Retail",
      "Retail Management": "Retail Management",
      "Retr": "Recruitment",
      "Reverse Engineering": "Reverse Engineering",
      "Review Candidate:": "Review Candidate:",
      "Rfp’s": "RFPs",
      "Rhino": "Rhino",
      "Rijbewijs": "Driver's License",
      "Rijbewijs B": "Driver's License B",
      "Risico Analyse": "Risk Analysis",
      "Risk & Security Analyst": "Risk & Security Analyst",
      "Risk Assessment": "Risk Assessment",
      "Risk Management": "Risk Management",
      "Risk Manager": "Risk Manager",
      "Robot Framework": "Robot Framework",
      "Robotic Process Automation (RPA)": "Robotic Process Automation (RPA)",
      "Role": "Role",
      "Romanian": "Romanian",
      "Routeplanning": "Route Planning",
      "RPA Developers": "RPA Developers",
      "RSA Security": "RSA Security",
      "Ruby": "Ruby",
      "Ruby on Rails": "Ruby on Rails",
      "Rundeck": "Rundeck",
      "Russian": "Russian",
      "Rust": "Rust",
      "RxJS": "RxJS",
      "SaaS": "SaaS",
      "SaaS-ervaring": "SaaS Experience",
      "SAFe": "SAFe",
      "SAFe®": "SAFe®",
      "Sailpoint": "SailPoint",
      "Salary": "Salary",
      "Salary Administrator": "Salary Administrator",
      "Salary interval": "Salary Interval",
      "Salary:": "Salary:",
      "Sales": "Sales",
      "Sales (main)": "Sales (Main)",
      "Sales & consultancy": "Sales & Consulting",
      "Sales Administration": "Sales Administration",
      "Sales Associate": "Sales Associate",
      "Sales Engineering": "Sales Engineering",
      "Sales Executive": "Sales Executive",
      "Sales experience": "Sales Experience",
      "Sales ICT": "Sales ICT",
      "Sales Manager": "Sales Manager",
      "Sales Managers": "Sales Managers",
      "Sales Negotiation": "Sales Negotiation",
      "Sales Operations": "Sales Operations",
      "Sales Skills": "Sales Skills",
      "SalesIT": "SalesIT",
      "Sap": "Sap",
      "SAP Autorisatie": "SAP Authorization",
      "SAP BI": "SAP BI",
      "SAP CRM": "SAP CRM",
      "SAP S/4HANA": "SAP S/4HANA",
      "SAP S/4HANA Cloud Finance Consultant": "SAP S/4HANA Cloud Finance Consultant",
      "SAP Utilities": "SAP Utilities",
      "Sasdads": "Test Data",
      "SC 200": "SC-200",
      "SC Analytics": "SC Analytics",
      "Scala": "Scala",
      "Scaleup": "Scaleup",
      "Scheduling skills": "Scheduling Skills",
      "Schoonmaak": "Cleaning",
      "Schoonmaakervaring": "Cleaning Experience",
      "Schoonmaakvaardigheden": "Cleaning Skills",
      "Schoonmaakwerkzaamheden": "Cleaning Activities",
      "Schoonmaken": "Cleaning",
      "Schrijf- & seo-vaardigheden": "Schrijf- & seo-vaardigheden",
      "Scia": "Scia",
      "Scikit-learn": "Scikit-learn",
      "Scios": "Scios",
      "Scom": "Scom",
      "Scope bewaking": "Scope Monitoring",
      "Scraping": "Scraping",
      "Scraping data": "Data Scraping",
      "Scrapy": "Scrapy",
      "Scripting": "Scripting",
      "Scrum": "Scrum",
      "Scrum Master": "Scrum Master",
      "Scrum Master (PSM 1)": "Scrum Master (PSM 1)",
      "Scrum Master (PSM 2)": "Scrum Master (PSM 2)",
      "Scrum/Agile methodologies": "Scrum/Agile Methodologies",
      "Sd": "Sd",
      "Sdwan, mpls, ipsec, s2s, dmvpn": "Sdwan, mpls, ipsec, s2s, dmvpn",
      "Search Engine Advertising": "Search Engine Advertising",
      "secondment": "Secondment",
      "Secondment period (optional)": "Secondment Period (Optional)",
      "Security": "Security",
      "Security & Public Safety": "Security & Public Safety",
      "Security Applications": "Security Applications",
      "Security groups": "Security Groups",
      "Security Management": "Security Management",
      "Security Operations": "Security Operations",
      "Security Specialists": "Security Specialists",
      "Security Standaarden": "Security Standards",
      "Security Vulnerability Techniques": "Security Vulnerability Techniques",
      "Security+": "Security+",
      "Secuur werken": "Meticulous Work",
      "SEE Electrical": "SEE Electrical",
      "Select from your list of open ATS jobs below and we'll create you a new HirePort job to match!": "Select from your list of open ATS jobs below and we'll create you a new HirePort job to match!",
      "Select this checkbox if you want to select talent suppliers after job creation": "Select this checkbox if you want to select agencies after job creation",
      "Selenium": "Selenium",
      "Self-Management": "Self-Management",
      "Self-Motivation": "Self-Motivation",
      "Selligent": "Selligent",
      "Semantic search": "Semantic Search",
      "Send offer": "Send Offer",
      "Senior": "Senior",
      "Sentry": "Sentry",
      "SEO / SEM": "SEO / SEM",
      "SEO Content": "SEO Content",
      "SEO Specialist": "SEO Specialist",
      "SEO/SEA": "SEO/SEA",
      "Server Architecture": "Server Architecture",
      "Server management": "Server Management",
      "Serverless": "Serverless",
      "Serverless Architectures": "Serverless Architectures",
      "Service Engineers": "Service Engineers",
      "Service excellence": "Service Excellence",
      "Service management tools": "Service Management Tools",
      "Service Managers": "Service Managers",
      "Service Orientation": "Service Orientation",
      "Service-Oriented Architecture (SOA)": "Service-Oriented Architecture (SOA)",
      "Servicegericht": "Service-Oriented",
      "ServiceNow": "ServiceNow",
      "Setting Up Testing Frameworks": "Setting Up Testing Frameworks",
      "Sf": "Salesforce",
      "Shell Scripting": "Shell Scripting",
      "Shopify": "Shopify",
      "Sicherheitsstandards": "Security Standards",
      "Siem": "Siem",
      "Siemens (WinCC OA and Step 7)": "Siemens (WinCC OA and Step 7)",
      "Siemens NX": "Siemens NX",
      "SignalFx": "SignalFx",
      "Sikb 7800": "Sikb 7800",
      "Silverlight": "Silverlight",
      "Simplifai": "Simplifai",
      "Simulink": "Simulink",
      "Site management": "Site Management",
      "Site Reliability": "Site Reliability",
      "Site supervision": "Site Supervision",
      "Sitecore": "Sitecore",
      "Sjendnden": "Test Data",
      "Skill": "Skill",
      "Skype": "Skype",
      "Slack": "Slack",
      "Slim": "Slim",
      "Slovak": "Slovak",
      "Slovenian": "Slovenian",
      "Smart Contracts": "Smart Contracts",
      "Snowflake": "Snowflake",
      "Social Media": "Social Media",
      "Social Media Coordinator": "Social Media Coordinator",
      "Social Media Manager": "Social Media Manager",
      "Social Media Marketing": "Social Media Marketing",
      "Social skills": "Social Skills",
      "Social work": "Social Work",
      "Sociale Vaardigheden": "Social Skills",
      "Soft Skills": "Soft Skills",
      "Software": "Software",
      "Software Architect": "Software Architect",
      "Software Architecture": "Software Architecture",
      "Software Developer": "Software Developer",
      "Software Development": "Software Development",
      "Software Engineering Bachelor": "Software Engineering Bachelor",
      "Software Testing": "Software Testing",
      "Software-architecturen": "Software Architectures",
      "Softwareontwikkeling": "Software Development",
      "Solidity": "Solidity",
      "Solution Architecture": "Solution Architecture",
      "Solution Design": "Solution Design",
      "Solution Selling": "Solution Selling",
      "Solutions Architect": "Solutions Architect",
      "Sonarqube": "SonarQube",
      "Sophos": "Sophos",
      "sourced": "Sourced",
      "Sourcing": "Sourcing",
      "Sourcing skills": "Sourcing Skills",
      "Spanish": "Spanish",
      "Spark": "Spark",
      "Spark Structured Streaming": "Spark Structured Streaming",
      "Spatial Computing": "Spatial Computing",
      "Spatial Databases": "Spatial Databases",
      "Specflow gherkin": "SpecFlow Gherkin",
      "Speed": "Speed",
      "Splunk": "Splunk",
      "Spring": "Spring",
      "Spring Boot": "Spring Boot",
      "Spring Framework": "Spring Framework",
      "Spring microservice": "Spring Microservice",
      "SpringBoot": "Spring Boot",
      "Sql": "Sql",
      "SQL Server/SQL Azure": "SQL Server/SQL Azure",
      "Sscm": "Sscm",
      "SSCP (Systems Security Certified Practitioner)": "SSCP (Systems Security Certified Practitioner)",
      "Staffing": "Staffing",
      "Stakeholder Communication": "Stakeholder Communication",
      "Stakeholder Engagement": "Stakeholder Engagement",
      "Stakeholder Management": "Stakeholder Management",
      "Starlette": "Starlette",
      "Start Date (optional)": "Start Date (optional)",
      "Start-up or smaller teams experience": "Start-up or Smaller Teams Experience",
      "Startup Operations": "Startup Operations",
      "Statamic": "Statamic",
      "Statistical analysis": "Statistical Analysis",
      "Statistics": "Statistics",
      "Statistiek": "Statistics",
      "Sterk in woord en geschrift": "Strong Written and Verbal Communication Skills",
      "Stibo Step": "Stibo Step",
      "Stibo systems": "Stibo Systems",
      "Storage": "Storage",
      "Store Operations": "Store Operations",
      "Storingen oplossen": "Troubleshooting",
      "Strapi": "Strapi",
      "Strategic": "Strategic",
      "Strategic and operational safety expertise": "Strategic and Operational Safety Expertise",
      "Strategic Business Development": "Strategic Business Development",
      "Strategic Market Analysis": "Strategic Market Analysis",
      "Strategic Planning": "Strategic Planning",
      "Strategic Relationship Management": "Strategic Relationship Management",
      "Strategic Thinking": "Strategic Thinking",
      "Strategic Transport Planning": "Strategic Transport Planning",
      "Strategisch Denken": "Strategic Thinking",
      "Strategisch plannen": "Strategic Planning",
      "Strategische en tactische marketing": "Strategic and Tactical Marketing",
      "Strategische Planning": "Strategic Planning",
      "Strategy": "Strategy",
      "Strategy/planning": "Strategy/Planning",
      "Stress testing": "Stress Testing",
      "Stressbestendig": "Stress-Resistant",
      "Stressbestendigheid": "Stress Resilience",
      "Stressmanagement": "Stress Management",
      "Strong communication skills": "Strong Communication Skills",
      "Strong leadership": "Strong Leadership",
      "Strong understanding of it": "Strong understanding of it",
      "Strongly-typed languages": "Strongly Typed Languages",
      "Structural Engineer": "Structural Engineer",
      "Structuring purchasing processes": "Structuring Purchasing Processes",
      "Sturen op kpi's": "Sturen op kpi's",
      "Subsidies (optional)": "Subsidies (optional)",
      "Supervision": "Supervision",
      "Supervisor": "Supervisor",
      "Supplier Job Stages": "Agency Job Stages",
      "Supplier management": "Agency Management",
      "Supply Chain": "Supply Chain",
      "Supply Chain Analyst": "Supply Chain Analyst",
      "Supply Chain Management": "Supply Chain Management",
      "Supply Chain Manager": "Supply Chain Manager",
      "Support": "Support",
      "Support Engineers": "Support Engineers",
      "Support experience": "Support Experience",
      "Suse": "Suse",
      "Sustainability": "Sustainability",
      "Sustainability Initiative Implementation": "Sustainability Initiative Implementation",
      "Sustainability Project Management": "Sustainability Project Management",
      "Sustainable Solutions": "Sustainable Solutions",
      "Sustainable Transport": "Sustainable Transport",
      "Swagger": "Swagger",
      "Swedish": "Swedish",
      "Swift": "Swift",
      "Swift (Programming Language)": "Swift (Programming Language)",
      "SWIFT payments": "SWIFT Payments",
      "Swift ui": "SwiftUI",
      "Swift/ ios development": "Swift/iOS Development",
      "Sybase": "Sybase",
      "Symfony Framework": "Symfony Framework",
      "Syntess Atrium": "Syntess Atrium",
      "Systeemintegraties": "System Integrations",
      "System": "System",
      "System Adaptation": "System Adaptation",
      "System Administrator": "System Administrator",
      "System Architecture": "System Architecture",
      "System assembly": "System Assembly",
      "System Design": "System Design",
      "System Engineering": "System Engineering",
      "System Engineers": "System Engineers",
      "System Integration": "System Integration",
      "Systems Analyst": "Systems Analyst",
      "Systems Engineering": "Systems Engineering",
      "Tableau": "Tableau",
      "Tagetik": "Tagetik",
      "Tailwind CSS": "Tailwind CSS",
      "Taking initiative": "Taking Initiative",
      "Talent Acquisition": "Talent Acquisition",
      "Talent Acquisition Specialist": "Talent Acquisition Specialist",
      "Talent Management": "Talent Management",
      "Talent Manager": "Talent Manager",
      "Task": "Task",
      "Tax": "Tax",
      "Tax Knowledge": "Tax Knowledge",
      "Team aansturing": "Team Leadership",
      "Team Building": "Team Building",
      "Team Coaching": "Team Coaching",
      "Team Formation": "Team Formation",
      "Team Foundation Server (TFS)": "Team Foundation Server (TFS)",
      "Team Lead": "Team Lead",
      "Team Leadership": "Team Leadership",
      "Team leiderschap": "Team Leadership",
      "Team Player": "Team Player",
      "Team samenwerking": "Team Collaboration",
      "TeamCity": "TeamCity",
      "Teamleadership": "Team Leadership",
      "Teamplayer": "Team Player",
      "Teams": "Teams",
      "Teamspeler": "Team Player",
      "Teamwerk": "Teamwork",
      "Teamwork": "Teamwork",
      "Technical": "Technical",
      "Technical Application Manager": "Technical Application Manager",
      "Technical background": "Technical Background",
      "Technical Knowledge in Retrofit and Decarbonisation": "Technical Knowledge in Retrofit and Decarbonisation",
      "Technical Maintenance": "Technical Maintenance",
      "Technical Operation": "Technical Operation",
      "Technical Problem Solving": "Technical Problem Solving",
      "Technical Problem-Solving": "Technical Problem-Solving",
      "Technical product owner": "Technical Product Owner",
      "Technical Project Manager": "Technical Project Manager",
      "Technical Reporting": "Technical Reporting",
      "Technical Reviews": "Technical Reviews",
      "Technical Sales": "Technical Sales",
      "Technical Support": "Technical Support",
      "Technical Support Specialist": "Technical Support Specialist",
      "Technical Troubleshooting": "Technical Troubleshooting",
      "Technical Writer": "Technical Writer",
      "Technical Writing": "Technical Writing",
      "Techniek": "Engineering",
      "Techniek/telecom": "Engineering/Telecom",
      "Technisch Calculeren": "Technical Estimation",
      "Technisch Inzicht": "Technical Insight",
      "Technisch onderlegd": "Technically Skilled",
      "Technisch probleemoplossend": "Technical Problem-Solving",
      "Technisch support": "Technical Support",
      "Technische Bedrijfskunde": "Technical Business Administration",
      "Technische Inzicht": "Technical Insight",
      "Technische kennis": "Technical Knowledge",
      "Technische ondersteuning": "Technical Support",
      "Technische probleemoplossing": "Technical Problem-Solving",
      "Technische Processen": "Technical Processes",
      "Technische vaardigheden": "Technical Skills",
      "Technische Voorbereiding": "Technical Preparation",
      "Technological Innovation": "Technological Innovation",
      "Technology Knowledge": "Technology Knowledge",
      "Telecom": "Telecom",
      "Telecom Engineer": "Telecom Engineer",
      "Telecommunication": "Telecommunication",
      "Telecommunications": "Telecommunications",
      "Telecomnetwerken": "Telecom Networks",
      "Telecoms Engineer": "Telecoms Engineer",
      "Telephony": "Telephony",
      "temporary": "Temporary",
      "Tender Management": "Tender Management",
      "Tender Schrijven": "Tender Writing",
      "Tender Submission": "Tender Submission",
      "Tendermanagement": "Tender Management",
      "TensorFlow": "TensorFlow",
      "Teraforms": "Terraform",
      "TerraForm": "Terraform",
      "Test": "Test",
      "Test Automation": "Test Automation",
      "Test Driven Development": "Test Driven Development",
      "Test Driven Development (TDD)": "Test Driven Development (TDD)",
      "Test-driven development": "Test-Driven Development",
      "test123": "test123",
      "test12345": "test12345",
      "Testautomatisering": "Test Automation",
      "TestCafe": "TestCafe",
      "Testers/QA Engineers": "Testers/QA Engineers",
      "Testing": "Testing",
      "Testing/QA": "Testing/QA",
      "TestLevi0": "TestLevi0",
      "Thank you for your rating": "Thank you for your rating",
      "The candidate has been moved to Hired stage, please check your environment.": "\nThe candidate has been moved to Hired stage, please check your environment.\n",
      "The HirePort Team": "The HirePort Team",
      "This might take a few minutes, so please be patient and don't navigate away from this page.": "This might take a few minutes, so please be patient and don't navigate away from this page.",
      "Thoughtspot": "ThoughtSpot",
      "Tibco": "Tibco",
      "TIBCO BPM": "TIBCO BPM",
      "Tibco EBX": "TIBCO EBX",
      "Tijdlijnmanagement": "Timeline Management",
      "Time Management": "Time Management",
      "Tivoli Identity Manager": "Tivoli Identity Manager",
      "TMap (Next)": "TMap (Next)",
      "TMap NEXT": "TMap NEXT",
      "to be confirmed": "to be confirmed",
      "Togaf": "Togaf",
      "Tomcat": "Tomcat",
      "Tools": "Tools",
      "Topdesk": "Topdesk",
      "Topdesk is a plus": "Topdesk is a plus",
      "Tourism": "Tourism",
      "Training": "Training",
      "Training & Development": "Training & Development",
      "Translation Management": "Translation Management",
      "Travel Allowance (optional)": "Travel Allowance (optional)",
      "Treasury": "Treasury",
      "Trend micro": "Trend Micro",
      "Troubleshooting": "Troubleshooting",
      "Trunk-based development": "Trunk-Based Development",
      "Trustworthy": "Trustworthy",
      "TS.ED": "TS.ED",
      "Turkish": "Turkish",
      "Twinfield": "Twinfield",
      "Typ": "Type",
      "Type": "Type",
      "Types of Methodology": "Types of Methodology",
      "Types of Modeling Principles": "Types of Modeling Principles",
      "TypeScript": "TypeScript",
      "Typo3": "Typo3",
      "UAV and UAV-GC": "UAV and UAV-GC",
      "Ubuntu": "Ubuntu",
      "UI Designers": "UI Designers",
      "UI/UX Design": "UI/UX Design",
      "UI/UX Designers": "UI/UX Designers",
      "UI/UX Developer": "UI/UX Developer",
      "UiPath": "UiPath",
      "Uitvoerder": "Site Manager",
      "Ukrainian": "Ukrainian",
      "Ultimo": "Ultimo",
      "Umbraco": "Umbraco",
      "Uml": "Uml",
      "Unit Testing": "Unit Testing",
      "Unity": "Unity",
      "Unix": "Unix",
      "Unix administration": " Unix administration",
      "Unknown Location": "Unknown Location",
      "Unpublished reason:": "Unpublished Reason:",
      "Unreal Engine 4": "Unreal Engine 4",
      "Update:": "Update:",
      "Upload document": "Upload Document",
      "Us": "Us",
      "User Engagement": "User Engagement",
      "User Experience (UX)": "User Experience (UX)",
      "User Experience Design": "User Experience Design",
      "User Experience Researcher": "User Experience Researcher",
      "User Interface (UI)": "User Interface (UI)",
      "User was successfully added to your company": "User was successfully added to your company",
      "Users and device management": "User and Device Management",
      "UX Designers": "UX Designers",
      "UX Research": "UX Research",
      "UX/UI Design": "UX/UI Design",
      "VanAmeydeTier1": "VanAmeydeTier1",
      "Vastgoedmanagement": "Real Estate Management",
      "Vastgoedrecht": "Real Estate Law",
      "Vault": "Vault",
      "VBScript": "VBScript",
      "Vca": "Vca",
      "VCA VOL": "VCA VOL",
      "Vca vol-certificaat": "Vca vol-certificaat",
      "Vca, ehbo en/of bhv": "Vca, ehbo en/of bhv",
      "vCloud": "vCloud",
      "Vector databases": "Vector Databases",
      "Vehicle Battery Pack Systems": "Vehicle Battery Pack Systems",
      "Veilig werken langs de weg": "Safe Working Alongside Traffic",
      "Veiligheid": "Safety",
      "Veiligheidsbewust": "Safety-Conscious",
      "Veiligheidsmanagement": "Safety Management",
      "Vena": "Vena",
      "Veracode": "Veracode",
      "Verantwoordelijk": "Responsible",
      "Verbindend": "Connecting",
      "Verkoop & Leveranciersrelaties": "Sales & Supplier Relationships",
      "Verkoop via tussenpersonen": "Sales Through Intermediaries",
      "Verpleegkundig certificaat": "Nursing Certificate",
      "Vertieftes microsoft wissen": "In-Depth Microsoft Knowledge",
      "Verzekeringsbeheer": "Insurance Management",
      "VICnet": "VICnet",
      "Video Editing": "Video Editing",
      "Video Editor": "Video Editor",
      "Video Game Designer": "Video Game Designer",
      "Video Production": "Video Production",
      "View": "View",
      "View Resume:": "View Resume:",
      "View: Supplier Job": "View: Agency Job",
      "Vis": "Visualization",
      "Visa:": "Visa:",
      "Visit HirePort:": "Visit HirePort:",
      "Visma": "Visma",
      "Visual Studio": "Visual Studio",
      "Visualizing Solutions": "Visualizing Solutions",
      "Visuele inspectie": "Visual Inspection",
      "Vite": "Vite",
      "VMware": "VMware",
      "Vocational College": "Vocational College",
      "Vog": "Certificate of Good Conduct",
      "Voice over IP (VoIP)": "Voice over IP (VoIP)",
      "Vpc": "Vpc",
      "Vps": "Vps",
      "Vue 3": "Vue 3",
      "Vue.js": "Vue.js",
      "Vue.js and react": "Vue.js and React",
      "Vue/Vuex": "Vue/Vuex",
      "VueJS": "VueJS",
      "VWE-ProductOwner": "VWE-ProductOwner",
      "Wan": "Wan",
      "Warm": "Warm",
      "Warmte opwekkingsinstallaties": "Heat Generation Installations",
      "Warmtenetten": "Warmtenetten",
      "Warmtepompen": "Warmtepompen",
      "Was the 1st interview in line with the job description?": "Was the 1st interview in line with the job description?",
      "Watchguard": "Watchguard",
      "Waterfall model": "Waterfall model",
      "Waterpompen": "Waterpompen",
      "Wcf": "Wcf",
      "WCF Services": "WCF Services",
      "We'll let you know if this position becomes available again. In the meantime, please check out other open positions in HirePort.": "We'll let you know if this position becomes available again. In the meantime, please check out other open positions in HirePort.",
      "We're sorry to inform you that a job you had saved to your favorites has been put on hold:": "We're sorry to inform you that a job you had saved to your favorites has been put on hold:",
      "We're sorry to inform you that a job you had saved to your favorites has been unpublished:": "We're sorry to inform you that a job you had saved to your favorites has been unpublished:",
      "We've started working on your job import.": "We've started working on your job import.",
      "Web and Email protocols": "Web and Email protocols",
      "Web Designer": "Web Designer",
      "Web development": " Web development",
      "Web Navigation": "Web Navigation",
      "Web technologies & methodologies": "Web technologies & methodologies",
      "WebAPI": "WebAPI",
      "Weblogic": "Weblogic",
      "Webpack": "Webpack",
      "Webservices": "Webservices",
      "Webshop management": "Webshop management",
      "Webshopbeheer": "Webshopbeheer",
      "Websphere": "Websphere",
      "weekly": "weekly",
      "Wegenbouw": "Wegenbouw",
      "Were the candidate's skills within expectations?": "Were the candidate's skills within expectations?",
      "Werken met machines": "Werken met machines",
      "Werktuigbouw": "Werktuigbouw",
      "Werktuigbouwkunde": "Werktuigbouwkunde",
      "Werkvoorbereider": "Werkvoorbereider",
      "Werkvoorbereiding": "Werkvoorbereiding",
      "WFT Basis": "WFT Basis",
      "Wft basisdiploma": "Wft basisdiploma",
      "Wft diploma's": "Wft diploma's",
      "Wft hypothecair krediet": "Wft hypothecair krediet",
      "WFT Schade Particulier": "WFT Schade Particulier",
      "WFT Schade Zakelijk": "WFT Schade Zakelijk",
      "What We Like:": "What We Like:",
      "When the import process is finished, you'll be able to review your job.": "When the import process is finished, you'll be able to review your job.",
      "Where:": "Where:",
      "Wide Area Network (WAN)": "Wide Area Network (WAN)",
      "WiFi": "WiFi",
      "Win32": "Win32",
      "Windows": "Windows",
      "Windows 10": "Windows 10",
      "Windows 11": "Windows 11",
      "Windows Engineers": "Windows Engineers",
      "Windows Server": "Windows Server",
      "Winforms": "Winforms",
      "Wireframing": "Wireframing",
      "Wireless Networking": "Wireless Networking",
      "Wko": "Wko",
      "Wko-systemen": "Wko-systemen",
      "Word": "Word",
      "Wordpress": "Wordpress",
      "Work exp. in education, publishing or (Ed)Tech/SaaS companies": "Work exp. in education, publishing or (Ed)Tech/SaaS companies",
      "Work experience": "Work experience",
      "Work permit": "Work permit",
      "Work Planner": "Work Planner",
      "Workday": "Workday",
      "Workforce management software": "Workforce management software",
      "Working experience as Register Accountant": "Working experience as Register Accountant",
      "Workstation management": "Workstation management",
      "Wsus": "Wsus",
      "Xamarin": "Xamarin",
      "Xdr": "Xdr",
      "Xml-based ui": "Xml-based ui",
      "yearly": "yearly",
      "Yes": "Yes",
      "You have an ATS connected, but we couldn't find any open positions which had a publicly accessible job page.": "You have an ATS connected, but we couldn't find any open positions which had a publicly accessible job page.",
      "You haven't connected HirePort to your ATS yet.": "You haven't connected HirePort to your ATS yet.",
      "You need to be part of a company to invite users": "You need to be part of a company to invite users",
      "Your candidate has been moved to the next stage": "Your candidate has been moved to the next stage",
      "Zachman": "Zachman",
      "Zelfstandig werken": "Zelfstandig werken",
      "Zelfstandigheid": "Zelfstandigheid",
      "Zelle": "Zelle",
      "Zend Framework": "Zend Framework",
      "Zero Trust": " Zero Trust",
      "Zinkunie-Private-Suppliers": "Zinkunie-Private-Suppliers",
      "团队领导": "Team Leadership",
      "培训与发展": "Training & Development",
      "招聘管理": "Recruitment Management",
      "猎头招聘": "Executive Search"
    }
  }
}
